var Hs = Object.defineProperty, Gs = Object.defineProperties;
var $s = Object.getOwnPropertyDescriptors;
var be = Object.getOwnPropertySymbols, js = Object.getPrototypeOf, si = Object.prototype.hasOwnProperty, ui = Object.prototype.propertyIsEnumerable, Vs = Reflect.get;
var fr = (e, t, r) => t in e ? Hs(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r, S = (e, t) => {
  for (var r in t || (t = {}))
    si.call(t, r) && fr(e, r, t[r]);
  if (be)
    for (var r of be(t))
      ui.call(t, r) && fr(e, r, t[r]);
  return e;
}, N = (e, t) => Gs(e, $s(t));
var lr = (e, t) => {
  var r = {};
  for (var n in e)
    si.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && be)
    for (var n of be(e))
      t.indexOf(n) < 0 && ui.call(e, n) && (r[n] = e[n]);
  return r;
};
var R = (e, t, r) => fr(e, typeof t != "symbol" ? t + "" : t, r);
var dr = (e, t, r) => Vs(js(e), r, t);
var D = (e, t, r) => new Promise((n, i) => {
  var o = (c) => {
    try {
      u(r.next(c));
    } catch (s) {
      i(s);
    }
  }, a = (c) => {
    try {
      u(r.throw(c));
    } catch (s) {
      i(s);
    }
  }, u = (c) => c.done ? n(c.value) : Promise.resolve(c.value).then(o, a);
  u((r = r.apply(e, t)).next());
});
import { T as Go, U as Fs, W as on, X as Xs, s as Ut, Y as ot, Z as $o, _ as jo, $ as Vo, a0 as Fo, w as zs, a1 as qs, a2 as Ws, a3 as Ys, a4 as Ks, a5 as Js, a6 as Xo, a7 as se, q as Zs, a8 as pr, a9 as hr, aa as Qs, c as tu, n as eu, o as ru, L as nu, h as iu, t as ou, ab as au, D as su, ac as uu, I as ci, E as _r, ad as cu, ae as fu, J as lu, K as du, N as pu, O as hu, Q as _u, R as vu, af as gu, ag as Eu, ah as fi, ai as yu, aj as mu, ak as Tu } from "./common-Cpxpot06.js";
import { a as Su, i as zo } from "./buffer-DIFxvF2Q.js";
import { LDObserve as Ou } from "./LDObserve.js";
const qo = [
  "assert",
  "count",
  "countReset",
  "debug",
  "dir",
  "dirxml",
  "error",
  "group",
  "groupCollapsed",
  "groupEnd",
  "info",
  "log",
  "table",
  "time",
  "timeEnd",
  "timeLog",
  "trace",
  "warn"
];
var dt = /* @__PURE__ */ ((e) => (e.DeviceMemory = "DeviceMemory", e.ViewportHeight = "ViewportHeight", e.ViewportWidth = "ViewportWidth", e.ScreenHeight = "ScreenHeight", e.ScreenWidth = "ScreenWidth", e.ViewportArea = "ViewportArea", e))(dt || {}), F = /* @__PURE__ */ ((e) => (e.Device = "Device", e.WebVital = "WebVital", e.Performance = "Performance", e.Frontend = "Frontend", e.Backend = "Backend", e))(F || {}), Wo = { exports: {} }, vr = { exports: {} }, li;
function Au() {
  return li || (li = 1, function(e, t) {
    (function(r, n) {
      e.exports = n();
    })(Go, function() {
      function r(p) {
        return !isNaN(parseFloat(p)) && isFinite(p);
      }
      function n(p) {
        return p.charAt(0).toUpperCase() + p.substring(1);
      }
      function i(p) {
        return function() {
          return this[p];
        };
      }
      var o = ["isConstructor", "isEval", "isNative", "isToplevel"], a = ["columnNumber", "lineNumber"], u = ["fileName", "functionName", "source"], c = ["args"], s = ["evalOrigin"], f = o.concat(a, u, c, s);
      function l(p) {
        if (p)
          for (var g = 0; g < f.length; g++)
            p[f[g]] !== void 0 && this["set" + n(f[g])](p[f[g]]);
      }
      l.prototype = {
        getArgs: function() {
          return this.args;
        },
        setArgs: function(p) {
          if (Object.prototype.toString.call(p) !== "[object Array]")
            throw new TypeError("Args must be an Array");
          this.args = p;
        },
        getEvalOrigin: function() {
          return this.evalOrigin;
        },
        setEvalOrigin: function(p) {
          if (p instanceof l)
            this.evalOrigin = p;
          else if (p instanceof Object)
            this.evalOrigin = new l(p);
          else
            throw new TypeError("Eval Origin must be an Object or StackFrame");
        },
        toString: function() {
          var p = this.getFileName() || "", g = this.getLineNumber() || "", E = this.getColumnNumber() || "", y = this.getFunctionName() || "";
          return this.getIsEval() ? p ? "[eval] (" + p + ":" + g + ":" + E + ")" : "[eval]:" + g + ":" + E : y ? y + " (" + p + ":" + g + ":" + E + ")" : p + ":" + g + ":" + E;
        }
      }, l.fromString = function(g) {
        var E = g.indexOf("("), y = g.lastIndexOf(")"), A = g.substring(0, E), L = g.substring(E + 1, y).split(","), P = g.substring(y + 1);
        if (P.indexOf("@") === 0)
          var C = /@(.+?)(?::(\d+))?(?::(\d+))?$/.exec(P, ""), Lt = C[1], Xt = C[2], Pt = C[3];
        return new l({
          functionName: A,
          args: L || void 0,
          fileName: Lt,
          lineNumber: Xt || void 0,
          columnNumber: Pt || void 0
        });
      };
      for (var d = 0; d < o.length; d++)
        l.prototype["get" + n(o[d])] = i(o[d]), l.prototype["set" + n(o[d])] = /* @__PURE__ */ function(p) {
          return function(g) {
            this[p] = !!g;
          };
        }(o[d]);
      for (var h = 0; h < a.length; h++)
        l.prototype["get" + n(a[h])] = i(a[h]), l.prototype["set" + n(a[h])] = /* @__PURE__ */ function(p) {
          return function(g) {
            if (!r(g))
              throw new TypeError(p + " must be a Number");
            this[p] = Number(g);
          };
        }(a[h]);
      for (var _ = 0; _ < u.length; _++)
        l.prototype["get" + n(u[_])] = i(u[_]), l.prototype["set" + n(u[_])] = /* @__PURE__ */ function(p) {
          return function(g) {
            this[p] = String(g);
          };
        }(u[_]);
      return l;
    });
  }(vr)), vr.exports;
}
(function(e, t) {
  (function(r, n) {
    e.exports = n(Au());
  })(Go, function(n) {
    var i = /(^|@)\S+:\d+/, o = /^\s*at .*(\S+:\d+|\(native\))/m, a = /^(eval@)?(\[native code])?$/;
    return {
      /**
       * Given an Error object, extract the most information from it.
       *
       * @param {Error} error object
       * @return {Array} of StackFrames
       */
      parse: function(c) {
        if (typeof c.stacktrace != "undefined" || typeof c["opera#sourceloc"] != "undefined")
          return this.parseOpera(c);
        if (c.stack && c.stack.match(o))
          return this.parseV8OrIE(c);
        if (c.stack)
          return this.parseFFOrSafari(c);
        throw new Error("Cannot parse given Error object");
      },
      // Separate line and column numbers from a string of the form: (URI:Line:Column)
      extractLocation: function(c) {
        if (c.indexOf(":") === -1)
          return [c];
        var s = /(.+?)(?::(\d+))?(?::(\d+))?$/, f = s.exec(c.replace(/[()]/g, ""));
        return [f[1], f[2] || void 0, f[3] || void 0];
      },
      parseV8OrIE: function(c) {
        var s = c.stack.split(`
`).filter(function(f) {
          return !!f.match(o);
        }, this);
        return s.map(function(f) {
          f.indexOf("(eval ") > -1 && (f = f.replace(/eval code/g, "eval").replace(/(\(eval at [^()]*)|(\),.*$)/g, ""));
          var l = f.replace(/^\s+/, "").replace(/\(eval code/g, "("), d = l.match(/ (\((.+):(\d+):(\d+)\)$)/);
          l = d ? l.replace(d[0], "") : l;
          var h = l.split(/\s+/).slice(1), _ = this.extractLocation(d ? d[1] : h.pop()), p = h.join(" ") || void 0, g = ["eval", "<anonymous>"].indexOf(_[0]) > -1 ? void 0 : _[0];
          return new n({
            functionName: p,
            fileName: g,
            lineNumber: _[1],
            columnNumber: _[2],
            source: f
          });
        }, this);
      },
      parseFFOrSafari: function(c) {
        var s = c.stack.split(`
`).filter(function(f) {
          return !f.match(a);
        }, this);
        return s.map(function(f) {
          if (f.indexOf(" > eval") > -1 && (f = f.replace(/ line (\d+)(?: > eval line \d+)* > eval:\d+:\d+/g, ":$1")), f.indexOf("@") === -1 && f.indexOf(":") === -1)
            return new n({
              functionName: f
            });
          var l = /((.*".+"[^@]*)?[^@]*)(?:@)/, d = f.match(l), h = d && d[1] ? d[1] : void 0, _ = this.extractLocation(f.replace(l, ""));
          return new n({
            functionName: h,
            fileName: _[0],
            lineNumber: _[1],
            columnNumber: _[2],
            source: f
          });
        }, this);
      },
      parseOpera: function(c) {
        return !c.stacktrace || c.message.indexOf(`
`) > -1 && c.message.split(`
`).length > c.stacktrace.split(`
`).length ? this.parseOpera9(c) : c.stack ? this.parseOpera11(c) : this.parseOpera10(c);
      },
      parseOpera9: function(c) {
        for (var s = /Line (\d+).*script (?:in )?(\S+)/i, f = c.message.split(`
`), l = [], d = 2, h = f.length; d < h; d += 2) {
          var _ = s.exec(f[d]);
          _ && l.push(new n({
            fileName: _[2],
            lineNumber: _[1],
            source: f[d]
          }));
        }
        return l;
      },
      parseOpera10: function(c) {
        for (var s = /Line (\d+).*script (?:in )?(\S+)(?:: In function (\S+))?$/i, f = c.stacktrace.split(`
`), l = [], d = 0, h = f.length; d < h; d += 2) {
          var _ = s.exec(f[d]);
          _ && l.push(
            new n({
              functionName: _[3] || void 0,
              fileName: _[2],
              lineNumber: _[1],
              source: f[d]
            })
          );
        }
        return l;
      },
      // Opera 10.65+ Error.stack very similar to FF/Safari
      parseOpera11: function(c) {
        var s = c.stack.split(`
`).filter(function(f) {
          return !!f.match(i) && !f.match(/^Error created at/);
        }, this);
        return s.map(function(f) {
          var l = f.split("@"), d = this.extractLocation(l.pop()), h = l.shift() || "", _ = h.replace(/<anonymous function(: (\w+))?>/, "$2").replace(/\([^)]*\)/g, "") || void 0, p;
          h.match(/\(([^)]*)\)/) && (p = h.replace(/^[^(]+\(([^)]*)\)$/, "$1"));
          var g = p === void 0 || p === "[arguments not available]" ? void 0 : p.split(",");
          return new n({
            functionName: _,
            args: g,
            fileName: d[0],
            lineNumber: d[1],
            columnNumber: d[2],
            source: f
          });
        }, this);
      }
    };
  });
})(Wo);
var bu = Wo.exports;
const di = /* @__PURE__ */ Fs(bu);
function er(e) {
  try {
    return di.parse(e);
  } catch (t) {
    try {
      return di.parse(new Error());
    } catch (r) {
      return console.warn("Highlight Warning: failed to parse error", {
        originalError: t,
        secondaryError: r
      }), [];
    }
  }
}
const Xy = {
  level: [...qo],
  logger: "console",
  stringifyOptions: {
    depthOfLimit: 10,
    numOfKeysLimit: 100,
    stringLengthLimit: 1e3
  }
};
function wu(e, t) {
  const r = t.logger;
  if (!r)
    return () => {
    };
  let n;
  typeof r == "string" ? n = window[r] : n = r;
  const i = [];
  if (t.level.includes("error") && window) {
    const a = (u) => {
      const { message: c, error: s } = u;
      let f = [];
      s && (f = er(s));
      const l = [
        on(c, t.stringifyOptions)
      ];
      e({
        type: "Error",
        trace: f,
        time: Date.now(),
        value: l
      });
    };
    window.addEventListener("error", a), i.push(() => {
      window && window.removeEventListener("error", a);
    });
  }
  for (const a of t.level)
    i.push(o(n, a));
  return () => {
    i.forEach((a) => a());
  };
  function o(a, u) {
    return a[u] ? Xs(a, u, (c) => (...s) => {
      c.apply(this, s);
      try {
        e(Ru(u, t, ...s));
      } catch (f) {
        c("highlight logger error:", f, ...s);
      }
    }) : () => {
    };
  }
}
function Ru(e, t, ...r) {
  const n = er(new Error()), i = t.serializeConsoleAttributes ? r.map(
    (o) => typeof o == "object" ? on(o, t.stringifyOptions) : o
  ) : r.filter((o) => typeof o != "object").map((o) => `${o}`);
  return {
    type: e,
    trace: n,
    value: i,
    attributes: on(
      r.filter((o) => typeof o == "object").reduce((o, a) => S(S({}, o), a), {}),
      t.stringifyOptions
    ),
    time: Date.now()
  };
}
const Lu = {
  start: 0,
  end: 3
}, Pu = {
  start: 4,
  end: 5
}, gr = {
  start: 6,
  end: 7
}, Er = {
  start: 8,
  end: 8
}, Nu = {
  start: 9,
  end: 9
}, Iu = {
  start: 10,
  end: 15
};
function Cu() {
  if (crypto && crypto.getRandomValues) {
    const t = new Uint8Array(16);
    return crypto.getRandomValues(t), [...t.values()];
  }
  const e = [];
  for (let t = 0; t < 16; t += 1)
    e.push(Math.floor(Math.random() * 256));
  return e;
}
function It(e, t) {
  let r = "";
  for (let n = t.start; n <= t.end; n += 1)
    r += e[n].toString(16).padStart(2, "0");
  return r;
}
function Mu(e) {
  return e[Er.start] = (e[Er.start] | 128) & 191, e[gr.start] = e[gr.start] & 15 | 64, `${It(e, Lu)}-${It(e, Pu)}-${It(e, gr)}-${It(e, Er)}${It(e, Nu)}-${It(e, Iu)}`;
}
function xu() {
  const e = Cu();
  return Mu(e);
}
function Yo() {
  return typeof crypto != "undefined" && typeof crypto.randomUUID == "function" ? crypto.randomUUID() : xu();
}
function yr(e, t, r, n) {
  var c, s, f, l;
  let i = n != null ? n : t, o = er(i), a = {};
  t instanceof Error && (t = t.message, t.cause && (a = { "exception.cause": t.cause }));
  const u = Uu(o);
  e({
    error: i,
    event: Ut(t),
    type: "window.onerror",
    url: window.location.href,
    source: r != null ? r : "",
    lineNumber: (c = u[0]) != null && c.lineNumber ? (s = u[0]) == null ? void 0 : s.lineNumber : 0,
    columnNumber: (f = u[0]) != null && f.columnNumber ? (l = u[0]) == null ? void 0 : l.columnNumber : 0,
    stackTrace: u,
    timestamp: (/* @__PURE__ */ new Date()).toISOString(),
    payload: a ? Ut(a) : void 0,
    id: Yo()
  });
}
const Du = (e, { enablePromisePatch: t }) => {
  if (typeof window == "undefined") return () => {
  };
  const r = window.onerror = (a, u, c, s, f) => {
    yr(e, a, u, f);
  }, n = window.onunhandledrejection = (a) => {
    if (a.reason) {
      const u = a.promise;
      u.getStack ? yr(
        e,
        a.reason,
        a.type,
        u.getStack()
      ) : yr(e, a.reason, a.type);
    }
  }, i = window.Promise, o = class extends i {
    constructor(c) {
      super(c);
      R(this, "promiseCreationError");
      this.promiseCreationError = new Error();
    }
    getStack() {
      return this.promiseCreationError;
    }
    static shouldPatch() {
      const c = typeof window.Zone == "undefined";
      return t && c;
    }
  };
  return o.shouldPatch() && (window.Promise = o), () => {
    window.Promise = i, window.onunhandledrejection = n, window.onerror = r;
  };
}, Uu = (e) => {
  var r, n;
  if (e.length === 0)
    return e;
  const t = e[0];
  return (r = t.fileName) != null && r.includes("highlight.run") || (n = t.fileName) != null && n.includes("highlight.io") || t.functionName === "new highlightPromise" ? e.slice(1) : e;
}, Bu = [
  '["\\"Script error.\\""]',
  '"Script error."',
  '["\\"Load failed.\\""]',
  '"Load failed."',
  '["\\"Network request failed.\\""]',
  '"Network request failed."',
  '["\\"Document is not focused.\\""]',
  '"Document is not focused."',
  '["\\"Failed to fetch\\""]',
  '"Failed to fetch"',
  '[{"isTrusted":true}]',
  '{"isTrusted":true}',
  '["{}"]',
  '"{}"',
  '[""]',
  '""',
  '["\\"\\""]',
  '""'
], ku = [
  "websocket error",
  '\\"ResizeObserver loop'
];
var Hu = typeof globalThis == "object" ? globalThis : typeof self == "object" ? self : typeof window == "object" ? window : typeof global == "object" ? global : {}, gt = "1.9.0", pi = /^(\d+)\.(\d+)\.(\d+)(-(.+))?$/;
function Gu(e) {
  var t = /* @__PURE__ */ new Set([e]), r = /* @__PURE__ */ new Set(), n = e.match(pi);
  if (!n)
    return function() {
      return !1;
    };
  var i = {
    major: +n[1],
    minor: +n[2],
    patch: +n[3],
    prerelease: n[4]
  };
  if (i.prerelease != null)
    return function(c) {
      return c === e;
    };
  function o(u) {
    return r.add(u), !1;
  }
  function a(u) {
    return t.add(u), !0;
  }
  return function(c) {
    if (t.has(c))
      return !0;
    if (r.has(c))
      return !1;
    var s = c.match(pi);
    if (!s)
      return o(c);
    var f = {
      major: +s[1],
      minor: +s[2],
      patch: +s[3],
      prerelease: s[4]
    };
    return f.prerelease != null || i.major !== f.major ? o(c) : i.major === 0 ? i.minor === f.minor && i.patch <= f.patch ? a(c) : o(c) : i.minor <= f.minor ? a(c) : o(c);
  };
}
var $u = Gu(gt), ju = gt.split(".")[0], ue = Symbol.for("opentelemetry.js.api." + ju), ce = Hu;
function ve(e, t, r, n) {
  var i;
  n === void 0 && (n = !1);
  var o = ce[ue] = (i = ce[ue]) !== null && i !== void 0 ? i : {
    version: gt
  };
  if (!n && o[e]) {
    var a = new Error("@opentelemetry/api: Attempted duplicate registration of API: " + e);
    return r.error(a.stack || a.message), !1;
  }
  if (o.version !== gt) {
    var a = new Error("@opentelemetry/api: Registration of version v" + o.version + " for " + e + " does not match previously registered API v" + gt);
    return r.error(a.stack || a.message), !1;
  }
  return o[e] = t, r.debug("@opentelemetry/api: Registered a global for " + e + " v" + gt + "."), !0;
}
function mt(e) {
  var t, r, n = (t = ce[ue]) === null || t === void 0 ? void 0 : t.version;
  if (!(!n || !$u(n)))
    return (r = ce[ue]) === null || r === void 0 ? void 0 : r[e];
}
function ge(e, t) {
  t.debug("@opentelemetry/api: Unregistering a global for " + e + " v" + gt + ".");
  var r = ce[ue];
  r && delete r[e];
}
var Vu = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Fu = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, Xu = (
  /** @class */
  function() {
    function e(t) {
      this._namespace = t.namespace || "DiagComponentLogger";
    }
    return e.prototype.debug = function() {
      for (var t = [], r = 0; r < arguments.length; r++)
        t[r] = arguments[r];
      return Kt("debug", this._namespace, t);
    }, e.prototype.error = function() {
      for (var t = [], r = 0; r < arguments.length; r++)
        t[r] = arguments[r];
      return Kt("error", this._namespace, t);
    }, e.prototype.info = function() {
      for (var t = [], r = 0; r < arguments.length; r++)
        t[r] = arguments[r];
      return Kt("info", this._namespace, t);
    }, e.prototype.warn = function() {
      for (var t = [], r = 0; r < arguments.length; r++)
        t[r] = arguments[r];
      return Kt("warn", this._namespace, t);
    }, e.prototype.verbose = function() {
      for (var t = [], r = 0; r < arguments.length; r++)
        t[r] = arguments[r];
      return Kt("verbose", this._namespace, t);
    }, e;
  }()
);
function Kt(e, t, r) {
  var n = mt("diag");
  if (n)
    return r.unshift(t), n[e].apply(n, Fu([], Vu(r), !1));
}
var w;
(function(e) {
  e[e.NONE = 0] = "NONE", e[e.ERROR = 30] = "ERROR", e[e.WARN = 50] = "WARN", e[e.INFO = 60] = "INFO", e[e.DEBUG = 70] = "DEBUG", e[e.VERBOSE = 80] = "VERBOSE", e[e.ALL = 9999] = "ALL";
})(w || (w = {}));
function zu(e, t) {
  e < w.NONE ? e = w.NONE : e > w.ALL && (e = w.ALL), t = t || {};
  function r(n, i) {
    var o = t[n];
    return typeof o == "function" && e >= i ? o.bind(t) : function() {
    };
  }
  return {
    error: r("error", w.ERROR),
    warn: r("warn", w.WARN),
    info: r("info", w.INFO),
    debug: r("debug", w.DEBUG),
    verbose: r("verbose", w.VERBOSE)
  };
}
var qu = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Wu = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, Yu = "diag", K = (
  /** @class */
  function() {
    function e() {
      function t(i) {
        return function() {
          for (var o = [], a = 0; a < arguments.length; a++)
            o[a] = arguments[a];
          var u = mt("diag");
          if (u)
            return u[i].apply(u, Wu([], qu(o), !1));
        };
      }
      var r = this, n = function(i, o) {
        var a, u, c;
        if (o === void 0 && (o = { logLevel: w.INFO }), i === r) {
          var s = new Error("Cannot use diag as the logger for itself. Please use a DiagLogger implementation like ConsoleDiagLogger or a custom implementation");
          return r.error((a = s.stack) !== null && a !== void 0 ? a : s.message), !1;
        }
        typeof o == "number" && (o = {
          logLevel: o
        });
        var f = mt("diag"), l = zu((u = o.logLevel) !== null && u !== void 0 ? u : w.INFO, i);
        if (f && !o.suppressOverrideMessage) {
          var d = (c = new Error().stack) !== null && c !== void 0 ? c : "<failed to generate stacktrace>";
          f.warn("Current logger will be overwritten from " + d), l.warn("Current logger will overwrite one already registered from " + d);
        }
        return ve("diag", l, r, !0);
      };
      r.setLogger = n, r.disable = function() {
        ge(Yu, r);
      }, r.createComponentLogger = function(i) {
        return new Xu(i);
      }, r.verbose = t("verbose"), r.debug = t("debug"), r.info = t("info"), r.warn = t("warn"), r.error = t("error");
    }
    return e.instance = function() {
      return this._instance || (this._instance = new e()), this._instance;
    }, e;
  }()
), Ku = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Ju = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Zu = (
  /** @class */
  function() {
    function e(t) {
      this._entries = t ? new Map(t) : /* @__PURE__ */ new Map();
    }
    return e.prototype.getEntry = function(t) {
      var r = this._entries.get(t);
      if (r)
        return Object.assign({}, r);
    }, e.prototype.getAllEntries = function() {
      return Array.from(this._entries.entries()).map(function(t) {
        var r = Ku(t, 2), n = r[0], i = r[1];
        return [n, i];
      });
    }, e.prototype.setEntry = function(t, r) {
      var n = new e(this._entries);
      return n._entries.set(t, r), n;
    }, e.prototype.removeEntry = function(t) {
      var r = new e(this._entries);
      return r._entries.delete(t), r;
    }, e.prototype.removeEntries = function() {
      for (var t, r, n = [], i = 0; i < arguments.length; i++)
        n[i] = arguments[i];
      var o = new e(this._entries);
      try {
        for (var a = Ju(n), u = a.next(); !u.done; u = a.next()) {
          var c = u.value;
          o._entries.delete(c);
        }
      } catch (s) {
        t = { error: s };
      } finally {
        try {
          u && !u.done && (r = a.return) && r.call(a);
        } finally {
          if (t) throw t.error;
        }
      }
      return o;
    }, e.prototype.clear = function() {
      return new e();
    }, e;
  }()
), Qu = Symbol("BaggageEntryMetadata"), tc = K.instance();
function ec(e) {
  return e === void 0 && (e = {}), new Zu(new Map(Object.entries(e)));
}
function Ko(e) {
  return typeof e != "string" && (tc.error("Cannot create baggage metadata from unknown type: " + typeof e), e = ""), {
    __TYPE__: Qu,
    toString: function() {
      return e;
    }
  };
}
function Ee(e) {
  return Symbol.for(e);
}
var rc = (
  /** @class */
  /* @__PURE__ */ function() {
    function e(t) {
      var r = this;
      r._currentContext = t ? new Map(t) : /* @__PURE__ */ new Map(), r.getValue = function(n) {
        return r._currentContext.get(n);
      }, r.setValue = function(n, i) {
        var o = new e(r._currentContext);
        return o._currentContext.set(n, i), o;
      }, r.deleteValue = function(n) {
        var i = new e(r._currentContext);
        return i._currentContext.delete(n), i;
      };
    }
    return e;
  }()
), pt = new rc(), Ot = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), nc = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.createGauge = function(t, r) {
      return dc;
    }, e.prototype.createHistogram = function(t, r) {
      return pc;
    }, e.prototype.createCounter = function(t, r) {
      return lc;
    }, e.prototype.createUpDownCounter = function(t, r) {
      return hc;
    }, e.prototype.createObservableGauge = function(t, r) {
      return vc;
    }, e.prototype.createObservableCounter = function(t, r) {
      return _c;
    }, e.prototype.createObservableUpDownCounter = function(t, r) {
      return gc;
    }, e.prototype.addBatchObservableCallback = function(t, r) {
    }, e.prototype.removeBatchObservableCallback = function(t) {
    }, e;
  }()
), rr = (
  /** @class */
  /* @__PURE__ */ function() {
    function e() {
    }
    return e;
  }()
), ic = (
  /** @class */
  function(e) {
    Ot(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.add = function(r, n) {
    }, t;
  }(rr)
), oc = (
  /** @class */
  function(e) {
    Ot(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.add = function(r, n) {
    }, t;
  }(rr)
), ac = (
  /** @class */
  function(e) {
    Ot(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.record = function(r, n) {
    }, t;
  }(rr)
), sc = (
  /** @class */
  function(e) {
    Ot(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.record = function(r, n) {
    }, t;
  }(rr)
), Un = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.addCallback = function(t) {
    }, e.prototype.removeCallback = function(t) {
    }, e;
  }()
), uc = (
  /** @class */
  function(e) {
    Ot(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t;
  }(Un)
), cc = (
  /** @class */
  function(e) {
    Ot(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t;
  }(Un)
), fc = (
  /** @class */
  function(e) {
    Ot(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t;
  }(Un)
), Jo = new nc(), lc = new ic(), dc = new ac(), pc = new sc(), hc = new oc(), _c = new uc(), vc = new cc(), gc = new fc();
function Ec() {
  return Jo;
}
var ft;
(function(e) {
  e[e.INT = 0] = "INT", e[e.DOUBLE = 1] = "DOUBLE";
})(ft || (ft = {}));
var yc = {
  get: function(e, t) {
    if (e != null)
      return e[t];
  },
  keys: function(e) {
    return e == null ? [] : Object.keys(e);
  }
}, mc = {
  set: function(e, t, r) {
    e != null && (e[t] = r);
  }
}, Tc = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Sc = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, Oc = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.active = function() {
      return pt;
    }, e.prototype.with = function(t, r, n) {
      for (var i = [], o = 3; o < arguments.length; o++)
        i[o - 3] = arguments[o];
      return r.call.apply(r, Sc([n], Tc(i), !1));
    }, e.prototype.bind = function(t, r) {
      return r;
    }, e.prototype.enable = function() {
      return this;
    }, e.prototype.disable = function() {
      return this;
    }, e;
  }()
), Ac = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, bc = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, mr = "context", wc = new Oc(), nr = (
  /** @class */
  function() {
    function e() {
    }
    return e.getInstance = function() {
      return this._instance || (this._instance = new e()), this._instance;
    }, e.prototype.setGlobalContextManager = function(t) {
      return ve(mr, t, K.instance());
    }, e.prototype.active = function() {
      return this._getContextManager().active();
    }, e.prototype.with = function(t, r, n) {
      for (var i, o = [], a = 3; a < arguments.length; a++)
        o[a - 3] = arguments[a];
      return (i = this._getContextManager()).with.apply(i, bc([t, r, n], Ac(o), !1));
    }, e.prototype.bind = function(t, r) {
      return this._getContextManager().bind(t, r);
    }, e.prototype._getContextManager = function() {
      return mt(mr) || wc;
    }, e.prototype.disable = function() {
      this._getContextManager().disable(), ge(mr, K.instance());
    }, e;
  }()
), J;
(function(e) {
  e[e.NONE = 0] = "NONE", e[e.SAMPLED = 1] = "SAMPLED";
})(J || (J = {}));
var Zo = "0000000000000000", Qo = "00000000000000000000000000000000", ta = {
  traceId: Qo,
  spanId: Zo,
  traceFlags: J.NONE
}, ne = (
  /** @class */
  function() {
    function e(t) {
      t === void 0 && (t = ta), this._spanContext = t;
    }
    return e.prototype.spanContext = function() {
      return this._spanContext;
    }, e.prototype.setAttribute = function(t, r) {
      return this;
    }, e.prototype.setAttributes = function(t) {
      return this;
    }, e.prototype.addEvent = function(t, r) {
      return this;
    }, e.prototype.addLink = function(t) {
      return this;
    }, e.prototype.addLinks = function(t) {
      return this;
    }, e.prototype.setStatus = function(t) {
      return this;
    }, e.prototype.updateName = function(t) {
      return this;
    }, e.prototype.end = function(t) {
    }, e.prototype.isRecording = function() {
      return !1;
    }, e.prototype.recordException = function(t, r) {
    }, e;
  }()
), Bn = Ee("OpenTelemetry Context Key SPAN");
function kn(e) {
  return e.getValue(Bn) || void 0;
}
function Rc() {
  return kn(nr.getInstance().active());
}
function Hn(e, t) {
  return e.setValue(Bn, t);
}
function Lc(e) {
  return e.deleteValue(Bn);
}
function Pc(e, t) {
  return Hn(e, new ne(t));
}
function ea(e) {
  var t;
  return (t = kn(e)) === null || t === void 0 ? void 0 : t.spanContext();
}
var Nc = /^([0-9a-f]{32})$/i, Ic = /^[0-9a-f]{16}$/i;
function ra(e) {
  return Nc.test(e) && e !== Qo;
}
function Cc(e) {
  return Ic.test(e) && e !== Zo;
}
function ye(e) {
  return ra(e.traceId) && Cc(e.spanId);
}
function Mc(e) {
  return new ne(e);
}
var Tr = nr.getInstance(), na = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.startSpan = function(t, r, n) {
      n === void 0 && (n = Tr.active());
      var i = !!(r != null && r.root);
      if (i)
        return new ne();
      var o = n && ea(n);
      return xc(o) && ye(o) ? new ne(o) : new ne();
    }, e.prototype.startActiveSpan = function(t, r, n, i) {
      var o, a, u;
      if (!(arguments.length < 2)) {
        arguments.length === 2 ? u = r : arguments.length === 3 ? (o = r, u = n) : (o = r, a = n, u = i);
        var c = a != null ? a : Tr.active(), s = this.startSpan(t, o, c), f = Hn(c, s);
        return Tr.with(f, u, void 0, s);
      }
    }, e;
  }()
);
function xc(e) {
  return typeof e == "object" && typeof e.spanId == "string" && typeof e.traceId == "string" && typeof e.traceFlags == "number";
}
var Dc = new na(), Uc = (
  /** @class */
  function() {
    function e(t, r, n, i) {
      this._provider = t, this.name = r, this.version = n, this.options = i;
    }
    return e.prototype.startSpan = function(t, r, n) {
      return this._getTracer().startSpan(t, r, n);
    }, e.prototype.startActiveSpan = function(t, r, n, i) {
      var o = this._getTracer();
      return Reflect.apply(o.startActiveSpan, o, arguments);
    }, e.prototype._getTracer = function() {
      if (this._delegate)
        return this._delegate;
      var t = this._provider.getDelegateTracer(this.name, this.version, this.options);
      return t ? (this._delegate = t, this._delegate) : Dc;
    }, e;
  }()
), Bc = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.getTracer = function(t, r, n) {
      return new na();
    }, e;
  }()
), kc = new Bc(), hi = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.getTracer = function(t, r, n) {
      var i;
      return (i = this.getDelegateTracer(t, r, n)) !== null && i !== void 0 ? i : new Uc(this, t, r, n);
    }, e.prototype.getDelegate = function() {
      var t;
      return (t = this._delegate) !== null && t !== void 0 ? t : kc;
    }, e.prototype.setDelegate = function(t) {
      this._delegate = t;
    }, e.prototype.getDelegateTracer = function(t, r, n) {
      var i;
      return (i = this._delegate) === null || i === void 0 ? void 0 : i.getTracer(t, r, n);
    }, e;
  }()
), je;
(function(e) {
  e[e.NOT_RECORD = 0] = "NOT_RECORD", e[e.RECORD = 1] = "RECORD", e[e.RECORD_AND_SAMPLED = 2] = "RECORD_AND_SAMPLED";
})(je || (je = {}));
var fe;
(function(e) {
  e[e.INTERNAL = 0] = "INTERNAL", e[e.SERVER = 1] = "SERVER", e[e.CLIENT = 2] = "CLIENT", e[e.PRODUCER = 3] = "PRODUCER", e[e.CONSUMER = 4] = "CONSUMER";
})(fe || (fe = {}));
var Ve;
(function(e) {
  e[e.UNSET = 0] = "UNSET", e[e.OK = 1] = "OK", e[e.ERROR = 2] = "ERROR";
})(Ve || (Ve = {}));
var O = nr.getInstance(), v = K.instance(), Hc = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.getMeter = function(t, r, n) {
      return Jo;
    }, e;
  }()
), Gc = new Hc(), Sr = "metrics", $c = (
  /** @class */
  function() {
    function e() {
    }
    return e.getInstance = function() {
      return this._instance || (this._instance = new e()), this._instance;
    }, e.prototype.setGlobalMeterProvider = function(t) {
      return ve(Sr, t, K.instance());
    }, e.prototype.getMeterProvider = function() {
      return mt(Sr) || Gc;
    }, e.prototype.getMeter = function(t, r, n) {
      return this.getMeterProvider().getMeter(t, r, n);
    }, e.prototype.disable = function() {
      ge(Sr, K.instance());
    }, e;
  }()
), Vt = $c.getInstance(), jc = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.inject = function(t, r) {
    }, e.prototype.extract = function(t, r) {
      return t;
    }, e.prototype.fields = function() {
      return [];
    }, e;
  }()
), Gn = Ee("OpenTelemetry Baggage Key");
function ia(e) {
  return e.getValue(Gn) || void 0;
}
function Vc() {
  return ia(nr.getInstance().active());
}
function Fc(e, t) {
  return e.setValue(Gn, t);
}
function Xc(e) {
  return e.deleteValue(Gn);
}
var Or = "propagation", zc = new jc(), qc = (
  /** @class */
  function() {
    function e() {
      this.createBaggage = ec, this.getBaggage = ia, this.getActiveBaggage = Vc, this.setBaggage = Fc, this.deleteBaggage = Xc;
    }
    return e.getInstance = function() {
      return this._instance || (this._instance = new e()), this._instance;
    }, e.prototype.setGlobalPropagator = function(t) {
      return ve(Or, t, K.instance());
    }, e.prototype.inject = function(t, r, n) {
      return n === void 0 && (n = mc), this._getGlobalPropagator().inject(t, r, n);
    }, e.prototype.extract = function(t, r, n) {
      return n === void 0 && (n = yc), this._getGlobalPropagator().extract(t, r, n);
    }, e.prototype.fields = function() {
      return this._getGlobalPropagator().fields();
    }, e.prototype.disable = function() {
      ge(Or, K.instance());
    }, e.prototype._getGlobalPropagator = function() {
      return mt(Or) || zc;
    }, e;
  }()
), k = qc.getInstance(), Ar = "trace", Wc = (
  /** @class */
  function() {
    function e() {
      this._proxyTracerProvider = new hi(), this.wrapSpanContext = Mc, this.isSpanContextValid = ye, this.deleteSpan = Lc, this.getSpan = kn, this.getActiveSpan = Rc, this.getSpanContext = ea, this.setSpan = Hn, this.setSpanContext = Pc;
    }
    return e.getInstance = function() {
      return this._instance || (this._instance = new e()), this._instance;
    }, e.prototype.setGlobalTracerProvider = function(t) {
      var r = ve(Ar, this._proxyTracerProvider, K.instance());
      return r && this._proxyTracerProvider.setDelegate(t), r;
    }, e.prototype.getTracerProvider = function() {
      return mt(Ar) || this._proxyTracerProvider;
    }, e.prototype.getTracer = function(t, r) {
      return this.getTracerProvider().getTracer(t, r);
    }, e.prototype.disable = function() {
      ge(Ar, K.instance()), this._proxyTracerProvider = new hi();
    }, e;
  }()
), b = Wc.getInstance(), Yc = Ee("OpenTelemetry SDK Context Key SUPPRESS_TRACING");
function oa(e) {
  return e.getValue(Yc) === !0;
}
var Kc = "=", an = ";", sn = ",", br = "baggage", Jc = 180, Zc = 4096, Qc = 8192, tf = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
};
function ef(e) {
  return e.reduce(function(t, r) {
    var n = "" + t + (t !== "" ? sn : "") + r;
    return n.length > Qc ? t : n;
  }, "");
}
function rf(e) {
  return e.getAllEntries().map(function(t) {
    var r = tf(t, 2), n = r[0], i = r[1], o = encodeURIComponent(n) + "=" + encodeURIComponent(i.value);
    return i.metadata !== void 0 && (o += an + i.metadata.toString()), o;
  });
}
function nf(e) {
  var t = e.split(an);
  if (!(t.length <= 0)) {
    var r = t.shift();
    if (r) {
      var n = r.indexOf(Kc);
      if (!(n <= 0)) {
        var i = decodeURIComponent(r.substring(0, n).trim()), o = decodeURIComponent(r.substring(n + 1).trim()), a;
        return t.length > 0 && (a = Ko(t.join(an))), { key: i, value: o, metadata: a };
      }
    }
  }
}
var of = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.inject = function(t, r, n) {
      var i = k.getBaggage(t);
      if (!(!i || oa(t))) {
        var o = rf(i).filter(function(u) {
          return u.length <= Zc;
        }).slice(0, Jc), a = ef(o);
        a.length > 0 && n.set(r, br, a);
      }
    }, e.prototype.extract = function(t, r, n) {
      var i = n.get(r, br), o = Array.isArray(i) ? i.join(sn) : i;
      if (!o)
        return t;
      var a = {};
      if (o.length === 0)
        return t;
      var u = o.split(sn);
      return u.forEach(function(c) {
        var s = nf(c);
        if (s) {
          var f = { value: s.value };
          s.metadata && (f.metadata = s.metadata), a[s.key] = f;
        }
      }), Object.entries(a).length === 0 ? t : k.setBaggage(t, k.createBaggage(a));
    }, e.prototype.fields = function() {
      return [br];
    }, e;
  }()
), un;
(function(e) {
  e.AlwaysOff = "always_off", e.AlwaysOn = "always_on", e.ParentBasedAlwaysOff = "parentbased_always_off", e.ParentBasedAlwaysOn = "parentbased_always_on", e.ParentBasedTraceIdRatio = "parentbased_traceidratio", e.TraceIdRatio = "traceidratio";
})(un || (un = {}));
var af = ",", sf = ["OTEL_SDK_DISABLED"];
function uf(e) {
  return sf.indexOf(e) > -1;
}
var cf = [
  "OTEL_BSP_EXPORT_TIMEOUT",
  "OTEL_BSP_MAX_EXPORT_BATCH_SIZE",
  "OTEL_BSP_MAX_QUEUE_SIZE",
  "OTEL_BSP_SCHEDULE_DELAY",
  "OTEL_BLRP_EXPORT_TIMEOUT",
  "OTEL_BLRP_MAX_EXPORT_BATCH_SIZE",
  "OTEL_BLRP_MAX_QUEUE_SIZE",
  "OTEL_BLRP_SCHEDULE_DELAY",
  "OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT",
  "OTEL_ATTRIBUTE_COUNT_LIMIT",
  "OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT",
  "OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT",
  "OTEL_LOGRECORD_ATTRIBUTE_VALUE_LENGTH_LIMIT",
  "OTEL_LOGRECORD_ATTRIBUTE_COUNT_LIMIT",
  "OTEL_SPAN_EVENT_COUNT_LIMIT",
  "OTEL_SPAN_LINK_COUNT_LIMIT",
  "OTEL_SPAN_ATTRIBUTE_PER_EVENT_COUNT_LIMIT",
  "OTEL_SPAN_ATTRIBUTE_PER_LINK_COUNT_LIMIT",
  "OTEL_EXPORTER_OTLP_TIMEOUT",
  "OTEL_EXPORTER_OTLP_TRACES_TIMEOUT",
  "OTEL_EXPORTER_OTLP_METRICS_TIMEOUT",
  "OTEL_EXPORTER_OTLP_LOGS_TIMEOUT",
  "OTEL_EXPORTER_JAEGER_AGENT_PORT"
];
function ff(e) {
  return cf.indexOf(e) > -1;
}
var lf = [
  "OTEL_NO_PATCH_MODULES",
  "OTEL_PROPAGATORS",
  "OTEL_SEMCONV_STABILITY_OPT_IN"
];
function df(e) {
  return lf.indexOf(e) > -1;
}
var wr = 1 / 0, Rr = 128, pf = 128, hf = 128, aa = {
  OTEL_SDK_DISABLED: !1,
  CONTAINER_NAME: "",
  ECS_CONTAINER_METADATA_URI_V4: "",
  ECS_CONTAINER_METADATA_URI: "",
  HOSTNAME: "",
  KUBERNETES_SERVICE_HOST: "",
  NAMESPACE: "",
  OTEL_BSP_EXPORT_TIMEOUT: 3e4,
  OTEL_BSP_MAX_EXPORT_BATCH_SIZE: 512,
  OTEL_BSP_MAX_QUEUE_SIZE: 2048,
  OTEL_BSP_SCHEDULE_DELAY: 5e3,
  OTEL_BLRP_EXPORT_TIMEOUT: 3e4,
  OTEL_BLRP_MAX_EXPORT_BATCH_SIZE: 512,
  OTEL_BLRP_MAX_QUEUE_SIZE: 2048,
  OTEL_BLRP_SCHEDULE_DELAY: 5e3,
  OTEL_EXPORTER_JAEGER_AGENT_HOST: "",
  OTEL_EXPORTER_JAEGER_AGENT_PORT: 6832,
  OTEL_EXPORTER_JAEGER_ENDPOINT: "",
  OTEL_EXPORTER_JAEGER_PASSWORD: "",
  OTEL_EXPORTER_JAEGER_USER: "",
  OTEL_EXPORTER_OTLP_ENDPOINT: "",
  OTEL_EXPORTER_OTLP_TRACES_ENDPOINT: "",
  OTEL_EXPORTER_OTLP_METRICS_ENDPOINT: "",
  OTEL_EXPORTER_OTLP_LOGS_ENDPOINT: "",
  OTEL_EXPORTER_OTLP_HEADERS: "",
  OTEL_EXPORTER_OTLP_TRACES_HEADERS: "",
  OTEL_EXPORTER_OTLP_METRICS_HEADERS: "",
  OTEL_EXPORTER_OTLP_LOGS_HEADERS: "",
  OTEL_EXPORTER_OTLP_TIMEOUT: 1e4,
  OTEL_EXPORTER_OTLP_TRACES_TIMEOUT: 1e4,
  OTEL_EXPORTER_OTLP_METRICS_TIMEOUT: 1e4,
  OTEL_EXPORTER_OTLP_LOGS_TIMEOUT: 1e4,
  OTEL_EXPORTER_ZIPKIN_ENDPOINT: "http://localhost:9411/api/v2/spans",
  OTEL_LOG_LEVEL: w.INFO,
  OTEL_NO_PATCH_MODULES: [],
  OTEL_PROPAGATORS: ["tracecontext", "baggage"],
  OTEL_RESOURCE_ATTRIBUTES: "",
  OTEL_SERVICE_NAME: "",
  OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT: wr,
  OTEL_ATTRIBUTE_COUNT_LIMIT: Rr,
  OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT: wr,
  OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT: Rr,
  OTEL_LOGRECORD_ATTRIBUTE_VALUE_LENGTH_LIMIT: wr,
  OTEL_LOGRECORD_ATTRIBUTE_COUNT_LIMIT: Rr,
  OTEL_SPAN_EVENT_COUNT_LIMIT: 128,
  OTEL_SPAN_LINK_COUNT_LIMIT: 128,
  OTEL_SPAN_ATTRIBUTE_PER_EVENT_COUNT_LIMIT: pf,
  OTEL_SPAN_ATTRIBUTE_PER_LINK_COUNT_LIMIT: hf,
  OTEL_TRACES_EXPORTER: "",
  OTEL_TRACES_SAMPLER: un.ParentBasedAlwaysOn,
  OTEL_TRACES_SAMPLER_ARG: "",
  OTEL_LOGS_EXPORTER: "",
  OTEL_EXPORTER_OTLP_INSECURE: "",
  OTEL_EXPORTER_OTLP_TRACES_INSECURE: "",
  OTEL_EXPORTER_OTLP_METRICS_INSECURE: "",
  OTEL_EXPORTER_OTLP_LOGS_INSECURE: "",
  OTEL_EXPORTER_OTLP_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_TRACES_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_METRICS_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_LOGS_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_COMPRESSION: "",
  OTEL_EXPORTER_OTLP_TRACES_COMPRESSION: "",
  OTEL_EXPORTER_OTLP_METRICS_COMPRESSION: "",
  OTEL_EXPORTER_OTLP_LOGS_COMPRESSION: "",
  OTEL_EXPORTER_OTLP_CLIENT_KEY: "",
  OTEL_EXPORTER_OTLP_TRACES_CLIENT_KEY: "",
  OTEL_EXPORTER_OTLP_METRICS_CLIENT_KEY: "",
  OTEL_EXPORTER_OTLP_LOGS_CLIENT_KEY: "",
  OTEL_EXPORTER_OTLP_CLIENT_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_TRACES_CLIENT_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_METRICS_CLIENT_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_LOGS_CLIENT_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_PROTOCOL: "http/protobuf",
  OTEL_EXPORTER_OTLP_TRACES_PROTOCOL: "http/protobuf",
  OTEL_EXPORTER_OTLP_METRICS_PROTOCOL: "http/protobuf",
  OTEL_EXPORTER_OTLP_LOGS_PROTOCOL: "http/protobuf",
  OTEL_EXPORTER_OTLP_METRICS_TEMPORALITY_PREFERENCE: "cumulative",
  OTEL_SEMCONV_STABILITY_OPT_IN: []
};
function _f(e, t, r) {
  if (typeof r[e] != "undefined") {
    var n = String(r[e]);
    t[e] = n.toLowerCase() === "true";
  }
}
function vf(e, t, r, n, i) {
  if (n === void 0 && (n = -1 / 0), i === void 0 && (i = 1 / 0), typeof r[e] != "undefined") {
    var o = Number(r[e]);
    isNaN(o) || (o < n ? t[e] = n : o > i ? t[e] = i : t[e] = o);
  }
}
function gf(e, t, r, n) {
  n === void 0 && (n = af);
  var i = r[e];
  typeof i == "string" && (t[e] = i.split(n).map(function(o) {
    return o.trim();
  }));
}
var Ef = {
  ALL: w.ALL,
  VERBOSE: w.VERBOSE,
  DEBUG: w.DEBUG,
  INFO: w.INFO,
  WARN: w.WARN,
  ERROR: w.ERROR,
  NONE: w.NONE
};
function yf(e, t, r) {
  var n = r[e];
  if (typeof n == "string") {
    var i = Ef[n.toUpperCase()];
    i != null && (t[e] = i);
  }
}
function mf(e) {
  var t = {};
  for (var r in aa) {
    var n = r;
    switch (n) {
      case "OTEL_LOG_LEVEL":
        yf(n, t, e);
        break;
      default:
        if (uf(n))
          _f(n, t, e);
        else if (ff(n))
          vf(n, t, e);
        else if (df(n))
          gf(n, t, e);
        else {
          var i = e[n];
          typeof i != "undefined" && i !== null && (t[n] = String(i));
        }
    }
  }
  return t;
}
var Tf = typeof globalThis == "object" ? globalThis : typeof self == "object" ? self : typeof window == "object" ? window : typeof global == "object" ? global : {};
function Sf() {
  var e = mf(Tf);
  return Object.assign({}, aa, e);
}
var cn = performance, Of = 9, Af = 6, bf = Math.pow(10, Af), _i = Math.pow(10, Of);
function vi(e) {
  var t = e / 1e3, r = Math.trunc(t), n = Math.round(e % 1e3 * bf);
  return [r, n];
}
function wf() {
  var e = cn.timeOrigin;
  if (typeof e != "number") {
    var t = cn;
    e = t.timing && t.timing.fetchStart;
  }
  return e;
}
function Rf(e) {
  var t = vi(wf()), r = vi(cn.now());
  return Lf(t, r);
}
function Lf(e, t) {
  var r = [e[0] + t[0], e[1] + t[1]];
  return r[1] >= _i && (r[1] -= _i, r[0] += 1), r;
}
var B;
(function(e) {
  e[e.SUCCESS = 0] = "SUCCESS", e[e.FAILED = 1] = "FAILED";
})(B || (B = {}));
var Pf = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Nf = (
  /** @class */
  function() {
    function e(t) {
      t === void 0 && (t = {});
      var r;
      this._propagators = (r = t.propagators) !== null && r !== void 0 ? r : [], this._fields = Array.from(new Set(this._propagators.map(function(n) {
        return typeof n.fields == "function" ? n.fields() : [];
      }).reduce(function(n, i) {
        return n.concat(i);
      }, [])));
    }
    return e.prototype.inject = function(t, r, n) {
      var i, o;
      try {
        for (var a = Pf(this._propagators), u = a.next(); !u.done; u = a.next()) {
          var c = u.value;
          try {
            c.inject(t, r, n);
          } catch (s) {
            v.warn("Failed to inject with " + c.constructor.name + ". Err: " + s.message);
          }
        }
      } catch (s) {
        i = { error: s };
      } finally {
        try {
          u && !u.done && (o = a.return) && o.call(a);
        } finally {
          if (i) throw i.error;
        }
      }
    }, e.prototype.extract = function(t, r, n) {
      return this._propagators.reduce(function(i, o) {
        try {
          return o.extract(i, r, n);
        } catch (a) {
          v.warn("Failed to extract with " + o.constructor.name + ". Err: " + a.message);
        }
        return i;
      }, t);
    }, e.prototype.fields = function() {
      return this._fields.slice();
    }, e;
  }()
), fn = "[_0-9a-z-*/]", If = "[a-z]" + fn + "{0,255}", Cf = "[a-z0-9]" + fn + "{0,240}@[a-z]" + fn + "{0,13}", Mf = new RegExp("^(?:" + If + "|" + Cf + ")$"), xf = /^[ -~]{0,255}[!-~]$/, Df = /,|=/;
function Uf(e) {
  return Mf.test(e);
}
function Bf(e) {
  return xf.test(e) && !Df.test(e);
}
var gi = 32, kf = 512, Ei = ",", yi = "=", Hf = (
  /** @class */
  function() {
    function e(t) {
      this._internalState = /* @__PURE__ */ new Map(), t && this._parse(t);
    }
    return e.prototype.set = function(t, r) {
      var n = this._clone();
      return n._internalState.has(t) && n._internalState.delete(t), n._internalState.set(t, r), n;
    }, e.prototype.unset = function(t) {
      var r = this._clone();
      return r._internalState.delete(t), r;
    }, e.prototype.get = function(t) {
      return this._internalState.get(t);
    }, e.prototype.serialize = function() {
      var t = this;
      return this._keys().reduce(function(r, n) {
        return r.push(n + yi + t.get(n)), r;
      }, []).join(Ei);
    }, e.prototype._parse = function(t) {
      t.length > kf || (this._internalState = t.split(Ei).reverse().reduce(function(r, n) {
        var i = n.trim(), o = i.indexOf(yi);
        if (o !== -1) {
          var a = i.slice(0, o), u = i.slice(o + 1, n.length);
          Uf(a) && Bf(u) && r.set(a, u);
        }
        return r;
      }, /* @__PURE__ */ new Map()), this._internalState.size > gi && (this._internalState = new Map(Array.from(this._internalState.entries()).reverse().slice(0, gi))));
    }, e.prototype._keys = function() {
      return Array.from(this._internalState.keys()).reverse();
    }, e.prototype._clone = function() {
      var t = new e();
      return t._internalState = new Map(this._internalState), t;
    }, e;
  }()
), Lr = "traceparent", Pr = "tracestate", Gf = "00", $f = "(?!ff)[\\da-f]{2}", jf = "(?![0]{32})[\\da-f]{32}", Vf = "(?![0]{16})[\\da-f]{16}", Ff = "[\\da-f]{2}", Xf = new RegExp("^\\s?(" + $f + ")-(" + jf + ")-(" + Vf + ")-(" + Ff + ")(-.*)?\\s?$");
function zf(e) {
  var t = Xf.exec(e);
  return !t || t[1] === "00" && t[5] ? null : {
    traceId: t[2],
    spanId: t[3],
    traceFlags: parseInt(t[4], 16)
  };
}
var qf = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.inject = function(t, r, n) {
      var i = b.getSpanContext(t);
      if (!(!i || oa(t) || !ye(i))) {
        var o = Gf + "-" + i.traceId + "-" + i.spanId + "-0" + Number(i.traceFlags || J.NONE).toString(16);
        n.set(r, Lr, o), i.traceState && n.set(r, Pr, i.traceState.serialize());
      }
    }, e.prototype.extract = function(t, r, n) {
      var i = n.get(r, Lr);
      if (!i)
        return t;
      var o = Array.isArray(i) ? i[0] : i;
      if (typeof o != "string")
        return t;
      var a = zf(o);
      if (!a)
        return t;
      a.isRemote = !0;
      var u = n.get(r, Pr);
      if (u) {
        var c = Array.isArray(u) ? u.join(",") : u;
        a.traceState = new Hf(typeof c == "string" ? c : void 0);
      }
      return b.setSpanContext(t, a);
    }, e.prototype.fields = function() {
      return [Lr, Pr];
    }, e;
  }()
), Wf = "[object Object]", Yf = "[object Null]", Kf = "[object Undefined]", Jf = Function.prototype, sa = Jf.toString, Zf = sa.call(Object), Qf = tl(Object.getPrototypeOf, Object), ua = Object.prototype, ca = ua.hasOwnProperty, ht = Symbol ? Symbol.toStringTag : void 0, fa = ua.toString;
function tl(e, t) {
  return function(r) {
    return e(t(r));
  };
}
function mi(e) {
  if (!el(e) || rl(e) !== Wf)
    return !1;
  var t = Qf(e);
  if (t === null)
    return !0;
  var r = ca.call(t, "constructor") && t.constructor;
  return typeof r == "function" && r instanceof r && sa.call(r) === Zf;
}
function el(e) {
  return e != null && typeof e == "object";
}
function rl(e) {
  return e == null ? e === void 0 ? Kf : Yf : ht && ht in Object(e) ? nl(e) : il(e);
}
function nl(e) {
  var t = ca.call(e, ht), r = e[ht], n = !1;
  try {
    e[ht] = void 0, n = !0;
  } catch (o) {
  }
  var i = fa.call(e);
  return n && (t ? e[ht] = r : delete e[ht]), i;
}
function il(e) {
  return fa.call(e);
}
var ol = 20;
function al() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  for (var r = e.shift(), n = /* @__PURE__ */ new WeakMap(); e.length > 0; )
    r = la(r, e.shift(), 0, n);
  return r;
}
function Nr(e) {
  return Fe(e) ? e.slice() : e;
}
function la(e, t, r, n) {
  r === void 0 && (r = 0);
  var i;
  if (!(r > ol)) {
    if (r++, Be(e) || Be(t) || da(t))
      i = Nr(t);
    else if (Fe(e)) {
      if (i = e.slice(), Fe(t))
        for (var o = 0, a = t.length; o < a; o++)
          i.push(Nr(t[o]));
      else if (Jt(t))
        for (var u = Object.keys(t), o = 0, a = u.length; o < a; o++) {
          var c = u[o];
          i[c] = Nr(t[c]);
        }
    } else if (Jt(e))
      if (Jt(t)) {
        if (!sl(e, t))
          return t;
        i = Object.assign({}, e);
        for (var u = Object.keys(t), o = 0, a = u.length; o < a; o++) {
          var c = u[o], s = t[c];
          if (Be(s))
            typeof s == "undefined" ? delete i[c] : i[c] = s;
          else {
            var f = i[c], l = s;
            if (Ti(e, c, n) || Ti(t, c, n))
              delete i[c];
            else {
              if (Jt(f) && Jt(l)) {
                var d = n.get(f) || [], h = n.get(l) || [];
                d.push({ obj: e, key: c }), h.push({ obj: t, key: c }), n.set(f, d), n.set(l, h);
              }
              i[c] = la(i[c], s, r, n);
            }
          }
        }
      } else
        i = t;
    return i;
  }
}
function Ti(e, t, r) {
  for (var n = r.get(e[t]) || [], i = 0, o = n.length; i < o; i++) {
    var a = n[i];
    if (a.key === t && a.obj === e)
      return !0;
  }
  return !1;
}
function Fe(e) {
  return Array.isArray(e);
}
function da(e) {
  return typeof e == "function";
}
function Jt(e) {
  return !Be(e) && !Fe(e) && !da(e) && typeof e == "object";
}
function Be(e) {
  return typeof e == "string" || typeof e == "number" || typeof e == "boolean" || typeof e == "undefined" || e instanceof Date || e instanceof RegExp || e === null;
}
function sl(e, t) {
  return !(!mi(e) || !mi(t));
}
var pa = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.emit = function(t) {
    }, e;
  }()
), ul = new pa(), cl = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.getLogger = function(t, r, n) {
      return new pa();
    }, e;
  }()
), ha = new cl(), fl = (
  /** @class */
  function() {
    function e(t, r, n, i) {
      this._provider = t, this.name = r, this.version = n, this.options = i;
    }
    return e.prototype.emit = function(t) {
      this._getLogger().emit(t);
    }, e.prototype._getLogger = function() {
      if (this._delegate)
        return this._delegate;
      var t = this._provider.getDelegateLogger(this.name, this.version, this.options);
      return t ? (this._delegate = t, this._delegate) : ul;
    }, e;
  }()
), Si = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.getLogger = function(t, r, n) {
      var i;
      return (i = this.getDelegateLogger(t, r, n)) !== null && i !== void 0 ? i : new fl(this, t, r, n);
    }, e.prototype.getDelegate = function() {
      var t;
      return (t = this._delegate) !== null && t !== void 0 ? t : ha;
    }, e.prototype.setDelegate = function(t) {
      this._delegate = t;
    }, e.prototype.getDelegateLogger = function(t, r, n) {
      var i;
      return (i = this._delegate) === null || i === void 0 ? void 0 : i.getLogger(t, r, n);
    }, e;
  }()
), ll = typeof globalThis == "object" ? globalThis : typeof self == "object" ? self : typeof window == "object" ? window : typeof global == "object" ? global : {}, we = Symbol.for("io.opentelemetry.js.api.logs"), Zt = ll;
function dl(e, t, r) {
  return function(n) {
    return n === e ? t : r;
  };
}
var Oi = 1, pl = (
  /** @class */
  function() {
    function e() {
      this._proxyLoggerProvider = new Si();
    }
    return e.getInstance = function() {
      return this._instance || (this._instance = new e()), this._instance;
    }, e.prototype.setGlobalLoggerProvider = function(t) {
      return Zt[we] ? this.getLoggerProvider() : (Zt[we] = dl(Oi, t, ha), this._proxyLoggerProvider.setDelegate(t), t);
    }, e.prototype.getLoggerProvider = function() {
      var t, r;
      return (r = (t = Zt[we]) === null || t === void 0 ? void 0 : t.call(Zt, Oi)) !== null && r !== void 0 ? r : this._proxyLoggerProvider;
    }, e.prototype.getLogger = function(t, r, n) {
      return this.getLoggerProvider().getLogger(t, r, n);
    }, e.prototype.disable = function() {
      delete Zt[we], this._proxyLoggerProvider = new Si();
    }, e;
  }()
), me = pl.getInstance();
function hl(e, t, r, n) {
  for (var i = 0, o = e.length; i < o; i++) {
    var a = e[i];
    t && a.setTracerProvider(t), r && a.setMeterProvider(r), n && a.setLoggerProvider && a.setLoggerProvider(n), a.getConfig().enabled || a.enable();
  }
}
function _l(e) {
  e.forEach(function(t) {
    return t.disable();
  });
}
function vl(e) {
  var t, r, n = e.tracerProvider || b.getTracerProvider(), i = e.meterProvider || Vt.getMeterProvider(), o = e.loggerProvider || me.getLoggerProvider(), a = (r = (t = e.instrumentations) === null || t === void 0 ? void 0 : t.flat()) !== null && r !== void 0 ? r : [];
  return hl(a, n, i, o), function() {
    _l(a);
  };
}
function ln(e) {
  return typeof e == "function";
}
var H = console.error.bind(console);
function Qt(e, t, r) {
  var n = !!e[t] && e.propertyIsEnumerable(t);
  Object.defineProperty(e, t, {
    configurable: !0,
    enumerable: n,
    writable: !0,
    value: r
  });
}
function Te(e) {
  e && e.logger && (ln(e.logger) ? H = e.logger : H("new logger isn't a function, not replacing"));
}
function _a(e, t, r) {
  if (!e || !e[t]) {
    H("no original function " + t + " to wrap");
    return;
  }
  if (!r) {
    H("no wrapper function"), H(new Error().stack);
    return;
  }
  if (!ln(e[t]) || !ln(r)) {
    H("original object and wrapper must be functions");
    return;
  }
  var n = e[t], i = r(n, t);
  return Qt(i, "__original", n), Qt(i, "__unwrap", function() {
    e[t] === i && Qt(e, t, n);
  }), Qt(i, "__wrapped", !0), Qt(e, t, i), i;
}
function gl(e, t, r) {
  if (e)
    Array.isArray(e) || (e = [e]);
  else {
    H("must provide one or more modules to patch"), H(new Error().stack);
    return;
  }
  if (!(t && Array.isArray(t))) {
    H("must provide one or more functions to wrap on modules");
    return;
  }
  e.forEach(function(n) {
    t.forEach(function(i) {
      _a(n, i, r);
    });
  });
}
function va(e, t) {
  if (!e || !e[t]) {
    H("no function to unwrap."), H(new Error().stack);
    return;
  }
  if (!e[t].__unwrap)
    H("no original to unwrap to -- has " + t + " already been unwrapped?");
  else
    return e[t].__unwrap();
}
function El(e, t) {
  if (e)
    Array.isArray(e) || (e = [e]);
  else {
    H("must provide one or more modules to patch"), H(new Error().stack);
    return;
  }
  if (!(t && Array.isArray(t))) {
    H("must provide one or more functions to unwrap on modules");
    return;
  }
  e.forEach(function(r) {
    t.forEach(function(n) {
      va(r, n);
    });
  });
}
Te.wrap = _a;
Te.massWrap = gl;
Te.unwrap = va;
Te.massUnwrap = El;
var x = Te, dn = function() {
  return dn = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, dn.apply(this, arguments);
}, yl = (
  /** @class */
  function() {
    function e(t, r, n) {
      this.instrumentationName = t, this.instrumentationVersion = r, this._config = {}, this._wrap = x.wrap, this._unwrap = x.unwrap, this._massWrap = x.massWrap, this._massUnwrap = x.massUnwrap, this.setConfig(n), this._diag = v.createComponentLogger({
        namespace: t
      }), this._tracer = b.getTracer(t, r), this._meter = Vt.getMeter(t, r), this._logger = me.getLogger(t, r), this._updateMetricInstruments();
    }
    return Object.defineProperty(e.prototype, "meter", {
      /* Returns meter */
      get: function() {
        return this._meter;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.setMeterProvider = function(t) {
      this._meter = t.getMeter(this.instrumentationName, this.instrumentationVersion), this._updateMetricInstruments();
    }, Object.defineProperty(e.prototype, "logger", {
      /* Returns logger */
      get: function() {
        return this._logger;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.setLoggerProvider = function(t) {
      this._logger = t.getLogger(this.instrumentationName, this.instrumentationVersion);
    }, e.prototype.getModuleDefinitions = function() {
      var t, r = (t = this.init()) !== null && t !== void 0 ? t : [];
      return Array.isArray(r) ? r : [r];
    }, e.prototype._updateMetricInstruments = function() {
    }, e.prototype.getConfig = function() {
      return this._config;
    }, e.prototype.setConfig = function(t) {
      this._config = dn({ enabled: !0 }, t);
    }, e.prototype.setTracerProvider = function(t) {
      this._tracer = t.getTracer(this.instrumentationName, this.instrumentationVersion);
    }, Object.defineProperty(e.prototype, "tracer", {
      /* Returns tracer */
      get: function() {
        return this._tracer;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype._runSpanCustomizationHook = function(t, r, n, i) {
      if (t)
        try {
          t(n, i);
        } catch (o) {
          this._diag.error("Error running span customization hook due to exception in handler", { triggerName: r }, o);
        }
    }, e;
  }()
), ml = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), Tl = (
  /** @class */
  function(e) {
    ml(t, e);
    function t(r, n, i) {
      var o = e.call(this, r, n, i) || this;
      return o._config.enabled && o.enable(), o;
    }
    return t;
  }(yl)
);
function U(e) {
  return typeof e == "function" && typeof e.__original == "function" && typeof e.__unwrap == "function" && e.__wrapped === !0;
}
var Xe = performance, Sl = "traceparent", ga = Ee("OpenTelemetry SDK Context Key SUPPRESS_TRACING");
function Ol(e) {
  return e.setValue(ga, !0);
}
function $n(e) {
  return e.getValue(ga) === !0;
}
var Al = "=", pn = ";", hn = ",", Ir = "baggage", bl = 180, wl = 4096, Rl = 8192, Ll = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
};
function Pl(e) {
  return e.reduce(function(t, r) {
    var n = "" + t + (t !== "" ? hn : "") + r;
    return n.length > Rl ? t : n;
  }, "");
}
function Nl(e) {
  return e.getAllEntries().map(function(t) {
    var r = Ll(t, 2), n = r[0], i = r[1], o = encodeURIComponent(n) + "=" + encodeURIComponent(i.value);
    return i.metadata !== void 0 && (o += pn + i.metadata.toString()), o;
  });
}
function Il(e) {
  var t = e.split(pn);
  if (!(t.length <= 0)) {
    var r = t.shift();
    if (r) {
      var n = r.indexOf(Al);
      if (!(n <= 0)) {
        var i = decodeURIComponent(r.substring(0, n).trim()), o = decodeURIComponent(r.substring(n + 1).trim()), a;
        return t.length > 0 && (a = Ko(t.join(pn))), { key: i, value: o, metadata: a };
      }
    }
  }
}
var Cl = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.inject = function(t, r, n) {
      var i = k.getBaggage(t);
      if (!(!i || $n(t))) {
        var o = Nl(i).filter(function(u) {
          return u.length <= wl;
        }).slice(0, bl), a = Pl(o);
        a.length > 0 && n.set(r, Ir, a);
      }
    }, e.prototype.extract = function(t, r, n) {
      var i = n.get(r, Ir), o = Array.isArray(i) ? i.join(hn) : i;
      if (!o)
        return t;
      var a = {};
      if (o.length === 0)
        return t;
      var u = o.split(hn);
      return u.forEach(function(c) {
        var s = Il(c);
        if (s) {
          var f = { value: s.value };
          s.metadata && (f.metadata = s.metadata), a[s.key] = f;
        }
      }), Object.entries(a).length === 0 ? t : k.setBaggage(t, k.createBaggage(a));
    }, e.prototype.fields = function() {
      return [Ir];
    }, e;
  }()
), Ea = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Ml = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
};
function ke(e) {
  var t, r, n = {};
  if (typeof e != "object" || e == null)
    return n;
  try {
    for (var i = Ea(Object.entries(e)), o = i.next(); !o.done; o = i.next()) {
      var a = Ml(o.value, 2), u = a[0], c = a[1];
      if (!xl(u)) {
        v.warn("Invalid attribute key: " + u);
        continue;
      }
      if (!ya(c)) {
        v.warn("Invalid attribute value set for key: " + u);
        continue;
      }
      Array.isArray(c) ? n[u] = c.slice() : n[u] = c;
    }
  } catch (s) {
    t = { error: s };
  } finally {
    try {
      o && !o.done && (r = i.return) && r.call(i);
    } finally {
      if (t) throw t.error;
    }
  }
  return n;
}
function xl(e) {
  return typeof e == "string" && e.length > 0;
}
function ya(e) {
  return e == null ? !0 : Array.isArray(e) ? Dl(e) : ma(e);
}
function Dl(e) {
  var t, r, n;
  try {
    for (var i = Ea(e), o = i.next(); !o.done; o = i.next()) {
      var a = o.value;
      if (a != null) {
        if (!n) {
          if (ma(a)) {
            n = typeof a;
            continue;
          }
          return !1;
        }
        if (typeof a !== n)
          return !1;
      }
    }
  } catch (u) {
    t = { error: u };
  } finally {
    try {
      o && !o.done && (r = i.return) && r.call(i);
    } finally {
      if (t) throw t.error;
    }
  }
  return !0;
}
function ma(e) {
  switch (typeof e) {
    case "number":
    case "boolean":
    case "string":
      return !0;
  }
  return !1;
}
function Ul() {
  return function(e) {
    v.error(Bl(e));
  };
}
function Bl(e) {
  return typeof e == "string" ? e : JSON.stringify(kl(e));
}
function kl(e) {
  for (var t = {}, r = e; r !== null; )
    Object.getOwnPropertyNames(r).forEach(function(n) {
      if (!t[n]) {
        var i = r[n];
        i && (t[n] = String(i));
      }
    }), r = Object.getPrototypeOf(r);
  return t;
}
var Hl = Ul();
function Gt(e) {
  try {
    Hl(e);
  } catch (t) {
  }
}
var q;
(function(e) {
  e.AlwaysOff = "always_off", e.AlwaysOn = "always_on", e.ParentBasedAlwaysOff = "parentbased_always_off", e.ParentBasedAlwaysOn = "parentbased_always_on", e.ParentBasedTraceIdRatio = "parentbased_traceidratio", e.TraceIdRatio = "traceidratio";
})(q || (q = {}));
var Gl = ",", $l = ["OTEL_SDK_DISABLED"];
function jl(e) {
  return $l.indexOf(e) > -1;
}
var Vl = [
  "OTEL_BSP_EXPORT_TIMEOUT",
  "OTEL_BSP_MAX_EXPORT_BATCH_SIZE",
  "OTEL_BSP_MAX_QUEUE_SIZE",
  "OTEL_BSP_SCHEDULE_DELAY",
  "OTEL_BLRP_EXPORT_TIMEOUT",
  "OTEL_BLRP_MAX_EXPORT_BATCH_SIZE",
  "OTEL_BLRP_MAX_QUEUE_SIZE",
  "OTEL_BLRP_SCHEDULE_DELAY",
  "OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT",
  "OTEL_ATTRIBUTE_COUNT_LIMIT",
  "OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT",
  "OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT",
  "OTEL_LOGRECORD_ATTRIBUTE_VALUE_LENGTH_LIMIT",
  "OTEL_LOGRECORD_ATTRIBUTE_COUNT_LIMIT",
  "OTEL_SPAN_EVENT_COUNT_LIMIT",
  "OTEL_SPAN_LINK_COUNT_LIMIT",
  "OTEL_SPAN_ATTRIBUTE_PER_EVENT_COUNT_LIMIT",
  "OTEL_SPAN_ATTRIBUTE_PER_LINK_COUNT_LIMIT",
  "OTEL_EXPORTER_OTLP_TIMEOUT",
  "OTEL_EXPORTER_OTLP_TRACES_TIMEOUT",
  "OTEL_EXPORTER_OTLP_METRICS_TIMEOUT",
  "OTEL_EXPORTER_OTLP_LOGS_TIMEOUT",
  "OTEL_EXPORTER_JAEGER_AGENT_PORT"
];
function Fl(e) {
  return Vl.indexOf(e) > -1;
}
var Xl = [
  "OTEL_NO_PATCH_MODULES",
  "OTEL_PROPAGATORS",
  "OTEL_SEMCONV_STABILITY_OPT_IN"
];
function zl(e) {
  return Xl.indexOf(e) > -1;
}
var He = 1 / 0, Ge = 128, ql = 128, Wl = 128, Ta = {
  OTEL_SDK_DISABLED: !1,
  CONTAINER_NAME: "",
  ECS_CONTAINER_METADATA_URI_V4: "",
  ECS_CONTAINER_METADATA_URI: "",
  HOSTNAME: "",
  KUBERNETES_SERVICE_HOST: "",
  NAMESPACE: "",
  OTEL_BSP_EXPORT_TIMEOUT: 3e4,
  OTEL_BSP_MAX_EXPORT_BATCH_SIZE: 512,
  OTEL_BSP_MAX_QUEUE_SIZE: 2048,
  OTEL_BSP_SCHEDULE_DELAY: 5e3,
  OTEL_BLRP_EXPORT_TIMEOUT: 3e4,
  OTEL_BLRP_MAX_EXPORT_BATCH_SIZE: 512,
  OTEL_BLRP_MAX_QUEUE_SIZE: 2048,
  OTEL_BLRP_SCHEDULE_DELAY: 5e3,
  OTEL_EXPORTER_JAEGER_AGENT_HOST: "",
  OTEL_EXPORTER_JAEGER_AGENT_PORT: 6832,
  OTEL_EXPORTER_JAEGER_ENDPOINT: "",
  OTEL_EXPORTER_JAEGER_PASSWORD: "",
  OTEL_EXPORTER_JAEGER_USER: "",
  OTEL_EXPORTER_OTLP_ENDPOINT: "",
  OTEL_EXPORTER_OTLP_TRACES_ENDPOINT: "",
  OTEL_EXPORTER_OTLP_METRICS_ENDPOINT: "",
  OTEL_EXPORTER_OTLP_LOGS_ENDPOINT: "",
  OTEL_EXPORTER_OTLP_HEADERS: "",
  OTEL_EXPORTER_OTLP_TRACES_HEADERS: "",
  OTEL_EXPORTER_OTLP_METRICS_HEADERS: "",
  OTEL_EXPORTER_OTLP_LOGS_HEADERS: "",
  OTEL_EXPORTER_OTLP_TIMEOUT: 1e4,
  OTEL_EXPORTER_OTLP_TRACES_TIMEOUT: 1e4,
  OTEL_EXPORTER_OTLP_METRICS_TIMEOUT: 1e4,
  OTEL_EXPORTER_OTLP_LOGS_TIMEOUT: 1e4,
  OTEL_EXPORTER_ZIPKIN_ENDPOINT: "http://localhost:9411/api/v2/spans",
  OTEL_LOG_LEVEL: w.INFO,
  OTEL_NO_PATCH_MODULES: [],
  OTEL_PROPAGATORS: ["tracecontext", "baggage"],
  OTEL_RESOURCE_ATTRIBUTES: "",
  OTEL_SERVICE_NAME: "",
  OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT: He,
  OTEL_ATTRIBUTE_COUNT_LIMIT: Ge,
  OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT: He,
  OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT: Ge,
  OTEL_LOGRECORD_ATTRIBUTE_VALUE_LENGTH_LIMIT: He,
  OTEL_LOGRECORD_ATTRIBUTE_COUNT_LIMIT: Ge,
  OTEL_SPAN_EVENT_COUNT_LIMIT: 128,
  OTEL_SPAN_LINK_COUNT_LIMIT: 128,
  OTEL_SPAN_ATTRIBUTE_PER_EVENT_COUNT_LIMIT: ql,
  OTEL_SPAN_ATTRIBUTE_PER_LINK_COUNT_LIMIT: Wl,
  OTEL_TRACES_EXPORTER: "",
  OTEL_TRACES_SAMPLER: q.ParentBasedAlwaysOn,
  OTEL_TRACES_SAMPLER_ARG: "",
  OTEL_LOGS_EXPORTER: "",
  OTEL_EXPORTER_OTLP_INSECURE: "",
  OTEL_EXPORTER_OTLP_TRACES_INSECURE: "",
  OTEL_EXPORTER_OTLP_METRICS_INSECURE: "",
  OTEL_EXPORTER_OTLP_LOGS_INSECURE: "",
  OTEL_EXPORTER_OTLP_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_TRACES_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_METRICS_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_LOGS_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_COMPRESSION: "",
  OTEL_EXPORTER_OTLP_TRACES_COMPRESSION: "",
  OTEL_EXPORTER_OTLP_METRICS_COMPRESSION: "",
  OTEL_EXPORTER_OTLP_LOGS_COMPRESSION: "",
  OTEL_EXPORTER_OTLP_CLIENT_KEY: "",
  OTEL_EXPORTER_OTLP_TRACES_CLIENT_KEY: "",
  OTEL_EXPORTER_OTLP_METRICS_CLIENT_KEY: "",
  OTEL_EXPORTER_OTLP_LOGS_CLIENT_KEY: "",
  OTEL_EXPORTER_OTLP_CLIENT_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_TRACES_CLIENT_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_METRICS_CLIENT_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_LOGS_CLIENT_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_PROTOCOL: "http/protobuf",
  OTEL_EXPORTER_OTLP_TRACES_PROTOCOL: "http/protobuf",
  OTEL_EXPORTER_OTLP_METRICS_PROTOCOL: "http/protobuf",
  OTEL_EXPORTER_OTLP_LOGS_PROTOCOL: "http/protobuf",
  OTEL_EXPORTER_OTLP_METRICS_TEMPORALITY_PREFERENCE: "cumulative",
  OTEL_SEMCONV_STABILITY_OPT_IN: []
};
function Yl(e, t, r) {
  if (typeof r[e] != "undefined") {
    var n = String(r[e]);
    t[e] = n.toLowerCase() === "true";
  }
}
function Kl(e, t, r, n, i) {
  if (n === void 0 && (n = -1 / 0), i === void 0 && (i = 1 / 0), typeof r[e] != "undefined") {
    var o = Number(r[e]);
    isNaN(o) || (o < n ? t[e] = n : o > i ? t[e] = i : t[e] = o);
  }
}
function Jl(e, t, r, n) {
  n === void 0 && (n = Gl);
  var i = r[e];
  typeof i == "string" && (t[e] = i.split(n).map(function(o) {
    return o.trim();
  }));
}
var Zl = {
  ALL: w.ALL,
  VERBOSE: w.VERBOSE,
  DEBUG: w.DEBUG,
  INFO: w.INFO,
  WARN: w.WARN,
  ERROR: w.ERROR,
  NONE: w.NONE
};
function Ql(e, t, r) {
  var n = r[e];
  if (typeof n == "string") {
    var i = Zl[n.toUpperCase()];
    i != null && (t[e] = i);
  }
}
function Sa(e) {
  var t = {};
  for (var r in Ta) {
    var n = r;
    switch (n) {
      case "OTEL_LOG_LEVEL":
        Ql(n, t, e);
        break;
      default:
        if (jl(n))
          Yl(n, t, e);
        else if (Fl(n))
          Kl(n, t, e);
        else if (zl(n))
          Jl(n, t, e);
        else {
          var i = e[n];
          typeof i != "undefined" && i !== null && (t[n] = String(i));
        }
    }
  }
  return t;
}
var Oa = typeof globalThis == "object" ? globalThis : typeof self == "object" ? self : typeof window == "object" ? window : typeof global == "object" ? global : {};
function le() {
  var e = Sa(Oa);
  return Object.assign({}, Ta, e);
}
function td() {
  return Sa(Oa);
}
var Bt = performance, ed = "exception.type", rd = "exception.message", nd = "exception.stacktrace", id = "http.response_content_length", od = "http.response_content_length_uncompressed", Cr = ed, Mr = rd, ad = nd, sd = id, ud = od, cd = 9, fd = 6, ld = Math.pow(10, fd), ze = Math.pow(10, cd);
function ut(e) {
  var t = e / 1e3, r = Math.trunc(t), n = Math.round(e % 1e3 * ld);
  return [r, n];
}
function jn() {
  var e = Bt.timeOrigin;
  if (typeof e != "number") {
    var t = Bt;
    e = t.timing && t.timing.fetchStart;
  }
  return e;
}
function Aa(e) {
  var t = ut(jn()), r = ut(typeof e == "number" ? e : Bt.now());
  return ba(t, r);
}
function ie(e) {
  if (Vn(e))
    return e;
  if (typeof e == "number")
    return e < jn() ? Aa(e) : ut(e);
  if (e instanceof Date)
    return ut(e.getTime());
  throw TypeError("Invalid input type");
}
function dd(e, t) {
  var r = t[0] - e[0], n = t[1] - e[1];
  return n < 0 && (r -= 1, n += ze), [r, n];
}
function ct(e) {
  return e[0] * ze + e[1];
}
function Vn(e) {
  return Array.isArray(e) && e.length === 2 && typeof e[0] == "number" && typeof e[1] == "number";
}
function Ai(e) {
  return Vn(e) || typeof e == "number" || e instanceof Date;
}
function ba(e, t) {
  var r = [e[0] + t[0], e[1] + t[1]];
  return r[1] >= ze && (r[1] -= ze, r[0] += 1), r;
}
var _n;
(function(e) {
  e[e.SUCCESS = 0] = "SUCCESS", e[e.FAILED = 1] = "FAILED";
})(_n || (_n = {}));
var pd = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, hd = (
  /** @class */
  function() {
    function e(t) {
      t === void 0 && (t = {});
      var r;
      this._propagators = (r = t.propagators) !== null && r !== void 0 ? r : [], this._fields = Array.from(new Set(this._propagators.map(function(n) {
        return typeof n.fields == "function" ? n.fields() : [];
      }).reduce(function(n, i) {
        return n.concat(i);
      }, [])));
    }
    return e.prototype.inject = function(t, r, n) {
      var i, o;
      try {
        for (var a = pd(this._propagators), u = a.next(); !u.done; u = a.next()) {
          var c = u.value;
          try {
            c.inject(t, r, n);
          } catch (s) {
            v.warn("Failed to inject with " + c.constructor.name + ". Err: " + s.message);
          }
        }
      } catch (s) {
        i = { error: s };
      } finally {
        try {
          u && !u.done && (o = a.return) && o.call(a);
        } finally {
          if (i) throw i.error;
        }
      }
    }, e.prototype.extract = function(t, r, n) {
      return this._propagators.reduce(function(i, o) {
        try {
          return o.extract(i, r, n);
        } catch (a) {
          v.warn("Failed to extract with " + o.constructor.name + ". Err: " + a.message);
        }
        return i;
      }, t);
    }, e.prototype.fields = function() {
      return this._fields.slice();
    }, e;
  }()
), vn = "[_0-9a-z-*/]", _d = "[a-z]" + vn + "{0,255}", vd = "[a-z0-9]" + vn + "{0,240}@[a-z]" + vn + "{0,13}", gd = new RegExp("^(?:" + _d + "|" + vd + ")$"), Ed = /^[ -~]{0,255}[!-~]$/, yd = /,|=/;
function md(e) {
  return gd.test(e);
}
function Td(e) {
  return Ed.test(e) && !yd.test(e);
}
var bi = 32, Sd = 512, wi = ",", Ri = "=", Od = (
  /** @class */
  function() {
    function e(t) {
      this._internalState = /* @__PURE__ */ new Map(), t && this._parse(t);
    }
    return e.prototype.set = function(t, r) {
      var n = this._clone();
      return n._internalState.has(t) && n._internalState.delete(t), n._internalState.set(t, r), n;
    }, e.prototype.unset = function(t) {
      var r = this._clone();
      return r._internalState.delete(t), r;
    }, e.prototype.get = function(t) {
      return this._internalState.get(t);
    }, e.prototype.serialize = function() {
      var t = this;
      return this._keys().reduce(function(r, n) {
        return r.push(n + Ri + t.get(n)), r;
      }, []).join(wi);
    }, e.prototype._parse = function(t) {
      t.length > Sd || (this._internalState = t.split(wi).reverse().reduce(function(r, n) {
        var i = n.trim(), o = i.indexOf(Ri);
        if (o !== -1) {
          var a = i.slice(0, o), u = i.slice(o + 1, n.length);
          md(a) && Td(u) && r.set(a, u);
        }
        return r;
      }, /* @__PURE__ */ new Map()), this._internalState.size > bi && (this._internalState = new Map(Array.from(this._internalState.entries()).reverse().slice(0, bi))));
    }, e.prototype._keys = function() {
      return Array.from(this._internalState.keys()).reverse();
    }, e.prototype._clone = function() {
      var t = new e();
      return t._internalState = new Map(this._internalState), t;
    }, e;
  }()
), xr = "traceparent", Dr = "tracestate", Ad = "00", bd = "(?!ff)[\\da-f]{2}", wd = "(?![0]{32})[\\da-f]{32}", Rd = "(?![0]{16})[\\da-f]{16}", Ld = "[\\da-f]{2}", Pd = new RegExp("^\\s?(" + bd + ")-(" + wd + ")-(" + Rd + ")-(" + Ld + ")(-.*)?\\s?$");
function Nd(e) {
  var t = Pd.exec(e);
  return !t || t[1] === "00" && t[5] ? null : {
    traceId: t[2],
    spanId: t[3],
    traceFlags: parseInt(t[4], 16)
  };
}
var Id = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.inject = function(t, r, n) {
      var i = b.getSpanContext(t);
      if (!(!i || $n(t) || !ye(i))) {
        var o = Ad + "-" + i.traceId + "-" + i.spanId + "-0" + Number(i.traceFlags || J.NONE).toString(16);
        n.set(r, xr, o), i.traceState && n.set(r, Dr, i.traceState.serialize());
      }
    }, e.prototype.extract = function(t, r, n) {
      var i = n.get(r, xr);
      if (!i)
        return t;
      var o = Array.isArray(i) ? i[0] : i;
      if (typeof o != "string")
        return t;
      var a = Nd(o);
      if (!a)
        return t;
      a.isRemote = !0;
      var u = n.get(r, Dr);
      if (u) {
        var c = Array.isArray(u) ? u.join(",") : u;
        a.traceState = new Od(typeof c == "string" ? c : void 0);
      }
      return b.setSpanContext(t, a);
    }, e.prototype.fields = function() {
      return [xr, Dr];
    }, e;
  }()
), Cd = "[object Object]", Md = "[object Null]", xd = "[object Undefined]", Dd = Function.prototype, wa = Dd.toString, Ud = wa.call(Object), Bd = kd(Object.getPrototypeOf, Object), Ra = Object.prototype, La = Ra.hasOwnProperty, _t = Symbol ? Symbol.toStringTag : void 0, Pa = Ra.toString;
function kd(e, t) {
  return function(r) {
    return e(t(r));
  };
}
function Li(e) {
  if (!Hd(e) || Gd(e) !== Cd)
    return !1;
  var t = Bd(e);
  if (t === null)
    return !0;
  var r = La.call(t, "constructor") && t.constructor;
  return typeof r == "function" && r instanceof r && wa.call(r) === Ud;
}
function Hd(e) {
  return e != null && typeof e == "object";
}
function Gd(e) {
  return e == null ? e === void 0 ? xd : Md : _t && _t in Object(e) ? $d(e) : jd(e);
}
function $d(e) {
  var t = La.call(e, _t), r = e[_t], n = !1;
  try {
    e[_t] = void 0, n = !0;
  } catch (o) {
  }
  var i = Pa.call(e);
  return n && (t ? e[_t] = r : delete e[_t]), i;
}
function jd(e) {
  return Pa.call(e);
}
var Vd = 20;
function Fd() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  for (var r = e.shift(), n = /* @__PURE__ */ new WeakMap(); e.length > 0; )
    r = Na(r, e.shift(), 0, n);
  return r;
}
function Ur(e) {
  return qe(e) ? e.slice() : e;
}
function Na(e, t, r, n) {
  r === void 0 && (r = 0);
  var i;
  if (!(r > Vd)) {
    if (r++, $e(e) || $e(t) || Ia(t))
      i = Ur(t);
    else if (qe(e)) {
      if (i = e.slice(), qe(t))
        for (var o = 0, a = t.length; o < a; o++)
          i.push(Ur(t[o]));
      else if (te(t))
        for (var u = Object.keys(t), o = 0, a = u.length; o < a; o++) {
          var c = u[o];
          i[c] = Ur(t[c]);
        }
    } else if (te(e))
      if (te(t)) {
        if (!Xd(e, t))
          return t;
        i = Object.assign({}, e);
        for (var u = Object.keys(t), o = 0, a = u.length; o < a; o++) {
          var c = u[o], s = t[c];
          if ($e(s))
            typeof s == "undefined" ? delete i[c] : i[c] = s;
          else {
            var f = i[c], l = s;
            if (Pi(e, c, n) || Pi(t, c, n))
              delete i[c];
            else {
              if (te(f) && te(l)) {
                var d = n.get(f) || [], h = n.get(l) || [];
                d.push({ obj: e, key: c }), h.push({ obj: t, key: c }), n.set(f, d), n.set(l, h);
              }
              i[c] = Na(i[c], s, r, n);
            }
          }
        }
      } else
        i = t;
    return i;
  }
}
function Pi(e, t, r) {
  for (var n = r.get(e[t]) || [], i = 0, o = n.length; i < o; i++) {
    var a = n[i];
    if (a.key === t && a.obj === e)
      return !0;
  }
  return !1;
}
function qe(e) {
  return Array.isArray(e);
}
function Ia(e) {
  return typeof e == "function";
}
function te(e) {
  return !$e(e) && !qe(e) && !Ia(e) && typeof e == "object";
}
function $e(e) {
  return typeof e == "string" || typeof e == "number" || typeof e == "boolean" || typeof e == "undefined" || e instanceof Date || e instanceof RegExp || e === null;
}
function Xd(e, t) {
  return !(!Li(e) || !Li(t));
}
function zd(e, t) {
  return typeof t == "string" ? e === t : !!e.match(t);
}
var qd = (
  /** @class */
  function() {
    function e() {
      var t = this;
      this._promise = new Promise(function(r, n) {
        t._resolve = r, t._reject = n;
      });
    }
    return Object.defineProperty(e.prototype, "promise", {
      get: function() {
        return this._promise;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.resolve = function(t) {
      this._resolve(t);
    }, e.prototype.reject = function(t) {
      this._reject(t);
    }, e;
  }()
), Wd = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Yd = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, Kd = (
  /** @class */
  function() {
    function e(t, r) {
      this._callback = t, this._that = r, this._isCalled = !1, this._deferred = new qd();
    }
    return Object.defineProperty(e.prototype, "isCalled", {
      get: function() {
        return this._isCalled;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "promise", {
      get: function() {
        return this._deferred.promise;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.call = function() {
      for (var t, r = this, n = [], i = 0; i < arguments.length; i++)
        n[i] = arguments[i];
      if (!this._isCalled) {
        this._isCalled = !0;
        try {
          Promise.resolve((t = this._callback).call.apply(t, Yd([this._that], Wd(n), !1))).then(function(o) {
            return r._deferred.resolve(o);
          }, function(o) {
            return r._deferred.reject(o);
          });
        } catch (o) {
          this._deferred.reject(o);
        }
      }
      return this._deferred.promise;
    }, e;
  }()
), Jd = "exception", gn = function() {
  return gn = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, gn.apply(this, arguments);
}, Zd = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Ni = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Qd = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, tp = (
  /** @class */
  function() {
    function e(t, r, n, i, o, a, u, c, s, f) {
      u === void 0 && (u = []), this.attributes = {}, this.links = [], this.events = [], this._droppedAttributesCount = 0, this._droppedEventsCount = 0, this._droppedLinksCount = 0, this.status = {
        code: Ve.UNSET
      }, this.endTime = [0, 0], this._ended = !1, this._duration = [-1, -1], this.name = n, this._spanContext = i, this.parentSpanId = a, this.kind = o, this.links = u;
      var l = Date.now();
      this._performanceStartTime = Bt.now(), this._performanceOffset = l - (this._performanceStartTime + jn()), this._startTimeProvided = c != null, this.startTime = this._getTime(c != null ? c : l), this.resource = t.resource, this.instrumentationLibrary = t.instrumentationLibrary, this._spanLimits = t.getSpanLimits(), this._attributeValueLengthLimit = this._spanLimits.attributeValueLengthLimit || 0, f != null && this.setAttributes(f), this._spanProcessor = t.getActiveSpanProcessor(), this._spanProcessor.onStart(this, r);
    }
    return e.prototype.spanContext = function() {
      return this._spanContext;
    }, e.prototype.setAttribute = function(t, r) {
      return r == null || this._isSpanEnded() ? this : t.length === 0 ? (v.warn("Invalid attribute key: " + t), this) : ya(r) ? Object.keys(this.attributes).length >= this._spanLimits.attributeCountLimit && !Object.prototype.hasOwnProperty.call(this.attributes, t) ? (this._droppedAttributesCount++, this) : (this.attributes[t] = this._truncateToSize(r), this) : (v.warn("Invalid attribute value set for key: " + t), this);
    }, e.prototype.setAttributes = function(t) {
      var r, n;
      try {
        for (var i = Zd(Object.entries(t)), o = i.next(); !o.done; o = i.next()) {
          var a = Ni(o.value, 2), u = a[0], c = a[1];
          this.setAttribute(u, c);
        }
      } catch (s) {
        r = { error: s };
      } finally {
        try {
          o && !o.done && (n = i.return) && n.call(i);
        } finally {
          if (r) throw r.error;
        }
      }
      return this;
    }, e.prototype.addEvent = function(t, r, n) {
      if (this._isSpanEnded())
        return this;
      if (this._spanLimits.eventCountLimit === 0)
        return v.warn("No events allowed."), this._droppedEventsCount++, this;
      this.events.length >= this._spanLimits.eventCountLimit && (this._droppedEventsCount === 0 && v.debug("Dropping extra events."), this.events.shift(), this._droppedEventsCount++), Ai(r) && (Ai(n) || (n = r), r = void 0);
      var i = ke(r);
      return this.events.push({
        name: t,
        attributes: i,
        time: this._getTime(n),
        droppedAttributesCount: 0
      }), this;
    }, e.prototype.addLink = function(t) {
      return this.links.push(t), this;
    }, e.prototype.addLinks = function(t) {
      var r;
      return (r = this.links).push.apply(r, Qd([], Ni(t), !1)), this;
    }, e.prototype.setStatus = function(t) {
      return this._isSpanEnded() ? this : (this.status = gn({}, t), this.status.message != null && typeof t.message != "string" && (v.warn("Dropping invalid status.message of type '" + typeof t.message + "', expected 'string'"), delete this.status.message), this);
    }, e.prototype.updateName = function(t) {
      return this._isSpanEnded() ? this : (this.name = t, this);
    }, e.prototype.end = function(t) {
      if (this._isSpanEnded()) {
        v.error(this.name + " " + this._spanContext.traceId + "-" + this._spanContext.spanId + " - You can only call end() on a span once.");
        return;
      }
      this._ended = !0, this.endTime = this._getTime(t), this._duration = dd(this.startTime, this.endTime), this._duration[0] < 0 && (v.warn("Inconsistent start and end time, startTime > endTime. Setting span duration to 0ms.", this.startTime, this.endTime), this.endTime = this.startTime.slice(), this._duration = [0, 0]), this._droppedEventsCount > 0 && v.warn("Dropped " + this._droppedEventsCount + " events because eventCountLimit reached"), this._spanProcessor.onEnd(this);
    }, e.prototype._getTime = function(t) {
      if (typeof t == "number" && t <= Bt.now())
        return Aa(t + this._performanceOffset);
      if (typeof t == "number")
        return ut(t);
      if (t instanceof Date)
        return ut(t.getTime());
      if (Vn(t))
        return t;
      if (this._startTimeProvided)
        return ut(Date.now());
      var r = Bt.now() - this._performanceStartTime;
      return ba(this.startTime, ut(r));
    }, e.prototype.isRecording = function() {
      return this._ended === !1;
    }, e.prototype.recordException = function(t, r) {
      var n = {};
      typeof t == "string" ? n[Mr] = t : t && (t.code ? n[Cr] = t.code.toString() : t.name && (n[Cr] = t.name), t.message && (n[Mr] = t.message), t.stack && (n[ad] = t.stack)), n[Cr] || n[Mr] ? this.addEvent(Jd, n, r) : v.warn("Failed to record an exception " + t);
    }, Object.defineProperty(e.prototype, "duration", {
      get: function() {
        return this._duration;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "ended", {
      get: function() {
        return this._ended;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "droppedAttributesCount", {
      get: function() {
        return this._droppedAttributesCount;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "droppedEventsCount", {
      get: function() {
        return this._droppedEventsCount;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "droppedLinksCount", {
      get: function() {
        return this._droppedLinksCount;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype._isSpanEnded = function() {
      return this._ended && v.warn("Can not execute the operation on ended Span {traceId: " + this._spanContext.traceId + ", spanId: " + this._spanContext.spanId + "}"), this._ended;
    }, e.prototype._truncateToLimitUtil = function(t, r) {
      return t.length <= r ? t : t.substring(0, r);
    }, e.prototype._truncateToSize = function(t) {
      var r = this, n = this._attributeValueLengthLimit;
      return n <= 0 ? (v.warn("Attribute value limit must be positive, got " + n), t) : typeof t == "string" ? this._truncateToLimitUtil(t, n) : Array.isArray(t) ? t.map(function(i) {
        return typeof i == "string" ? r._truncateToLimitUtil(i, n) : i;
      }) : t;
    }, e;
  }()
), $t;
(function(e) {
  e[e.NOT_RECORD = 0] = "NOT_RECORD", e[e.RECORD = 1] = "RECORD", e[e.RECORD_AND_SAMPLED = 2] = "RECORD_AND_SAMPLED";
})($t || ($t = {}));
var We = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.shouldSample = function() {
      return {
        decision: $t.NOT_RECORD
      };
    }, e.prototype.toString = function() {
      return "AlwaysOffSampler";
    }, e;
  }()
), kt = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.shouldSample = function() {
      return {
        decision: $t.RECORD_AND_SAMPLED
      };
    }, e.prototype.toString = function() {
      return "AlwaysOnSampler";
    }, e;
  }()
), Br = (
  /** @class */
  function() {
    function e(t) {
      var r, n, i, o;
      this._root = t.root, this._root || (Gt(new Error("ParentBasedSampler must have a root sampler configured")), this._root = new kt()), this._remoteParentSampled = (r = t.remoteParentSampled) !== null && r !== void 0 ? r : new kt(), this._remoteParentNotSampled = (n = t.remoteParentNotSampled) !== null && n !== void 0 ? n : new We(), this._localParentSampled = (i = t.localParentSampled) !== null && i !== void 0 ? i : new kt(), this._localParentNotSampled = (o = t.localParentNotSampled) !== null && o !== void 0 ? o : new We();
    }
    return e.prototype.shouldSample = function(t, r, n, i, o, a) {
      var u = b.getSpanContext(t);
      return !u || !ye(u) ? this._root.shouldSample(t, r, n, i, o, a) : u.isRemote ? u.traceFlags & J.SAMPLED ? this._remoteParentSampled.shouldSample(t, r, n, i, o, a) : this._remoteParentNotSampled.shouldSample(t, r, n, i, o, a) : u.traceFlags & J.SAMPLED ? this._localParentSampled.shouldSample(t, r, n, i, o, a) : this._localParentNotSampled.shouldSample(t, r, n, i, o, a);
    }, e.prototype.toString = function() {
      return "ParentBased{root=" + this._root.toString() + ", remoteParentSampled=" + this._remoteParentSampled.toString() + ", remoteParentNotSampled=" + this._remoteParentNotSampled.toString() + ", localParentSampled=" + this._localParentSampled.toString() + ", localParentNotSampled=" + this._localParentNotSampled.toString() + "}";
    }, e;
  }()
), Ii = (
  /** @class */
  function() {
    function e(t) {
      t === void 0 && (t = 0), this._ratio = t, this._ratio = this._normalize(t), this._upperBound = Math.floor(this._ratio * 4294967295);
    }
    return e.prototype.shouldSample = function(t, r) {
      return {
        decision: ra(r) && this._accumulate(r) < this._upperBound ? $t.RECORD_AND_SAMPLED : $t.NOT_RECORD
      };
    }, e.prototype.toString = function() {
      return "TraceIdRatioBased{" + this._ratio + "}";
    }, e.prototype._normalize = function(t) {
      return typeof t != "number" || isNaN(t) ? 0 : t >= 1 ? 1 : t <= 0 ? 0 : t;
    }, e.prototype._accumulate = function(t) {
      for (var r = 0, n = 0; n < t.length / 8; n++) {
        var i = n * 8, o = parseInt(t.slice(i, i + 8), 16);
        r = (r ^ o) >>> 0;
      }
      return r;
    }, e;
  }()
), ep = q.AlwaysOn, Ct = 1;
function Ca() {
  var e = le();
  return {
    sampler: Ma(e),
    forceFlushTimeoutMillis: 3e4,
    generalLimits: {
      attributeValueLengthLimit: e.OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT,
      attributeCountLimit: e.OTEL_ATTRIBUTE_COUNT_LIMIT
    },
    spanLimits: {
      attributeValueLengthLimit: e.OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT,
      attributeCountLimit: e.OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT,
      linkCountLimit: e.OTEL_SPAN_LINK_COUNT_LIMIT,
      eventCountLimit: e.OTEL_SPAN_EVENT_COUNT_LIMIT,
      attributePerEventCountLimit: e.OTEL_SPAN_ATTRIBUTE_PER_EVENT_COUNT_LIMIT,
      attributePerLinkCountLimit: e.OTEL_SPAN_ATTRIBUTE_PER_LINK_COUNT_LIMIT
    },
    mergeResourceWithDefaults: !0
  };
}
function Ma(e) {
  switch (e === void 0 && (e = le()), e.OTEL_TRACES_SAMPLER) {
    case q.AlwaysOn:
      return new kt();
    case q.AlwaysOff:
      return new We();
    case q.ParentBasedAlwaysOn:
      return new Br({
        root: new kt()
      });
    case q.ParentBasedAlwaysOff:
      return new Br({
        root: new We()
      });
    case q.TraceIdRatio:
      return new Ii(Ci(e));
    case q.ParentBasedTraceIdRatio:
      return new Br({
        root: new Ii(Ci(e))
      });
    default:
      return v.error('OTEL_TRACES_SAMPLER value "' + e.OTEL_TRACES_SAMPLER + " invalid, defaulting to " + ep + '".'), new kt();
  }
}
function Ci(e) {
  if (e.OTEL_TRACES_SAMPLER_ARG === void 0 || e.OTEL_TRACES_SAMPLER_ARG === "")
    return v.error("OTEL_TRACES_SAMPLER_ARG is blank, defaulting to " + Ct + "."), Ct;
  var t = Number(e.OTEL_TRACES_SAMPLER_ARG);
  return isNaN(t) ? (v.error("OTEL_TRACES_SAMPLER_ARG=" + e.OTEL_TRACES_SAMPLER_ARG + " was given, but it is invalid, defaulting to " + Ct + "."), Ct) : t < 0 || t > 1 ? (v.error("OTEL_TRACES_SAMPLER_ARG=" + e.OTEL_TRACES_SAMPLER_ARG + " was given, but it is out of range ([0..1]), defaulting to " + Ct + "."), Ct) : t;
}
function rp(e) {
  var t = {
    sampler: Ma()
  }, r = Ca(), n = Object.assign({}, r, t, e);
  return n.generalLimits = Object.assign({}, r.generalLimits, e.generalLimits || {}), n.spanLimits = Object.assign({}, r.spanLimits, e.spanLimits || {}), n;
}
function np(e) {
  var t, r, n, i, o, a, u, c, s, f, l, d, h = Object.assign({}, e.spanLimits), _ = td();
  return h.attributeCountLimit = (a = (o = (i = (r = (t = e.spanLimits) === null || t === void 0 ? void 0 : t.attributeCountLimit) !== null && r !== void 0 ? r : (n = e.generalLimits) === null || n === void 0 ? void 0 : n.attributeCountLimit) !== null && i !== void 0 ? i : _.OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT) !== null && o !== void 0 ? o : _.OTEL_ATTRIBUTE_COUNT_LIMIT) !== null && a !== void 0 ? a : Ge, h.attributeValueLengthLimit = (d = (l = (f = (c = (u = e.spanLimits) === null || u === void 0 ? void 0 : u.attributeValueLengthLimit) !== null && c !== void 0 ? c : (s = e.generalLimits) === null || s === void 0 ? void 0 : s.attributeValueLengthLimit) !== null && f !== void 0 ? f : _.OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT) !== null && l !== void 0 ? l : _.OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT) !== null && d !== void 0 ? d : He, Object.assign({}, e, { spanLimits: h });
}
var ip = (
  /** @class */
  function() {
    function e(t, r) {
      this._exporter = t, this._isExporting = !1, this._finishedSpans = [], this._droppedSpansCount = 0;
      var n = le();
      this._maxExportBatchSize = typeof (r == null ? void 0 : r.maxExportBatchSize) == "number" ? r.maxExportBatchSize : n.OTEL_BSP_MAX_EXPORT_BATCH_SIZE, this._maxQueueSize = typeof (r == null ? void 0 : r.maxQueueSize) == "number" ? r.maxQueueSize : n.OTEL_BSP_MAX_QUEUE_SIZE, this._scheduledDelayMillis = typeof (r == null ? void 0 : r.scheduledDelayMillis) == "number" ? r.scheduledDelayMillis : n.OTEL_BSP_SCHEDULE_DELAY, this._exportTimeoutMillis = typeof (r == null ? void 0 : r.exportTimeoutMillis) == "number" ? r.exportTimeoutMillis : n.OTEL_BSP_EXPORT_TIMEOUT, this._shutdownOnce = new Kd(this._shutdown, this), this._maxExportBatchSize > this._maxQueueSize && (v.warn("BatchSpanProcessor: maxExportBatchSize must be smaller or equal to maxQueueSize, setting maxExportBatchSize to match maxQueueSize"), this._maxExportBatchSize = this._maxQueueSize);
    }
    return e.prototype.forceFlush = function() {
      return this._shutdownOnce.isCalled ? this._shutdownOnce.promise : this._flushAll();
    }, e.prototype.onStart = function(t, r) {
    }, e.prototype.onEnd = function(t) {
      this._shutdownOnce.isCalled || (t.spanContext().traceFlags & J.SAMPLED) !== 0 && this._addToBuffer(t);
    }, e.prototype.shutdown = function() {
      return this._shutdownOnce.call();
    }, e.prototype._shutdown = function() {
      var t = this;
      return Promise.resolve().then(function() {
        return t.onShutdown();
      }).then(function() {
        return t._flushAll();
      }).then(function() {
        return t._exporter.shutdown();
      });
    }, e.prototype._addToBuffer = function(t) {
      if (this._finishedSpans.length >= this._maxQueueSize) {
        this._droppedSpansCount === 0 && v.debug("maxQueueSize reached, dropping spans"), this._droppedSpansCount++;
        return;
      }
      this._droppedSpansCount > 0 && (v.warn("Dropped " + this._droppedSpansCount + " spans because maxQueueSize reached"), this._droppedSpansCount = 0), this._finishedSpans.push(t), this._maybeStartTimer();
    }, e.prototype._flushAll = function() {
      var t = this;
      return new Promise(function(r, n) {
        for (var i = [], o = Math.ceil(t._finishedSpans.length / t._maxExportBatchSize), a = 0, u = o; a < u; a++)
          i.push(t._flushOneBatch());
        Promise.all(i).then(function() {
          r();
        }).catch(n);
      });
    }, e.prototype._flushOneBatch = function() {
      var t = this;
      return this._clearTimer(), this._finishedSpans.length === 0 ? Promise.resolve() : new Promise(function(r, n) {
        var i = setTimeout(function() {
          n(new Error("Timeout"));
        }, t._exportTimeoutMillis);
        O.with(Ol(O.active()), function() {
          var o;
          t._finishedSpans.length <= t._maxExportBatchSize ? (o = t._finishedSpans, t._finishedSpans = []) : o = t._finishedSpans.splice(0, t._maxExportBatchSize);
          for (var a = function() {
            return t._exporter.export(o, function(l) {
              var d;
              clearTimeout(i), l.code === _n.SUCCESS ? r() : n((d = l.error) !== null && d !== void 0 ? d : new Error("BatchSpanProcessor: span export failed"));
            });
          }, u = null, c = 0, s = o.length; c < s; c++) {
            var f = o[c];
            f.resource.asyncAttributesPending && f.resource.waitForAsyncAttributes && (u != null || (u = []), u.push(f.resource.waitForAsyncAttributes()));
          }
          u === null ? a() : Promise.all(u).then(a, function(l) {
            Gt(l), n(l);
          });
        });
      });
    }, e.prototype._maybeStartTimer = function() {
      var t = this;
      if (!this._isExporting) {
        var r = function() {
          t._isExporting = !0, t._flushOneBatch().finally(function() {
            t._isExporting = !1, t._finishedSpans.length > 0 && (t._clearTimer(), t._maybeStartTimer());
          }).catch(function(n) {
            t._isExporting = !1, Gt(n);
          });
        };
        if (this._finishedSpans.length >= this._maxExportBatchSize)
          return r();
        this._timer === void 0 && (this._timer = setTimeout(function() {
          return r();
        }, this._scheduledDelayMillis));
      }
    }, e.prototype._clearTimer = function() {
      this._timer !== void 0 && (clearTimeout(this._timer), this._timer = void 0);
    }, e;
  }()
), op = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), xa = (
  /** @class */
  function(e) {
    op(t, e);
    function t(r, n) {
      var i = e.call(this, r, n) || this;
      return i.onInit(n), i;
    }
    return t.prototype.onInit = function(r) {
      var n = this;
      (r == null ? void 0 : r.disableAutoFlushOnDocumentHide) !== !0 && typeof document != "undefined" && (this._visibilityChangeListener = function() {
        document.visibilityState === "hidden" && n.forceFlush().catch(function(i) {
          Gt(i);
        });
      }, this._pageHideListener = function() {
        n.forceFlush().catch(function(i) {
          Gt(i);
        });
      }, document.addEventListener("visibilitychange", this._visibilityChangeListener), document.addEventListener("pagehide", this._pageHideListener));
    }, t.prototype.onShutdown = function() {
      typeof document != "undefined" && (this._visibilityChangeListener && document.removeEventListener("visibilitychange", this._visibilityChangeListener), this._pageHideListener && document.removeEventListener("pagehide", this._pageHideListener));
    }, t;
  }(ip)
), ap = 8, sp = 16, up = (
  /** @class */
  /* @__PURE__ */ function() {
    function e() {
      this.generateTraceId = Mi(sp), this.generateSpanId = Mi(ap);
    }
    return e;
  }()
), Re = Array(32);
function Mi(e) {
  return function() {
    for (var r = 0; r < e * 2; r++)
      Re[r] = Math.floor(Math.random() * 16) + 48, Re[r] >= 58 && (Re[r] += 39);
    return String.fromCharCode.apply(null, Re.slice(0, e * 2));
  };
}
var cp = (
  /** @class */
  function() {
    function e(t, r, n) {
      this._tracerProvider = n;
      var i = rp(r);
      this._sampler = i.sampler, this._generalLimits = i.generalLimits, this._spanLimits = i.spanLimits, this._idGenerator = r.idGenerator || new up(), this.resource = n.resource, this.instrumentationLibrary = t;
    }
    return e.prototype.startSpan = function(t, r, n) {
      var i, o, a;
      r === void 0 && (r = {}), n === void 0 && (n = O.active()), r.root && (n = b.deleteSpan(n));
      var u = b.getSpan(n);
      if ($n(n)) {
        v.debug("Instrumentation suppressed, returning Noop Span");
        var c = b.wrapSpanContext(ta);
        return c;
      }
      var s = u == null ? void 0 : u.spanContext(), f = this._idGenerator.generateSpanId(), l, d, h;
      !s || !b.isSpanContextValid(s) ? l = this._idGenerator.generateTraceId() : (l = s.traceId, d = s.traceState, h = s.spanId);
      var _ = (i = r.kind) !== null && i !== void 0 ? i : fe.INTERNAL, p = ((o = r.links) !== null && o !== void 0 ? o : []).map(function(C) {
        return {
          context: C.context,
          attributes: ke(C.attributes)
        };
      }), g = ke(r.attributes), E = this._sampler.shouldSample(n, l, t, _, g, p);
      d = (a = E.traceState) !== null && a !== void 0 ? a : d;
      var y = E.decision === je.RECORD_AND_SAMPLED ? J.SAMPLED : J.NONE, A = { traceId: l, spanId: f, traceFlags: y, traceState: d };
      if (E.decision === je.NOT_RECORD) {
        v.debug("Recording is off, propagating context in a non-recording span");
        var c = b.wrapSpanContext(A);
        return c;
      }
      var L = ke(Object.assign(g, E.attributes)), P = new tp(this, n, t, A, _, h, p, r.startTime, void 0, L);
      return P;
    }, e.prototype.startActiveSpan = function(t, r, n, i) {
      var o, a, u;
      if (!(arguments.length < 2)) {
        arguments.length === 2 ? u = r : arguments.length === 3 ? (o = r, u = n) : (o = r, a = n, u = i);
        var c = a != null ? a : O.active(), s = this.startSpan(t, o, c), f = b.setSpan(c, s);
        return O.with(f, u, void 0, s);
      }
    }, e.prototype.getGeneralLimits = function() {
      return this._generalLimits;
    }, e.prototype.getSpanLimits = function() {
      return this._spanLimits;
    }, e.prototype.getActiveSpanProcessor = function() {
      return this._tracerProvider.getActiveSpanProcessor();
    }, e;
  }()
), fp = "process.runtime.name", lp = "service.name", dp = "telemetry.sdk.name", pp = "telemetry.sdk.language", hp = "telemetry.sdk.version", _p = fp, vp = lp, En = dp, yn = pp, mn = hp, gp = "webjs", Ep = gp, yp = "1.30.1", Mt, kr = (Mt = {}, Mt[En] = "opentelemetry", Mt[_p] = "browser", Mt[yn] = Ep, Mt[mn] = yp, Mt);
function mp() {
  return "unknown_service";
}
var at = function() {
  return at = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, at.apply(this, arguments);
}, Tp = function(e, t, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function u(f) {
      try {
        s(n.next(f));
      } catch (l) {
        a(l);
      }
    }
    function c(f) {
      try {
        s(n.throw(f));
      } catch (l) {
        a(l);
      }
    }
    function s(f) {
      f.done ? o(f.value) : i(f.value).then(u, c);
    }
    s((n = n.apply(e, t || [])).next());
  });
}, Sp = function(e, t) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(f) {
      return c([s, f]);
    };
  }
  function c(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return r.label++, { value: s[1], done: !1 };
        case 5:
          r.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            r = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            r.label = s[1];
            break;
          }
          if (s[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = s;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(s);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      s = t.call(e, r);
    } catch (f) {
      s = [6, f], i = 0;
    } finally {
      n = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, Op = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, de = (
  /** @class */
  function() {
    function e(t, r) {
      var n = this, i;
      this._attributes = t, this.asyncAttributesPending = r != null, this._syncAttributes = (i = this._attributes) !== null && i !== void 0 ? i : {}, this._asyncAttributesPromise = r == null ? void 0 : r.then(function(o) {
        return n._attributes = Object.assign({}, n._attributes, o), n.asyncAttributesPending = !1, o;
      }, function(o) {
        return v.debug("a resource's async attributes promise rejected: %s", o), n.asyncAttributesPending = !1, {};
      });
    }
    return e.empty = function() {
      return e.EMPTY;
    }, e.default = function() {
      var t;
      return new e((t = {}, t[vp] = mp(), t[yn] = kr[yn], t[En] = kr[En], t[mn] = kr[mn], t));
    }, Object.defineProperty(e.prototype, "attributes", {
      get: function() {
        var t;
        return this.asyncAttributesPending && v.error("Accessing resource attributes before async attributes settled"), (t = this._attributes) !== null && t !== void 0 ? t : {};
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.waitForAsyncAttributes = function() {
      return Tp(this, void 0, void 0, function() {
        return Sp(this, function(t) {
          switch (t.label) {
            case 0:
              return this.asyncAttributesPending ? [4, this._asyncAttributesPromise] : [3, 2];
            case 1:
              t.sent(), t.label = 2;
            case 2:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.merge = function(t) {
      var r = this, n;
      if (!t)
        return this;
      var i = at(at({}, this._syncAttributes), (n = t._syncAttributes) !== null && n !== void 0 ? n : t.attributes);
      if (!this._asyncAttributesPromise && !t._asyncAttributesPromise)
        return new e(i);
      var o = Promise.all([
        this._asyncAttributesPromise,
        t._asyncAttributesPromise
      ]).then(function(a) {
        var u, c = Op(a, 2), s = c[0], f = c[1];
        return at(at(at(at({}, r._syncAttributes), s), (u = t._syncAttributes) !== null && u !== void 0 ? u : t.attributes), f);
      });
      return new e(i, o);
    }, e.EMPTY = new e({}), e;
  }()
), Le = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, xi = (
  /** @class */
  function() {
    function e(t) {
      this._spanProcessors = t;
    }
    return e.prototype.forceFlush = function() {
      var t, r, n = [];
      try {
        for (var i = Le(this._spanProcessors), o = i.next(); !o.done; o = i.next()) {
          var a = o.value;
          n.push(a.forceFlush());
        }
      } catch (u) {
        t = { error: u };
      } finally {
        try {
          o && !o.done && (r = i.return) && r.call(i);
        } finally {
          if (t) throw t.error;
        }
      }
      return new Promise(function(u) {
        Promise.all(n).then(function() {
          u();
        }).catch(function(c) {
          Gt(c || new Error("MultiSpanProcessor: forceFlush failed")), u();
        });
      });
    }, e.prototype.onStart = function(t, r) {
      var n, i;
      try {
        for (var o = Le(this._spanProcessors), a = o.next(); !a.done; a = o.next()) {
          var u = a.value;
          u.onStart(t, r);
        }
      } catch (c) {
        n = { error: c };
      } finally {
        try {
          a && !a.done && (i = o.return) && i.call(o);
        } finally {
          if (n) throw n.error;
        }
      }
    }, e.prototype.onEnd = function(t) {
      var r, n;
      try {
        for (var i = Le(this._spanProcessors), o = i.next(); !o.done; o = i.next()) {
          var a = o.value;
          a.onEnd(t);
        }
      } catch (u) {
        r = { error: u };
      } finally {
        try {
          o && !o.done && (n = i.return) && n.call(i);
        } finally {
          if (r) throw r.error;
        }
      }
    }, e.prototype.shutdown = function() {
      var t, r, n = [];
      try {
        for (var i = Le(this._spanProcessors), o = i.next(); !o.done; o = i.next()) {
          var a = o.value;
          n.push(a.shutdown());
        }
      } catch (u) {
        t = { error: u };
      } finally {
        try {
          o && !o.done && (r = i.return) && r.call(i);
        } finally {
          if (t) throw t.error;
        }
      }
      return new Promise(function(u, c) {
        Promise.all(n).then(function() {
          u();
        }, c);
      });
    }, e;
  }()
), Ap = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.onStart = function(t, r) {
    }, e.prototype.onEnd = function(t) {
    }, e.prototype.shutdown = function() {
      return Promise.resolve();
    }, e.prototype.forceFlush = function() {
      return Promise.resolve();
    }, e;
  }()
), bp = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, wp = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, vt;
(function(e) {
  e[e.resolved = 0] = "resolved", e[e.timeout = 1] = "timeout", e[e.error = 2] = "error", e[e.unresolved = 3] = "unresolved";
})(vt || (vt = {}));
var Rp = (
  /** @class */
  function() {
    function e(t) {
      t === void 0 && (t = {});
      var r, n;
      this._registeredSpanProcessors = [], this._tracers = /* @__PURE__ */ new Map();
      var i = Fd({}, Ca(), np(t));
      if (this.resource = (r = i.resource) !== null && r !== void 0 ? r : de.empty(), i.mergeResourceWithDefaults && (this.resource = de.default().merge(this.resource)), this._config = Object.assign({}, i, {
        resource: this.resource
      }), !((n = t.spanProcessors) === null || n === void 0) && n.length)
        this._registeredSpanProcessors = wp([], bp(t.spanProcessors), !1), this.activeSpanProcessor = new xi(this._registeredSpanProcessors);
      else {
        var o = this._buildExporterFromEnv();
        if (o !== void 0) {
          var a = new xa(o);
          this.activeSpanProcessor = a;
        } else
          this.activeSpanProcessor = new Ap();
      }
    }
    return e.prototype.getTracer = function(t, r, n) {
      var i = t + "@" + (r || "") + ":" + ((n == null ? void 0 : n.schemaUrl) || "");
      return this._tracers.has(i) || this._tracers.set(i, new cp({ name: t, version: r, schemaUrl: n == null ? void 0 : n.schemaUrl }, this._config, this)), this._tracers.get(i);
    }, e.prototype.addSpanProcessor = function(t) {
      this._registeredSpanProcessors.length === 0 && this.activeSpanProcessor.shutdown().catch(function(r) {
        return v.error("Error while trying to shutdown current span processor", r);
      }), this._registeredSpanProcessors.push(t), this.activeSpanProcessor = new xi(this._registeredSpanProcessors);
    }, e.prototype.getActiveSpanProcessor = function() {
      return this.activeSpanProcessor;
    }, e.prototype.register = function(t) {
      t === void 0 && (t = {}), b.setGlobalTracerProvider(this), t.propagator === void 0 && (t.propagator = this._buildPropagatorFromEnv()), t.contextManager && O.setGlobalContextManager(t.contextManager), t.propagator && k.setGlobalPropagator(t.propagator);
    }, e.prototype.forceFlush = function() {
      var t = this._config.forceFlushTimeoutMillis, r = this._registeredSpanProcessors.map(function(n) {
        return new Promise(function(i) {
          var o, a = setTimeout(function() {
            i(new Error("Span processor did not completed within timeout period of " + t + " ms")), o = vt.timeout;
          }, t);
          n.forceFlush().then(function() {
            clearTimeout(a), o !== vt.timeout && (o = vt.resolved, i(o));
          }).catch(function(u) {
            clearTimeout(a), o = vt.error, i(u);
          });
        });
      });
      return new Promise(function(n, i) {
        Promise.all(r).then(function(o) {
          var a = o.filter(function(u) {
            return u !== vt.resolved;
          });
          a.length > 0 ? i(a) : n();
        }).catch(function(o) {
          return i([o]);
        });
      });
    }, e.prototype.shutdown = function() {
      return this.activeSpanProcessor.shutdown();
    }, e.prototype._getPropagator = function(t) {
      var r;
      return (r = this.constructor._registeredPropagators.get(t)) === null || r === void 0 ? void 0 : r();
    }, e.prototype._getSpanExporter = function(t) {
      var r;
      return (r = this.constructor._registeredExporters.get(t)) === null || r === void 0 ? void 0 : r();
    }, e.prototype._buildPropagatorFromEnv = function() {
      var t = this, r = Array.from(new Set(le().OTEL_PROPAGATORS)), n = r.map(function(o) {
        var a = t._getPropagator(o);
        return a || v.warn('Propagator "' + o + '" requested through environment variable is unavailable.'), a;
      }), i = n.reduce(function(o, a) {
        return a && o.push(a), o;
      }, []);
      if (i.length !== 0)
        return r.length === 1 ? i[0] : new hd({
          propagators: i
        });
    }, e.prototype._buildExporterFromEnv = function() {
      var t = le().OTEL_TRACES_EXPORTER;
      if (!(t === "none" || t === "")) {
        var r = this._getSpanExporter(t);
        return r || v.error('Exporter "' + t + '" requested through environment variable is unavailable.'), r;
      }
    }, e._registeredPropagators = /* @__PURE__ */ new Map([
      ["tracecontext", function() {
        return new Id();
      }],
      ["baggage", function() {
        return new Cl();
      }]
    ]), e._registeredExporters = /* @__PURE__ */ new Map(), e;
  }()
), Lp = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Pp = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, Da = (
  /** @class */
  function() {
    function e() {
      this._enabled = !1, this._currentContext = pt;
    }
    return e.prototype._bindFunction = function(t, r) {
      t === void 0 && (t = pt);
      var n = this, i = function() {
        for (var o = this, a = [], u = 0; u < arguments.length; u++)
          a[u] = arguments[u];
        return n.with(t, function() {
          return r.apply(o, a);
        });
      };
      return Object.defineProperty(i, "length", {
        enumerable: !1,
        configurable: !0,
        writable: !1,
        value: r.length
      }), i;
    }, e.prototype.active = function() {
      return this._currentContext;
    }, e.prototype.bind = function(t, r) {
      return t === void 0 && (t = this.active()), typeof r == "function" ? this._bindFunction(t, r) : r;
    }, e.prototype.disable = function() {
      return this._currentContext = pt, this._enabled = !1, this;
    }, e.prototype.enable = function() {
      return this._enabled ? this : (this._enabled = !0, this._currentContext = pt, this);
    }, e.prototype.with = function(t, r, n) {
      for (var i = [], o = 3; o < arguments.length; o++)
        i[o - 3] = arguments[o];
      var a = this._currentContext;
      this._currentContext = t || pt;
      try {
        return r.call.apply(r, Pp([n], Lp(i), !1));
      } finally {
        this._currentContext = a;
      }
    }, e;
  }()
), Np = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), Ip = (
  /** @class */
  function(e) {
    Np(t, e);
    function t(r) {
      r === void 0 && (r = {});
      var n = e.call(this, r) || this;
      if (r.contextManager)
        throw "contextManager should be defined in register method not in constructor";
      if (r.propagator)
        throw "propagator should be defined in register method not in constructor";
      return n;
    }
    return t.prototype.register = function(r) {
      r === void 0 && (r = {}), r.contextManager === void 0 && (r.contextManager = new Da()), r.contextManager && r.contextManager.enable(), e.prototype.register.call(this, r);
    }, t;
  }(Rp)
), m;
(function(e) {
  e.CONNECT_END = "connectEnd", e.CONNECT_START = "connectStart", e.DECODED_BODY_SIZE = "decodedBodySize", e.DOM_COMPLETE = "domComplete", e.DOM_CONTENT_LOADED_EVENT_END = "domContentLoadedEventEnd", e.DOM_CONTENT_LOADED_EVENT_START = "domContentLoadedEventStart", e.DOM_INTERACTIVE = "domInteractive", e.DOMAIN_LOOKUP_END = "domainLookupEnd", e.DOMAIN_LOOKUP_START = "domainLookupStart", e.ENCODED_BODY_SIZE = "encodedBodySize", e.FETCH_START = "fetchStart", e.LOAD_EVENT_END = "loadEventEnd", e.LOAD_EVENT_START = "loadEventStart", e.NAVIGATION_START = "navigationStart", e.REDIRECT_END = "redirectEnd", e.REDIRECT_START = "redirectStart", e.REQUEST_START = "requestStart", e.RESPONSE_END = "responseEnd", e.RESPONSE_START = "responseStart", e.SECURE_CONNECTION_START = "secureConnectionStart", e.UNLOAD_EVENT_END = "unloadEventEnd", e.UNLOAD_EVENT_START = "unloadEventStart";
})(m || (m = {}));
var Hr;
function Cp() {
  return Hr || (Hr = document.createElement("a")), Hr;
}
function lt(e, t) {
  return t in e;
}
function I(e, t, r, n) {
  var i = void 0, o = void 0;
  lt(r, t) && typeof r[t] == "number" && (i = r[t]);
  var a = m.FETCH_START;
  if (lt(r, a) && typeof r[a] == "number" && (o = r[a]), i !== void 0 && o !== void 0 && i >= o)
    return e.addEvent(t, i), e;
}
function jt(e, t, r) {
  r === void 0 && (r = !1), r || (I(e, m.FETCH_START, t), I(e, m.DOMAIN_LOOKUP_START, t), I(e, m.DOMAIN_LOOKUP_END, t), I(e, m.CONNECT_START, t), lt(t, "name") && t.name.startsWith("https:") && I(e, m.SECURE_CONNECTION_START, t), I(e, m.CONNECT_END, t), I(e, m.REQUEST_START, t), I(e, m.RESPONSE_START, t), I(e, m.RESPONSE_END, t));
  var n = t[m.ENCODED_BODY_SIZE];
  n !== void 0 && e.setAttribute(sd, n);
  var i = t[m.DECODED_BODY_SIZE];
  i !== void 0 && n !== i && e.setAttribute(ud, i);
}
function Mp(e) {
  return e.slice().sort(function(t, r) {
    var n = t[m.FETCH_START], i = r[m.FETCH_START];
    return n > i ? 1 : n < i ? -1 : 0;
  });
}
function Ua() {
  return typeof location != "undefined" ? location.origin : void 0;
}
function Ba(e, t, r, n, i, o) {
  i === void 0 && (i = /* @__PURE__ */ new WeakSet());
  var a = et(e);
  e = a.toString();
  var u = Dp(e, t, r, n, i, o);
  if (u.length === 0)
    return {
      mainRequest: void 0
    };
  if (u.length === 1)
    return {
      mainRequest: u[0]
    };
  var c = Mp(u);
  if (a.origin !== Ua() && c.length > 1) {
    var s = c[0], f = xp(c, s[m.RESPONSE_END], r), l = s[m.RESPONSE_END], d = f[m.FETCH_START];
    return d < l && (f = s, s = void 0), {
      corsPreFlightRequest: s,
      mainRequest: f
    };
  } else
    return {
      mainRequest: u[0]
    };
}
function xp(e, t, r) {
  for (var n = ct(r), i = ct(ie(t)), o = e[1], a, u = e.length, c = 1; c < u; c++) {
    var s = e[c], f = ct(ie(s[m.FETCH_START])), l = ct(ie(s[m.RESPONSE_END])), d = n - l;
    f >= i && (!a || d < a) && (a = d, o = s);
  }
  return o;
}
function Dp(e, t, r, n, i, o) {
  var a = ct(t), u = ct(r), c = n.filter(function(s) {
    var f = ct(ie(s[m.FETCH_START])), l = ct(ie(s[m.RESPONSE_END]));
    return s.initiatorType.toLowerCase() === (o || "xmlhttprequest") && s.name === e && f >= a && l <= u;
  });
  return c.length > 0 && (c = c.filter(function(s) {
    return !i.has(s);
  })), c;
}
function et(e) {
  if (typeof URL == "function")
    return new URL(e, typeof document != "undefined" ? document.baseURI : typeof location != "undefined" ? location.href : void 0);
  var t = Cp();
  return t.href = e, t;
}
function ka(e, t) {
  if (e.nodeType === Node.DOCUMENT_NODE)
    return "/";
  var r = Bp(e, t);
  if (t && r.indexOf("@id") > 0)
    return r;
  var n = "";
  return e.parentNode && (n += ka(e.parentNode, !1)), n += r, n;
}
function Up(e) {
  if (!e.parentNode)
    return 0;
  var t = [e.nodeType];
  e.nodeType === Node.CDATA_SECTION_NODE && t.push(Node.TEXT_NODE);
  var r = Array.from(e.parentNode.childNodes);
  return r = r.filter(function(n) {
    var i = n.localName;
    return t.indexOf(n.nodeType) >= 0 && i === e.localName;
  }), r.length >= 1 ? r.indexOf(e) + 1 : 0;
}
function Bp(e, t) {
  var r = e.nodeType, n = Up(e), i = "";
  if (r === Node.ELEMENT_NODE) {
    var o = e.getAttribute("id");
    if (t && o)
      return '//*[@id="' + o + '"]';
    i = e.localName;
  } else if (r === Node.TEXT_NODE || r === Node.CDATA_SECTION_NODE)
    i = "text()";
  else if (r === Node.COMMENT_NODE)
    i = "comment()";
  else
    return "";
  return i && n > 1 ? "/" + i + "[" + n + "]" : "/" + i;
}
function Ha(e, t) {
  var r = t || [];
  (typeof r == "string" || r instanceof RegExp) && (r = [r]);
  var n = et(e);
  return n.origin === Ua() ? !0 : r.some(function(i) {
    return zd(e, i);
  });
}
var Tn = function() {
  return Tn = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, Tn.apply(this, arguments);
}, kp = (
  /** @class */
  function() {
    function e(t, r, n) {
      this.instrumentationName = t, this.instrumentationVersion = r, this._config = {}, this._wrap = x.wrap, this._unwrap = x.unwrap, this._massWrap = x.massWrap, this._massUnwrap = x.massUnwrap, this.setConfig(n), this._diag = v.createComponentLogger({
        namespace: t
      }), this._tracer = b.getTracer(t, r), this._meter = Vt.getMeter(t, r), this._logger = me.getLogger(t, r), this._updateMetricInstruments();
    }
    return Object.defineProperty(e.prototype, "meter", {
      /* Returns meter */
      get: function() {
        return this._meter;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.setMeterProvider = function(t) {
      this._meter = t.getMeter(this.instrumentationName, this.instrumentationVersion), this._updateMetricInstruments();
    }, Object.defineProperty(e.prototype, "logger", {
      /* Returns logger */
      get: function() {
        return this._logger;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.setLoggerProvider = function(t) {
      this._logger = t.getLogger(this.instrumentationName, this.instrumentationVersion);
    }, e.prototype.getModuleDefinitions = function() {
      var t, r = (t = this.init()) !== null && t !== void 0 ? t : [];
      return Array.isArray(r) ? r : [r];
    }, e.prototype._updateMetricInstruments = function() {
    }, e.prototype.getConfig = function() {
      return this._config;
    }, e.prototype.setConfig = function(t) {
      this._config = Tn({ enabled: !0 }, t);
    }, e.prototype.setTracerProvider = function(t) {
      this._tracer = t.getTracer(this.instrumentationName, this.instrumentationVersion);
    }, Object.defineProperty(e.prototype, "tracer", {
      /* Returns tracer */
      get: function() {
        return this._tracer;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype._runSpanCustomizationHook = function(t, r, n, i) {
      if (t)
        try {
          t(n, i);
        } catch (o) {
          this._diag.error("Error running span customization hook due to exception in handler", { triggerName: r }, o);
        }
    }, e;
  }()
), Hp = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), Gp = (
  /** @class */
  function(e) {
    Hp(t, e);
    function t(r, n, i) {
      var o = e.call(this, r, n, i) || this;
      return o._config.enabled && o.enable(), o;
    }
    return t;
  }(kp)
);
function Di(e, t, r) {
  var n, i;
  try {
    i = e();
  } catch (o) {
    n = o;
  } finally {
    return t(n, i), i;
  }
}
var oe;
(function(e) {
  e.DOCUMENT_LOAD = "documentLoad", e.DOCUMENT_FETCH = "documentFetch", e.RESOURCE_FETCH = "resourceFetch";
})(oe || (oe = {}));
var $p = "0.44.0", jp = "@opentelemetry/instrumentation-document-load";
const Vp = "http.url", Fp = "http.user_agent", Ht = Vp, Xp = Fp;
var Ye;
(function(e) {
  e.FIRST_PAINT = "firstPaint", e.FIRST_CONTENTFUL_PAINT = "firstContentfulPaint";
})(Ye || (Ye = {}));
var zp = function() {
  var e, t, r = {}, n = (t = (e = Xe).getEntriesByType) === null || t === void 0 ? void 0 : t.call(e, "navigation")[0];
  if (n) {
    var i = Object.values(m);
    i.forEach(function(u) {
      if (lt(n, u)) {
        var c = n[u];
        typeof c == "number" && (r[u] = c);
      }
    });
  } else {
    var o = Xe, a = o.timing;
    if (a) {
      var i = Object.values(m);
      i.forEach(function(c) {
        if (lt(a, c)) {
          var s = a[c];
          typeof s == "number" && (r[c] = s);
        }
      });
    }
  }
  return r;
}, Ui = {
  "first-paint": Ye.FIRST_PAINT,
  "first-contentful-paint": Ye.FIRST_CONTENTFUL_PAINT
}, qp = function(e) {
  var t, r, n = (r = (t = Xe).getEntriesByType) === null || r === void 0 ? void 0 : r.call(t, "paint");
  n && n.forEach(function(i) {
    var o = i.name, a = i.startTime;
    lt(Ui, o) && e.addEvent(Ui[o], a);
  });
}, Wp = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), Yp = (
  /** @class */
  function(e) {
    Wp(t, e);
    function t(r) {
      r === void 0 && (r = {});
      var n = e.call(this, jp, $p, r) || this;
      return n.component = "document-load", n.version = "1", n.moduleName = n.component, n;
    }
    return t.prototype.init = function() {
    }, t.prototype._onDocumentLoaded = function() {
      var r = this;
      window.setTimeout(function() {
        r._collectPerformance();
      });
    }, t.prototype._addResourcesSpans = function(r) {
      var n = this, i, o, a = (o = (i = Xe).getEntriesByType) === null || o === void 0 ? void 0 : o.call(i, "resource");
      a && a.forEach(function(u) {
        n._initResourceSpan(u, r);
      });
    }, t.prototype._collectPerformance = function() {
      var r = this, n = Array.from(document.getElementsByTagName("meta")).find(function(a) {
        return a.getAttribute("name") === Sl;
      }), i = zp(), o = n && n.content || "";
      O.with(k.extract(pt, { traceparent: o }), function() {
        var a, u = r._startSpan(oe.DOCUMENT_LOAD, m.FETCH_START, i);
        u && (O.with(b.setSpan(O.active(), u), function() {
          var c = r._startSpan(oe.DOCUMENT_FETCH, m.FETCH_START, i);
          c && (c.setAttribute(Ht, location.href), O.with(b.setSpan(O.active(), c), function() {
            var s;
            r.getConfig().ignoreNetworkEvents || jt(c, i), r._addCustomAttributesOnSpan(c, (s = r.getConfig().applyCustomAttributesOnSpan) === null || s === void 0 ? void 0 : s.documentFetch), r._endSpan(c, m.RESPONSE_END, i);
          }));
        }), u.setAttribute(Ht, location.href), u.setAttribute(Xp, navigator.userAgent), r._addResourcesSpans(u), r.getConfig().ignoreNetworkEvents || (I(u, m.FETCH_START, i), I(u, m.UNLOAD_EVENT_START, i), I(u, m.UNLOAD_EVENT_END, i), I(u, m.DOM_INTERACTIVE, i), I(u, m.DOM_CONTENT_LOADED_EVENT_START, i), I(u, m.DOM_CONTENT_LOADED_EVENT_END, i), I(u, m.DOM_COMPLETE, i), I(u, m.LOAD_EVENT_START, i), I(u, m.LOAD_EVENT_END, i)), r.getConfig().ignorePerformancePaintEvents || qp(u), r._addCustomAttributesOnSpan(u, (a = r.getConfig().applyCustomAttributesOnSpan) === null || a === void 0 ? void 0 : a.documentLoad), r._endSpan(u, m.LOAD_EVENT_END, i));
      });
    }, t.prototype._endSpan = function(r, n, i) {
      r && (lt(i, n) ? r.end(i[n]) : r.end());
    }, t.prototype._initResourceSpan = function(r, n) {
      var i, o = this._startSpan(oe.RESOURCE_FETCH, m.FETCH_START, r, n);
      o && (o.setAttribute(Ht, r.name), this.getConfig().ignoreNetworkEvents || jt(o, r), this._addCustomAttributesOnResourceSpan(o, r, (i = this.getConfig().applyCustomAttributesOnSpan) === null || i === void 0 ? void 0 : i.resourceFetch), this._endSpan(o, m.RESPONSE_END, r));
    }, t.prototype._startSpan = function(r, n, i, o) {
      if (lt(i, n) && typeof i[n] == "number") {
        var a = this.tracer.startSpan(r, {
          startTime: i[n]
        }, o ? b.setSpan(O.active(), o) : void 0);
        return a;
      }
    }, t.prototype._waitForPageLoad = function() {
      window.document.readyState === "complete" ? this._onDocumentLoaded() : (this._onDocumentLoaded = this._onDocumentLoaded.bind(this), window.addEventListener("load", this._onDocumentLoaded));
    }, t.prototype._addCustomAttributesOnSpan = function(r, n) {
      var i = this;
      n && Di(function() {
        return n(r);
      }, function(o) {
        o && i._diag.error("addCustomAttributesOnSpan", o);
      });
    }, t.prototype._addCustomAttributesOnResourceSpan = function(r, n, i) {
      var o = this;
      i && Di(function() {
        return i(r, n);
      }, function(a) {
        a && o._diag.error("addCustomAttributesOnResourceSpan", a);
      });
    }, t.prototype.enable = function() {
      window.removeEventListener("load", this._onDocumentLoaded), this._waitForPageLoad();
    }, t.prototype.disable = function() {
      window.removeEventListener("load", this._onDocumentLoaded);
    }, t;
  }(Gp)
), Sn = function() {
  return Sn = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, Sn.apply(this, arguments);
}, Kp = (
  /** @class */
  function() {
    function e(t, r, n) {
      this.instrumentationName = t, this.instrumentationVersion = r, this._config = {}, this._wrap = x.wrap, this._unwrap = x.unwrap, this._massWrap = x.massWrap, this._massUnwrap = x.massUnwrap, this.setConfig(n), this._diag = v.createComponentLogger({
        namespace: t
      }), this._tracer = b.getTracer(t, r), this._meter = Vt.getMeter(t, r), this._logger = me.getLogger(t, r), this._updateMetricInstruments();
    }
    return Object.defineProperty(e.prototype, "meter", {
      /* Returns meter */
      get: function() {
        return this._meter;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.setMeterProvider = function(t) {
      this._meter = t.getMeter(this.instrumentationName, this.instrumentationVersion), this._updateMetricInstruments();
    }, Object.defineProperty(e.prototype, "logger", {
      /* Returns logger */
      get: function() {
        return this._logger;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.setLoggerProvider = function(t) {
      this._logger = t.getLogger(this.instrumentationName, this.instrumentationVersion);
    }, e.prototype.getModuleDefinitions = function() {
      var t, r = (t = this.init()) !== null && t !== void 0 ? t : [];
      return Array.isArray(r) ? r : [r];
    }, e.prototype._updateMetricInstruments = function() {
    }, e.prototype.getConfig = function() {
      return this._config;
    }, e.prototype.setConfig = function(t) {
      this._config = Sn({ enabled: !0 }, t);
    }, e.prototype.setTracerProvider = function(t) {
      this._tracer = t.getTracer(this.instrumentationName, this.instrumentationVersion);
    }, Object.defineProperty(e.prototype, "tracer", {
      /* Returns tracer */
      get: function() {
        return this._tracer;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype._runSpanCustomizationHook = function(t, r, n, i) {
      if (t)
        try {
          t(n, i);
        } catch (o) {
          this._diag.error("Error running span customization hook due to exception in handler", { triggerName: r }, o);
        }
    }, e;
  }()
), Jp = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), Zp = (
  /** @class */
  function(e) {
    Jp(t, e);
    function t(r, n, i) {
      var o = e.call(this, r, n, i) || this;
      return o._config.enabled && o.enable(), o;
    }
    return t;
  }(Kp)
);
function Qp(e, t, r) {
  var n, i;
  try {
    i = e();
  } catch (o) {
    n = o;
  } finally {
    return t(n, i), i;
  }
}
function th(e) {
  return typeof e == "function" && typeof e.__original == "function" && typeof e.__unwrap == "function" && e.__wrapped === !0;
}
var Gr = typeof globalThis == "object" ? globalThis : typeof self == "object" ? self : typeof window == "object" ? window : typeof global == "object" ? global : {}, On = performance, eh = "http.method", rh = "http.url", nh = "http.host", ih = "http.scheme", oh = "http.status_code", ah = "http.user_agent", sh = "http.request_content_length_uncompressed", uh = eh, ch = rh, fh = nh, lh = ih, dh = oh, ph = ah, hh = sh, _h = 9, vh = 6, gh = Math.pow(10, vh), Bi = Math.pow(10, _h);
function An(e) {
  var t = e / 1e3, r = Math.trunc(t), n = Math.round(e % 1e3 * gh);
  return [r, n];
}
function Eh() {
  var e = On.timeOrigin;
  if (typeof e != "number") {
    var t = On;
    e = t.timing && t.timing.fetchStart;
  }
  return e;
}
function ki(e) {
  var t = An(Eh()), r = An(On.now());
  return yh(t, r);
}
function yh(e, t) {
  var r = [e[0] + t[0], e[1] + t[1]];
  return r[1] >= Bi && (r[1] -= Bi, r[0] += 1), r;
}
var mh = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
function Th(e, t) {
  return typeof t == "string" ? e === t : !!e.match(t);
}
function Sh(e, t) {
  var r, n;
  if (!t)
    return !1;
  try {
    for (var i = mh(t), o = i.next(); !o.done; o = i.next()) {
      var a = o.value;
      if (Th(e, a))
        return !0;
    }
  } catch (u) {
    r = { error: u };
  } finally {
    try {
      o && !o.done && (n = i.return) && n.call(i);
    } finally {
      if (r) throw r.error;
    }
  }
  return !1;
}
var Ke;
(function(e) {
  e.COMPONENT = "component", e.HTTP_ERROR_NAME = "http.error_name", e.HTTP_STATUS_TEXT = "http.status_text";
})(Ke || (Ke = {}));
var Oh = function(e, t, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function u(f) {
      try {
        s(n.next(f));
      } catch (l) {
        a(l);
      }
    }
    function c(f) {
      try {
        s(n.throw(f));
      } catch (l) {
        a(l);
      }
    }
    function s(f) {
      f.done ? o(f.value) : i(f.value).then(u, c);
    }
    s((n = n.apply(e, t || [])).next());
  });
}, Ah = function(e, t) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(f) {
      return c([s, f]);
    };
  }
  function c(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return r.label++, { value: s[1], done: !1 };
        case 5:
          r.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            r = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            r.label = s[1];
            break;
          }
          if (s[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = s;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(s);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      s = t.call(e, r);
    } catch (f) {
      s = [6, f], i = 0;
    } finally {
      n = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, bh = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, wh = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Ga = v.createComponentLogger({
  namespace: "@opentelemetry/opentelemetry-instrumentation-fetch/utils"
});
function Rh() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  if (e[0] instanceof URL || typeof e[0] == "string") {
    var r = e[1];
    if (!(r != null && r.body))
      return Promise.resolve();
    if (r.body instanceof ReadableStream) {
      var n = Lh(r.body), i = n.body, o = n.length;
      return r.body = i, o;
    } else
      return Promise.resolve(Ph(r.body));
  } else {
    var a = e[0];
    return a != null && a.body ? a.clone().text().then(function(u) {
      return bn(u);
    }) : Promise.resolve();
  }
}
function Lh(e) {
  if (!e.pipeThrough)
    return Ga.warn("Platform has ReadableStream but not pipeThrough!"), {
      body: e,
      length: Promise.resolve(void 0)
    };
  var t = 0, r, n = new Promise(function(o) {
    r = o;
  }), i = new TransformStream({
    start: function() {
    },
    transform: function(o, a) {
      return Oh(this, void 0, void 0, function() {
        var u;
        return Ah(this, function(c) {
          switch (c.label) {
            case 0:
              return [4, o];
            case 1:
              return u = c.sent(), t += u.byteLength, a.enqueue(o), [
                2
                /*return*/
              ];
          }
        });
      });
    },
    flush: function() {
      r(t);
    }
  });
  return {
    body: e.pipeThrough(i),
    length: n
  };
}
function Ph(e) {
  if (typeof Document != "undefined" && e instanceof Document)
    return new XMLSerializer().serializeToString(document).length;
  if (e instanceof Blob)
    return e.size;
  if (e.byteLength !== void 0)
    return e.byteLength;
  if (e instanceof FormData)
    return Ih(e);
  if (e instanceof URLSearchParams)
    return bn(e.toString());
  if (typeof e == "string")
    return bn(e);
  Ga.warn("unknown body type");
}
var Nh = new TextEncoder();
function bn(e) {
  return Nh.encode(e).byteLength;
}
function Ih(e) {
  var t, r, n = 0;
  try {
    for (var i = bh(e.entries()), o = i.next(); !o.done; o = i.next()) {
      var a = wh(o.value, 2), u = a[0], c = a[1];
      n += u.length, c instanceof Blob ? n += c.size : n += c.length;
    }
  } catch (s) {
    t = { error: s };
  } finally {
    try {
      o && !o.done && (r = i.return) && r.call(i);
    } finally {
      if (t) throw t.error;
    }
  }
  return n;
}
var Hi = "0.57.2", Ch = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), Mh = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, xh = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, $r, Dh = 300, Gi = typeof process == "object" && (($r = process.release) === null || $r === void 0 ? void 0 : $r.name) === "node", Uh = (
  /** @class */
  function(e) {
    Ch(t, e);
    function t(r) {
      r === void 0 && (r = {});
      var n = e.call(this, "@opentelemetry/instrumentation-fetch", Hi, r) || this;
      return n.component = "fetch", n.version = Hi, n.moduleName = n.component, n._usedResources = /* @__PURE__ */ new WeakSet(), n._tasksCount = 0, n;
    }
    return t.prototype.init = function() {
    }, t.prototype._addChildSpan = function(r, n) {
      var i = this.tracer.startSpan("CORS Preflight", {
        startTime: n[m.FETCH_START]
      }, b.setSpan(O.active(), r));
      jt(i, n, this.getConfig().ignoreNetworkEvents), i.end(n[m.RESPONSE_END]);
    }, t.prototype._addFinalSpanAttributes = function(r, n) {
      var i = et(n.url);
      r.setAttribute(dh, n.status), n.statusText != null && r.setAttribute(Ke.HTTP_STATUS_TEXT, n.statusText), r.setAttribute(fh, i.host), r.setAttribute(lh, i.protocol.replace(":", "")), typeof navigator != "undefined" && r.setAttribute(ph, navigator.userAgent);
    }, t.prototype._addHeaders = function(r, n) {
      if (!Ha(n, this.getConfig().propagateTraceHeaderCorsUrls)) {
        var i = {};
        k.inject(O.active(), i), Object.keys(i).length > 0 && this._diag.debug("headers inject skipped due to CORS policy");
        return;
      }
      if (r instanceof Request)
        k.inject(O.active(), r.headers, {
          set: function(o, a, u) {
            return o.set(a, typeof u == "string" ? u : String(u));
          }
        });
      else if (r.headers instanceof Headers)
        k.inject(O.active(), r.headers, {
          set: function(o, a, u) {
            return o.set(a, typeof u == "string" ? u : String(u));
          }
        });
      else if (r.headers instanceof Map)
        k.inject(O.active(), r.headers, {
          set: function(o, a, u) {
            return o.set(a, typeof u == "string" ? u : String(u));
          }
        });
      else {
        var i = {};
        k.inject(O.active(), i), r.headers = Object.assign({}, i, r.headers || {});
      }
    }, t.prototype._clearResources = function() {
      this._tasksCount === 0 && this.getConfig().clearTimingResources && (performance.clearResourceTimings(), this._usedResources = /* @__PURE__ */ new WeakSet());
    }, t.prototype._createSpan = function(r, n) {
      var i;
      if (n === void 0 && (n = {}), Sh(r, this.getConfig().ignoreUrls)) {
        this._diag.debug("ignoring span as url matches ignored url");
        return;
      }
      var o = (n.method || "GET").toUpperCase(), a = "HTTP " + o;
      return this.tracer.startSpan(a, {
        kind: fe.CLIENT,
        attributes: (i = {}, i[Ke.COMPONENT] = this.moduleName, i[uh] = o, i[ch] = r, i)
      });
    }, t.prototype._findResourceAndAddNetworkEvents = function(r, n, i) {
      var o = n.entries;
      if (!o.length) {
        if (!performance.getEntriesByType)
          return;
        o = performance.getEntriesByType("resource");
      }
      var a = Ba(n.spanUrl, n.startTime, i, o, this._usedResources, "fetch");
      if (a.mainRequest) {
        var u = a.mainRequest;
        this._markResourceAsUsed(u);
        var c = a.corsPreFlightRequest;
        c && (this._addChildSpan(r, c), this._markResourceAsUsed(c)), jt(r, u, this.getConfig().ignoreNetworkEvents);
      }
    }, t.prototype._markResourceAsUsed = function(r) {
      this._usedResources.add(r);
    }, t.prototype._endSpan = function(r, n, i) {
      var o = this, a = An(Date.now()), u = ki();
      this._addFinalSpanAttributes(r, i), setTimeout(function() {
        var c;
        (c = n.observer) === null || c === void 0 || c.disconnect(), o._findResourceAndAddNetworkEvents(r, n, u), o._tasksCount--, o._clearResources(), r.end(a);
      }, Dh);
    }, t.prototype._patchConstructor = function() {
      var r = this;
      return function(n) {
        var i = r;
        return function() {
          for (var a = [], u = 0; u < arguments.length; u++)
            a[u] = arguments[u];
          var c = this, s = et(a[0] instanceof Request ? a[0].url : String(a[0])).href, f = a[0] instanceof Request ? a[0] : a[1] || {}, l = i._createSpan(s, f);
          if (!l)
            return n.apply(this, a);
          var d = i._prepareSpanData(s);
          i.getConfig().measureRequestSize && Rh.apply(void 0, xh([], Mh(a), !1)).then(function(E) {
            E && l.setAttribute(hh, E);
          }).catch(function(E) {
            i._diag.warn("getFetchBodyLength", E);
          });
          function h(E, y) {
            i._applyAttributesAfterFetch(E, f, y), i._endSpan(E, d, {
              status: y.status || 0,
              statusText: y.message,
              url: s
            });
          }
          function _(E, y) {
            i._applyAttributesAfterFetch(E, f, y), y.status >= 200 && y.status < 400 ? i._endSpan(E, d, y) : i._endSpan(E, d, {
              status: y.status,
              statusText: y.statusText,
              url: s
            });
          }
          function p(E, y, A) {
            try {
              var L = A.clone(), P = A.clone(), C = L.body;
              if (C) {
                var Lt = C.getReader(), Xt = function() {
                  Lt.read().then(function(Pt) {
                    var Z = Pt.done;
                    Z ? _(E, P) : Xt();
                  }, function(Pt) {
                    h(E, Pt);
                  });
                };
                Xt();
              } else
                _(E, A);
            } finally {
              y(A);
            }
          }
          function g(E, y, A) {
            try {
              h(E, A);
            } finally {
              y(A);
            }
          }
          return new Promise(function(E, y) {
            return O.with(b.setSpan(O.active(), l), function() {
              return i._addHeaders(f, s), i._tasksCount++, n.apply(c, f instanceof Request ? [f] : [s, f]).then(p.bind(c, l, E), g.bind(c, l, y));
            });
          });
        };
      };
    }, t.prototype._applyAttributesAfterFetch = function(r, n, i) {
      var o = this, a = this.getConfig().applyCustomAttributesOnSpan;
      a && Qp(function() {
        return a(r, n, i);
      }, function(u) {
        u && o._diag.error("applyCustomAttributesOnSpan", u);
      });
    }, t.prototype._prepareSpanData = function(r) {
      var n = ki(), i = [];
      if (typeof PerformanceObserver != "function")
        return { entries: i, startTime: n, spanUrl: r };
      var o = new PerformanceObserver(function(a) {
        var u = a.getEntries();
        u.forEach(function(c) {
          c.initiatorType === "fetch" && c.name === r && i.push(c);
        });
      });
      return o.observe({
        entryTypes: ["resource"]
      }), { entries: i, observer: o, startTime: n, spanUrl: r };
    }, t.prototype.enable = function() {
      if (Gi) {
        this._diag.warn("this instrumentation is intended for web usage only, it does not instrument Node.js's fetch()");
        return;
      }
      th(fetch) && (this._unwrap(Gr, "fetch"), this._diag.debug("removing previous patch for constructor")), this._wrap(Gr, "fetch", this._patchConstructor());
    }, t.prototype.disable = function() {
      Gi || (this._unwrap(Gr, "fetch"), this._usedResources = /* @__PURE__ */ new WeakSet());
    }, t;
  }(Zp)
), wn = function() {
  return wn = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, wn.apply(this, arguments);
}, Bh = (
  /** @class */
  function() {
    function e(t, r, n) {
      this.instrumentationName = t, this.instrumentationVersion = r, this._config = {}, this._wrap = x.wrap, this._unwrap = x.unwrap, this._massWrap = x.massWrap, this._massUnwrap = x.massUnwrap, this.setConfig(n), this._diag = v.createComponentLogger({
        namespace: t
      }), this._tracer = b.getTracer(t, r), this._meter = Vt.getMeter(t, r), this._logger = me.getLogger(t, r), this._updateMetricInstruments();
    }
    return Object.defineProperty(e.prototype, "meter", {
      /* Returns meter */
      get: function() {
        return this._meter;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.setMeterProvider = function(t) {
      this._meter = t.getMeter(this.instrumentationName, this.instrumentationVersion), this._updateMetricInstruments();
    }, Object.defineProperty(e.prototype, "logger", {
      /* Returns logger */
      get: function() {
        return this._logger;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.setLoggerProvider = function(t) {
      this._logger = t.getLogger(this.instrumentationName, this.instrumentationVersion);
    }, e.prototype.getModuleDefinitions = function() {
      var t, r = (t = this.init()) !== null && t !== void 0 ? t : [];
      return Array.isArray(r) ? r : [r];
    }, e.prototype._updateMetricInstruments = function() {
    }, e.prototype.getConfig = function() {
      return this._config;
    }, e.prototype.setConfig = function(t) {
      this._config = wn({ enabled: !0 }, t);
    }, e.prototype.setTracerProvider = function(t) {
      this._tracer = t.getTracer(this.instrumentationName, this.instrumentationVersion);
    }, Object.defineProperty(e.prototype, "tracer", {
      /* Returns tracer */
      get: function() {
        return this._tracer;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype._runSpanCustomizationHook = function(t, r, n, i) {
      if (t)
        try {
          t(n, i);
        } catch (o) {
          this._diag.error("Error running span customization hook due to exception in handler", { triggerName: r }, o);
        }
    }, e;
  }()
), kh = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), Hh = (
  /** @class */
  function(e) {
    kh(t, e);
    function t(r, n, i) {
      var o = e.call(this, r, n, i) || this;
      return o._config.enabled && o.enable(), o;
    }
    return t;
  }(Bh)
);
function Gh(e, t, r) {
  var n, i;
  try {
    i = e();
  } catch (o) {
    n = o;
  } finally {
    return t(n, i), i;
  }
}
function $i(e) {
  return typeof e == "function" && typeof e.__original == "function" && typeof e.__unwrap == "function" && e.__wrapped === !0;
}
var pe = performance, $h = "http.method", jh = "http.url", Vh = "http.host", Fh = "http.scheme", Xh = "http.status_code", zh = "http.user_agent", qh = "http.request_content_length_uncompressed", Wh = $h, Yh = jh, Kh = Vh, Jh = Fh, Zh = Xh, Qh = zh, t_ = qh, e_ = 9, r_ = 6, n_ = Math.pow(10, r_), ji = Math.pow(10, e_);
function Vi(e) {
  var t = e / 1e3, r = Math.trunc(t), n = Math.round(e % 1e3 * n_);
  return [r, n];
}
function i_() {
  var e = pe.timeOrigin;
  if (typeof e != "number") {
    var t = pe;
    e = t.timing && t.timing.fetchStart;
  }
  return e;
}
function Fi(e) {
  var t = Vi(i_()), r = Vi(pe.now());
  return o_(t, r);
}
function o_(e, t) {
  var r = [e[0] + t[0], e[1] + t[1]];
  return r[1] >= ji && (r[1] -= ji, r[0] += 1), r;
}
var a_ = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
function s_(e, t) {
  return typeof t == "string" ? e === t : !!e.match(t);
}
function u_(e, t) {
  var r, n;
  if (!t)
    return !1;
  try {
    for (var i = a_(t), o = i.next(); !o.done; o = i.next()) {
      var a = o.value;
      if (s_(e, a))
        return !0;
    }
  } catch (u) {
    r = { error: u };
  } finally {
    try {
      o && !o.done && (n = i.return) && n.call(i);
    } finally {
      if (r) throw r.error;
    }
  }
  return !1;
}
var tt;
(function(e) {
  e.METHOD_OPEN = "open", e.METHOD_SEND = "send", e.EVENT_ABORT = "abort", e.EVENT_ERROR = "error", e.EVENT_LOAD = "loaded", e.EVENT_TIMEOUT = "timeout";
})(tt || (tt = {}));
var c_ = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, f_ = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, l_ = v.createComponentLogger({
  namespace: "@opentelemetry/opentelemetry-instrumentation-xml-http-request/utils"
});
function d_(e) {
  if (typeof Document != "undefined" && e instanceof Document)
    return new XMLSerializer().serializeToString(document).length;
  if (e instanceof Blob)
    return e.size;
  if (e.byteLength !== void 0)
    return e.byteLength;
  if (e instanceof FormData)
    return h_(e);
  if (e instanceof URLSearchParams)
    return Xi(e.toString());
  if (typeof e == "string")
    return Xi(e);
  l_.warn("unknown body type");
}
var p_ = new TextEncoder();
function Xi(e) {
  return p_.encode(e).byteLength;
}
function h_(e) {
  var t, r, n = 0;
  try {
    for (var i = c_(e.entries()), o = i.next(); !o.done; o = i.next()) {
      var a = f_(o.value, 2), u = a[0], c = a[1];
      n += u.length, c instanceof Blob ? n += c.size : n += c.length;
    }
  } catch (s) {
    t = { error: s };
  } finally {
    try {
      o && !o.done && (r = i.return) && r.call(i);
    } finally {
      if (t) throw t.error;
    }
  }
  return n;
}
var zi = "0.57.2", Rn;
(function(e) {
  e.HTTP_STATUS_TEXT = "http.status_text";
})(Rn || (Rn = {}));
var __ = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), v_ = 300, g_ = (
  /** @class */
  function(e) {
    __(t, e);
    function t(r) {
      r === void 0 && (r = {});
      var n = e.call(this, "@opentelemetry/instrumentation-xml-http-request", zi, r) || this;
      return n.component = "xml-http-request", n.version = zi, n.moduleName = n.component, n._tasksCount = 0, n._xhrMem = /* @__PURE__ */ new WeakMap(), n._usedResources = /* @__PURE__ */ new WeakSet(), n;
    }
    return t.prototype.init = function() {
    }, t.prototype._addHeaders = function(r, n) {
      var i = et(n).href;
      if (!Ha(i, this.getConfig().propagateTraceHeaderCorsUrls)) {
        var o = {};
        k.inject(O.active(), o), Object.keys(o).length > 0 && this._diag.debug("headers inject skipped due to CORS policy");
        return;
      }
      var a = {};
      k.inject(O.active(), a), Object.keys(a).forEach(function(u) {
        r.setRequestHeader(u, String(a[u]));
      });
    }, t.prototype._addChildSpan = function(r, n) {
      var i = this;
      O.with(b.setSpan(O.active(), r), function() {
        var o = i.tracer.startSpan("CORS Preflight", {
          startTime: n[m.FETCH_START]
        });
        jt(o, n, i.getConfig().ignoreNetworkEvents), o.end(n[m.RESPONSE_END]);
      });
    }, t.prototype._addFinalSpanAttributes = function(r, n, i) {
      if (typeof i == "string") {
        var o = et(i);
        n.status !== void 0 && r.setAttribute(Zh, n.status), n.statusText !== void 0 && r.setAttribute(Rn.HTTP_STATUS_TEXT, n.statusText), r.setAttribute(Kh, o.host), r.setAttribute(Jh, o.protocol.replace(":", "")), r.setAttribute(Qh, navigator.userAgent);
      }
    }, t.prototype._applyAttributesAfterXHR = function(r, n) {
      var i = this, o = this.getConfig().applyCustomAttributesOnSpan;
      typeof o == "function" && Gh(function() {
        return o(r, n);
      }, function(a) {
        a && i._diag.error("applyCustomAttributesOnSpan", a);
      });
    }, t.prototype._addResourceObserver = function(r, n) {
      var i = this._xhrMem.get(r);
      !i || typeof PerformanceObserver != "function" || typeof PerformanceResourceTiming != "function" || (i.createdResources = {
        observer: new PerformanceObserver(function(o) {
          var a = o.getEntries(), u = et(n);
          a.forEach(function(c) {
            c.initiatorType === "xmlhttprequest" && c.name === u.href && i.createdResources && i.createdResources.entries.push(c);
          });
        }),
        entries: []
      }, i.createdResources.observer.observe({
        entryTypes: ["resource"]
      }));
    }, t.prototype._clearResources = function() {
      this._tasksCount === 0 && this.getConfig().clearTimingResources && (pe.clearResourceTimings(), this._xhrMem = /* @__PURE__ */ new WeakMap(), this._usedResources = /* @__PURE__ */ new WeakSet());
    }, t.prototype._findResourceAndAddNetworkEvents = function(r, n, i, o, a) {
      if (!(!i || !o || !a || !r.createdResources)) {
        var u = r.createdResources.entries;
        (!u || !u.length) && (u = pe.getEntriesByType("resource"));
        var c = Ba(et(i).href, o, a, u, this._usedResources);
        if (c.mainRequest) {
          var s = c.mainRequest;
          this._markResourceAsUsed(s);
          var f = c.corsPreFlightRequest;
          f && (this._addChildSpan(n, f), this._markResourceAsUsed(f)), jt(n, s, this.getConfig().ignoreNetworkEvents);
        }
      }
    }, t.prototype._cleanPreviousSpanInformation = function(r) {
      var n = this._xhrMem.get(r);
      if (n) {
        var i = n.callbackToRemoveEvents;
        i && i(), this._xhrMem.delete(r);
      }
    }, t.prototype._createSpan = function(r, n, i) {
      var o;
      if (u_(n, this.getConfig().ignoreUrls)) {
        this._diag.debug("ignoring span as url matches ignored url");
        return;
      }
      var a = i.toUpperCase(), u = this.tracer.startSpan(a, {
        kind: fe.CLIENT,
        attributes: (o = {}, o[Wh] = i, o[Yh] = et(n).toString(), o)
      });
      return u.addEvent(tt.METHOD_OPEN), this._cleanPreviousSpanInformation(r), this._xhrMem.set(r, {
        span: u,
        spanUrl: n
      }), u;
    }, t.prototype._markResourceAsUsed = function(r) {
      this._usedResources.add(r);
    }, t.prototype._patchOpen = function() {
      var r = this;
      return function(n) {
        var i = r;
        return function() {
          for (var a = [], u = 0; u < arguments.length; u++)
            a[u] = arguments[u];
          var c = a[0], s = a[1];
          return i._createSpan(this, s, c), n.apply(this, a);
        };
      };
    }, t.prototype._patchSend = function() {
      var r = this;
      function n(f, l, d, h) {
        var _ = l.callbackToRemoveEvents;
        typeof _ == "function" && _();
        var p = l.span, g = l.spanUrl, E = l.sendStartTime;
        p && (r._findResourceAndAddNetworkEvents(l, p, g, E, d), p.addEvent(f, h), r._addFinalSpanAttributes(p, l, g), p.end(h), r._tasksCount--), r._clearResources();
      }
      function i(f, l) {
        var d = r._xhrMem.get(l);
        if (d) {
          d.status = l.status, d.statusText = l.statusText, r._xhrMem.delete(l), d.span && r._applyAttributesAfterXHR(d.span, l);
          var h = Fi(), _ = Date.now();
          setTimeout(function() {
            n(f, d, h, _);
          }, v_);
        }
      }
      function o() {
        i(tt.EVENT_ERROR, this);
      }
      function a() {
        i(tt.EVENT_ABORT, this);
      }
      function u() {
        i(tt.EVENT_TIMEOUT, this);
      }
      function c() {
        this.status < 299 ? i(tt.EVENT_LOAD, this) : i(tt.EVENT_ERROR, this);
      }
      function s(f) {
        f.removeEventListener("abort", a), f.removeEventListener("error", o), f.removeEventListener("load", c), f.removeEventListener("timeout", u);
        var l = r._xhrMem.get(f);
        l && (l.callbackToRemoveEvents = void 0);
      }
      return function(f) {
        return function() {
          for (var d = this, h = [], _ = 0; _ < arguments.length; _++)
            h[_] = arguments[_];
          var p = r._xhrMem.get(this);
          if (!p)
            return f.apply(this, h);
          var g = p.span, E = p.spanUrl;
          if (g && E) {
            if (r.getConfig().measureRequestSize && (h != null && h[0])) {
              var y = h[0], A = d_(y);
              A !== void 0 && g.setAttribute(t_, A);
            }
            O.with(b.setSpan(O.active(), g), function() {
              r._tasksCount++, p.sendStartTime = Fi(), g.addEvent(tt.METHOD_SEND), d.addEventListener("abort", a), d.addEventListener("error", o), d.addEventListener("load", c), d.addEventListener("timeout", u), p.callbackToRemoveEvents = function() {
                s(d), p.createdResources && p.createdResources.observer.disconnect();
              }, r._addHeaders(d, E), r._addResourceObserver(d, E);
            });
          }
          return f.apply(this, h);
        };
      };
    }, t.prototype.enable = function() {
      this._diag.debug("applying patch to", this.moduleName, this.version), $i(XMLHttpRequest.prototype.open) && (this._unwrap(XMLHttpRequest.prototype, "open"), this._diag.debug("removing previous patch from method open")), $i(XMLHttpRequest.prototype.send) && (this._unwrap(XMLHttpRequest.prototype, "send"), this._diag.debug("removing previous patch from method send")), this._wrap(XMLHttpRequest.prototype, "open", this._patchOpen()), this._wrap(XMLHttpRequest.prototype, "send", this._patchSend());
    }, t.prototype.disable = function() {
      this._diag.debug("removing patch from", this.moduleName, this.version), this._unwrap(XMLHttpRequest.prototype, "open"), this._unwrap(XMLHttpRequest.prototype, "send"), this._tasksCount = 0, this._xhrMem = /* @__PURE__ */ new WeakMap(), this._usedResources = /* @__PURE__ */ new WeakSet();
    }, t;
  }(Hh)
);
const qi = (e, t, r) => {
  const n = ir(
    t,
    e.headers,
    r
  );
  return N(S({}, e), {
    headers: n
  });
}, ir = (e, t, r) => {
  var i, o;
  const n = S({}, t);
  return r ? ((i = Object.keys(n)) == null || i.forEach((a) => {
    [...r].includes(a == null ? void 0 : a.toLowerCase()) || (n[a] = "[REDACTED]");
  }), n) : ((o = Object.keys(n)) == null || o.forEach((a) => {
    [...E_, ...e].includes(
      a == null ? void 0 : a.toLowerCase()
    ) && (n[a] = "[REDACTED]");
  }), n);
}, E_ = [
  "authorization",
  "cookie",
  "proxy-authorization",
  "set-cookie",
  "token"
], y_ = [
  "https://www.googleapis.com/identitytoolkit",
  "https://securetoken.googleapis.com"
], m_ = [
  "awsaccesskeyid",
  "signature",
  "sig",
  "x-goog-signature"
], $a = (e) => {
  var t, r;
  try {
    return new URL(e);
  } catch (n) {
    return new URL(e, (r = (t = globalThis.location) == null ? void 0 : t.origin) != null ? r : "http://example.com");
  }
}, ja = (e) => {
  try {
    const t = $a(e);
    (t.username || t.password) && (t.username = "REDACTED", t.password = "REDACTED");
    const r = t.searchParams;
    if (m_.forEach((n) => {
      for (const i of Array.from(r.keys()))
        i.toLowerCase() === n && r.set(i, "REDACTED");
    }), !e.includes("://") && !e.startsWith("//"))
      return t.pathname + t.search + t.hash;
    if (e.startsWith("//")) {
      let n = "//";
      return (t.username || t.password) && (n += t.username + ":" + t.password + "@"), n += t.host + t.pathname + t.search + t.hash, n;
    }
    return t.toString();
  } catch (t) {
    return e;
  }
}, T_ = new RegExp("sdk\\/evalx\\/[^/]+\\/contexts\\/(?<context>[^/?]*)\\??.*?"), S_ = new RegExp("\\/eval\\/[^/]+\\/(?<context>[^/?]*)\\??.*?");
function O_(e) {
  return !!(e.includes("/sdk/evalx") && e.match(T_) || e.includes("/eval/") && e.match(S_));
}
const Va = "X-Highlight-Request", Wi = (e) => {
  let t = e;
  return !e.startsWith("https://") && !e.startsWith("http://") && (t = `${window.location.origin}${t}`), t.replace(/\/+$/, "");
}, A_ = (e, {
  headersToRedact: t,
  headersToRecord: r,
  requestResponseSanitizer: n
}) => {
  var c, s;
  let i = e;
  if (n) {
    let l = !0;
    try {
      i.request.body = JSON.parse(i.request.body);
    } catch (h) {
      l = !1;
    }
    let d = !0;
    try {
      i.response.body = JSON.parse(
        i.response.body
      );
    } catch (h) {
      d = !1;
    }
    try {
      i = n(i);
    } catch (h) {
    } finally {
      l = l && !!((c = i == null ? void 0 : i.request) != null && c.body), d = d && !!((s = i == null ? void 0 : i.response) != null && s.body), l && (i.request.body = JSON.stringify(
        i.request.body
      )), d && (i.response.body = JSON.stringify(
        i.response.body
      ));
    }
    if (!i)
      return null;
  }
  const f = i, { request: o, response: a } = f, u = lr(f, ["request", "response"]);
  return S({
    request: qi(o, t, r),
    response: qi(a, t, r)
  }, u);
}, qy = (e, t, r, n) => {
  e.sort((c, s) => c.responseEnd - s.responseEnd);
  const i = {
    xmlhttprequest: {},
    others: {},
    fetch: {}
  }, o = e.reduce((c, s) => {
    const f = Wi(s.name);
    return s.initiatorType === r ? c[r][f] = [
      ...c[r][f] || [],
      s
    ] : c.others[f] = [
      ...c.others[f] || [],
      s
    ], c;
  }, i);
  let a = {};
  a = t.reduce(
    (c, s) => {
      const f = Wi(s.request.url);
      return c[f] = [...c[f] || [], s], c;
    },
    a
  );
  for (let c in o[r]) {
    const s = o[r][c], f = a[c];
    if (!f)
      continue;
    const l = Math.max(
      s.length - f.length,
      0
    );
    for (let d = l; d < s.length; d++)
      s[d] && (s[d].requestResponsePair = f[d - l]);
  }
  let u = [];
  for (let c in o)
    for (let s in o[c])
      u = u.concat(o[c][s]);
  return u.sort((c, s) => c.fetchStart - s.fetchStart).reduce(
    (c, s) => {
      let f = s.requestResponsePair;
      return f && (f = A_(
        s.requestResponsePair,
        n
      ), !f) || (s.toJSON = function() {
        const l = window.performance.timeOrigin;
        return {
          initiatorType: this.initiatorType,
          startTimeAbs: l + this.startTime,
          connectStartAbs: l + this.connectStart,
          connectEndAbs: l + this.connectEnd,
          domainLookupStartAbs: l + this.domainLookupStart,
          domainLookupEndAbs: l + this.domainLookupEnd,
          fetchStartAbs: l + this.fetchStart,
          redirectStartAbs: l + this.redirectStart,
          redirectEndAbs: l + this.redirectEnd,
          requestStartAbs: l + this.requestStart,
          responseStartAbs: l + this.responseStart,
          responseEndAbs: l + this.responseEnd,
          secureConnectionStartAbs: l + this.secureConnectionStart,
          workerStartAbs: l + this.workerStart,
          name: this.name,
          transferSize: this.transferSize,
          encodedBodySize: this.encodedBodySize,
          decodedBodySize: this.decodedBodySize,
          nextHopProtocol: this.nextHopProtocol,
          requestResponsePairs: f
        };
      }, c.push(s)), c;
    },
    []
  );
}, b_ = (e) => ["events.ld.catamorphic.com", "events.launchdarkly.com"].some(
  (t) => e.toLocaleLowerCase().includes(t)
), w_ = (e) => O_(e), R_ = (e, t) => t.some(
  (r) => e.toLocaleLowerCase().includes(r)
), Fn = (e, t, r) => !R_(e, t) && !w_(e) && !b_(e), Xn = (e, t, r) => {
  var o;
  if (r.some(
    (a) => e.toLowerCase().includes(a)
  ))
    return !1;
  let n = [];
  t === !0 ? (n = ["localhost", /^\//], (o = window == null ? void 0 : window.location) != null && o.host && n.push(window.location.host)) : t instanceof Array && (n = t);
  let i = !1;
  return n.forEach((a) => {
    e.match(a) && (i = !0);
  }), i;
};
function L_(e) {
  for (var t = "", r = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789", n = r.length, i = 0; i < e; i++)
    t += r.charAt(
      Math.floor(Math.random() * n)
    );
  return t;
}
const Fa = () => {
  const e = L_(10), t = oy(), r = t == null ? void 0 : t.spanContext().traceId;
  return [ot(), r != null ? r : e];
}, Xa = (e, t) => e + "/" + t, Wy = (e, t, r, n, i, o) => {
  const a = XMLHttpRequest.prototype, u = a.open, c = a.send, s = a.setRequestHeader;
  return a.open = function(f, l) {
    return typeof l == "string" ? this._url = l : this._url = l.toString(), this._method = f, this._requestHeaders = {}, this._shouldRecordHeaderAndBody = !n.some(
      (d) => this._url.toLowerCase().includes(d)
    ), u.apply(this, arguments);
  }, a.setRequestHeader = function(f, l) {
    return this._requestHeaders[f] = l, s.apply(this, arguments);
  }, a.send = function(f) {
    if (!Fn(
      this._url,
      t
    ))
      return c.apply(this, arguments);
    const [l, d] = Fa();
    Xn(
      this._url,
      r,
      n
    ) && this.setRequestHeader(
      Va,
      Xa(l, d)
    );
    const h = this._shouldRecordHeaderAndBody, _ = {
      sessionSecureID: l,
      id: d,
      url: this._url,
      verb: this._method,
      headers: h ? this._requestHeaders : {},
      body: void 0
    };
    if (h && f) {
      const p = Yi(f, _.url);
      p && (this._body = p, _.body = rt(
        p,
        i,
        o,
        _.headers
      ));
    }
    return this.addEventListener("load", function() {
      return D(this, null, function* () {
        const p = {
          status: this.status,
          headers: {},
          body: void 0
        };
        if (h) {
          const y = this.getAllResponseHeaders().trim().split(/[\r\n]+/), A = {};
          if (y.forEach(function(L) {
            const P = L.split(": "), C = P.shift();
            A[C] = P.join(": ");
          }), p.headers = A, f) {
            const L = Yi(f, _.url);
            L && (_.body = rt(
              L,
              i,
              o,
              p.headers
            ));
          }
          if (this.responseType === "" || this.responseType === "text")
            p.body = rt(
              this.responseText,
              i,
              o,
              p.headers
            ), p.size = this.responseText.length * 8;
          else if (this.responseType === "blob") {
            if (this.response instanceof Blob)
              try {
                const L = yield this.response.text();
                p.body = rt(
                  L,
                  i,
                  o,
                  p.headers
                ), p.size = this.response.size;
              } catch (L) {
              }
          } else
            try {
              p.body = rt(
                this.response,
                i,
                o,
                p.headers
              );
            } catch (L) {
            }
        }
        e({
          request: _,
          response: p,
          urlBlocked: !h
        });
      });
    }), this.addEventListener("error", function() {
      return D(this, null, function* () {
        const p = {
          status: this.status,
          headers: void 0,
          body: void 0
        };
        e({
          request: _,
          response: p,
          urlBlocked: !1
        });
      });
    }), c.apply(this, arguments);
  }, () => {
    a.open = u, a.send = c, a.setRequestHeader = s;
  };
}, Yi = (e, t) => {
  if (typeof e == "string") {
    if (!((t != null && t.includes("localhost") || t != null && t.includes("highlight.run")) && (e.includes("pushPayload") || e.includes("pushSessionEvents"))))
      return e;
  } else if (typeof e == "object" || typeof e == "number" || typeof e == "boolean")
    return Ut(e);
  return null;
}, Ki = 64 * 1024, P_ = {
  "application/json": 64 * 1024 * 1024,
  // MB
  "text/plain": 64 * 1024 * 1024
  // MB
}, rt = (e, t, r, n) => {
  var o, a, u;
  let i = Ki;
  if (n) {
    let c = "";
    typeof n.get == "function" ? c = (o = n.get("content-type")) != null ? o : "" : c = (a = n["content-type"]) != null ? a : "";
    try {
      c = c.split(";")[0];
    } catch (s) {
    }
    i = (u = P_[c]) != null ? u : Ki;
  }
  if (e) {
    if (t)
      try {
        const c = JSON.parse(e);
        Array.isArray(c) ? c.forEach((s) => {
          Object.keys(s).forEach((f) => {
            t.includes(
              f.toLocaleLowerCase()
            ) && (s[f] = "[REDACTED]");
          });
        }) : Object.keys(c).forEach((s) => {
          t.includes(s.toLocaleLowerCase()) && (c[s] = "[REDACTED]");
        }), e = JSON.stringify(c);
      } catch (c) {
      }
    if (r)
      try {
        const c = JSON.parse(e);
        Object.keys(c).forEach((s) => {
          r.includes(s.toLocaleLowerCase()) || (c[s] = "[REDACTED]");
        }), e = JSON.stringify(c);
      } catch (c) {
      }
  }
  try {
    e = e.slice(0, i);
  } catch (c) {
  }
  return e;
}, Yy = (e, t, r, n, i, o) => {
  const a = window._fetchProxy;
  return window._fetchProxy = function(u, c) {
    const { method: s, url: f } = N_(u, c);
    if (!Fn(
      f,
      t
    ))
      return a.call(this, u, c);
    const [l, d] = Fa();
    if (Xn(f, r, n)) {
      c = c || {};
      let g = new Headers(c.headers);
      u instanceof Request && [...u.headers].forEach(
        ([E, y]) => g.set(E, y)
      ), g.set(
        Va,
        Xa(l, d)
      ), c.headers = Object.fromEntries(g.entries());
    }
    const h = {
      sessionSecureID: l,
      id: d,
      headers: {},
      body: void 0,
      url: f,
      verb: s
    }, _ = !n.some(
      (g) => f.toLowerCase().includes(g)
    );
    _ && (h.headers = Object.fromEntries(
      new Headers(c == null ? void 0 : c.headers).entries()
    ), h.body = rt(
      c == null ? void 0 : c.body,
      i,
      o,
      c == null ? void 0 : c.headers
    ));
    let p = a.call(this, u, c);
    return I_(
      p,
      h,
      e,
      _,
      i,
      o
    ), p;
  }, () => {
    window._fetchProxy = a;
  };
}, N_ = (e, t) => {
  const r = t && t.method || typeof e == "object" && "method" in e && e.method || "GET";
  let n;
  return typeof e == "object" ? "url" in e && e.url ? n = e.url : n = e.toString() : n = e, {
    method: r,
    url: n
  };
}, I_ = (e, t, r, n, i, o) => {
  const a = (u) => D(void 0, null, function* () {
    let c = {
      body: void 0,
      headers: void 0,
      status: 0,
      size: 0
    }, s = !1, f = !n;
    "stack" in u || u instanceof Error ? (c = N(S({}, c), {
      body: u.message,
      status: 0,
      size: void 0
    }), s = !0) : "status" in u && (c = N(S({}, c), {
      status: u.status
    }), n && (c.body = yield za(
      u,
      o,
      i
    ), c.headers = Object.fromEntries(
      u.headers.entries()
    ), c.size = c.body.length * 8), (u.type === "opaque" || u.type === "opaqueredirect") && (f = !0, c = N(S({}, c), {
      body: "CORS blocked request"
    })), s = !0), s && r({
      request: t,
      response: c,
      urlBlocked: f
    });
  });
  e.then(a).catch(() => {
  });
}, za = (e, t, r) => D(void 0, null, function* () {
  let n;
  try {
    const o = e.clone().body;
    if (o) {
      let a = o.getReader(), u = new TextDecoder(), c, s = "";
      for (; !(c = yield a.read()).done; ) {
        let f = c.value;
        s += u.decode(f);
      }
      n = s, n = rt(
        n,
        r,
        t,
        e.headers
      );
    } else
      n = "";
  } catch (i) {
    n = `Unable to clone response: ${i}`;
  }
  return n;
});
var qa = (
  /** @class */
  function() {
    function e(t) {
      this._delegate = t;
    }
    return e.prototype.export = function(t, r) {
      this._delegate.export(t, r);
    }, e.prototype.forceFlush = function() {
      return this._delegate.forceFlush();
    }, e.prototype.shutdown = function() {
      return this._delegate.shutdown();
    }, e;
  }()
), C_ = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), Ji = (
  /** @class */
  function(e) {
    C_(t, e);
    function t(r, n, i) {
      var o = e.call(this, r) || this;
      return o.name = "OTLPExporterError", o.data = i, o.code = n, o;
    }
    return t;
  }(Error)
);
function M_(e) {
  if (!Number.isNaN(e) && Number.isFinite(e) && e > 0)
    return e;
  throw new Error("Configuration: timeoutMillis is invalid, expected number greater than 0 (actual: '" + e + "')");
}
function x_(e) {
  if (e != null)
    return function() {
      return e;
    };
}
function D_(e, t, r) {
  var n, i, o, a, u, c;
  return {
    timeoutMillis: M_((i = (n = e.timeoutMillis) !== null && n !== void 0 ? n : t.timeoutMillis) !== null && i !== void 0 ? i : r.timeoutMillis),
    concurrencyLimit: (a = (o = e.concurrencyLimit) !== null && o !== void 0 ? o : t.concurrencyLimit) !== null && a !== void 0 ? a : r.concurrencyLimit,
    compression: (c = (u = e.compression) !== null && u !== void 0 ? u : t.compression) !== null && c !== void 0 ? c : r.compression
  };
}
function U_() {
  return {
    timeoutMillis: 1e4,
    concurrencyLimit: 30,
    compression: "none"
  };
}
var B_ = function(e, t, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function u(f) {
      try {
        s(n.next(f));
      } catch (l) {
        a(l);
      }
    }
    function c(f) {
      try {
        s(n.throw(f));
      } catch (l) {
        a(l);
      }
    }
    function s(f) {
      f.done ? o(f.value) : i(f.value).then(u, c);
    }
    s((n = n.apply(e, t || [])).next());
  });
}, k_ = function(e, t) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(f) {
      return c([s, f]);
    };
  }
  function c(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return r.label++, { value: s[1], done: !1 };
        case 5:
          r.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            r = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            r.label = s[1];
            break;
          }
          if (s[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = s;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(s);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      s = t.call(e, r);
    } catch (f) {
      s = [6, f], i = 0;
    } finally {
      n = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, H_ = (
  /** @class */
  function() {
    function e(t) {
      this._sendingPromises = [], this._concurrencyLimit = t;
    }
    return e.prototype.pushPromise = function(t) {
      var r = this;
      if (this.hasReachedLimit())
        throw new Error("Concurrency Limit reached");
      this._sendingPromises.push(t);
      var n = function() {
        var i = r._sendingPromises.indexOf(t);
        r._sendingPromises.splice(i, 1);
      };
      t.then(n, n);
    }, e.prototype.hasReachedLimit = function() {
      return this._sendingPromises.length >= this._concurrencyLimit;
    }, e.prototype.awaitAll = function() {
      return B_(this, void 0, void 0, function() {
        return k_(this, function(t) {
          switch (t.label) {
            case 0:
              return [4, Promise.all(this._sendingPromises)];
            case 1:
              return t.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, e;
  }()
);
function G_(e) {
  return new H_(e.concurrencyLimit);
}
function $_(e) {
  return Object.prototype.hasOwnProperty.call(e, "partialSuccess");
}
function j_() {
  return {
    handleResponse: function(e) {
      e == null || !$_(e) || e.partialSuccess == null || Object.keys(e.partialSuccess).length === 0 || v.warn("Received Partial Success response:", JSON.stringify(e.partialSuccess));
    }
  };
}
var V_ = function(e, t, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function u(f) {
      try {
        s(n.next(f));
      } catch (l) {
        a(l);
      }
    }
    function c(f) {
      try {
        s(n.throw(f));
      } catch (l) {
        a(l);
      }
    }
    function s(f) {
      f.done ? o(f.value) : i(f.value).then(u, c);
    }
    s((n = n.apply(e, t || [])).next());
  });
}, F_ = function(e, t) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(f) {
      return c([s, f]);
    };
  }
  function c(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return r.label++, { value: s[1], done: !1 };
        case 5:
          r.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            r = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            r.label = s[1];
            break;
          }
          if (s[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = s;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(s);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      s = t.call(e, r);
    } catch (f) {
      s = [6, f], i = 0;
    } finally {
      n = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, X_ = (
  /** @class */
  function() {
    function e(t, r, n, i, o) {
      this._transport = t, this._serializer = r, this._responseHandler = n, this._promiseQueue = i, this._timeout = o, this._diagLogger = v.createComponentLogger({
        namespace: "OTLPExportDelegate"
      });
    }
    return e.prototype.export = function(t, r) {
      var n = this;
      if (this._diagLogger.debug("items to be sent", t), this._promiseQueue.hasReachedLimit()) {
        r({
          code: B.FAILED,
          error: new Error("Concurrent export limit reached")
        });
        return;
      }
      var i = this._serializer.serializeRequest(t);
      if (i == null) {
        r({
          code: B.FAILED,
          error: new Error("Nothing to send")
        });
        return;
      }
      this._promiseQueue.pushPromise(this._transport.send(i, this._timeout).then(function(o) {
        if (o.status === "success") {
          if (o.data != null)
            try {
              n._responseHandler.handleResponse(n._serializer.deserializeResponse(o.data));
            } catch (a) {
              n._diagLogger.warn("Export succeeded but could not deserialize response - is the response specification compliant?", a, o.data);
            }
          r({
            code: B.SUCCESS
          });
          return;
        } else if (o.status === "failure" && o.error) {
          r({
            code: B.FAILED,
            error: o.error
          });
          return;
        } else o.status === "retryable" ? r({
          code: B.FAILED,
          error: new Ji("Export failed with retryable status")
        }) : r({
          code: B.FAILED,
          error: new Ji("Export failed with unknown error")
        });
      }, function(o) {
        return r({
          code: B.FAILED,
          error: o
        });
      }));
    }, e.prototype.forceFlush = function() {
      return this._promiseQueue.awaitAll();
    }, e.prototype.shutdown = function() {
      return V_(this, void 0, void 0, function() {
        return F_(this, function(t) {
          switch (t.label) {
            case 0:
              return this._diagLogger.debug("shutdown started"), [4, this.forceFlush()];
            case 1:
              return t.sent(), this._transport.shutdown(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, e;
  }()
);
function z_(e, t) {
  return new X_(e.transport, e.serializer, j_(), e.promiseHandler, t.timeout);
}
function Wa(e, t, r) {
  return z_({
    transport: r,
    serializer: t,
    promiseHandler: G_(e)
  }, { timeout: e.timeoutMillis });
}
function Zi(e) {
  return e >= 48 && e <= 57 ? e - 48 : e >= 97 && e <= 102 ? e - 87 : e - 55;
}
function zn(e) {
  for (var t = new Uint8Array(e.length / 2), r = 0, n = 0; n < e.length; n += 2) {
    var i = Zi(e.charCodeAt(n)), o = Zi(e.charCodeAt(n + 1));
    t[r++] = i << 4 | o;
  }
  return t;
}
var q_ = 9, W_ = Math.pow(10, q_);
function Y_(e) {
  return e[0] * W_ + e[1];
}
function Ya(e) {
  var t = BigInt(1e9);
  return BigInt(e[0]) * t + BigInt(e[1]);
}
function K_(e) {
  var t = Number(BigInt.asUintN(32, e)), r = Number(BigInt.asUintN(32, e >> BigInt(32)));
  return { low: t, high: r };
}
function Ka(e) {
  var t = Ya(e);
  return K_(t);
}
function J_(e) {
  var t = Ya(e);
  return t.toString();
}
var Z_ = typeof BigInt != "undefined" ? J_ : Y_;
function Qi(e) {
  return e;
}
function Ja(e) {
  if (e !== void 0)
    return zn(e);
}
var Q_ = {
  encodeHrTime: Ka,
  encodeSpanContext: zn,
  encodeOptionalSpanContext: Ja
};
function Za(e) {
  var t, r;
  if (e === void 0)
    return Q_;
  var n = (t = e.useLongBits) !== null && t !== void 0 ? t : !0, i = (r = e.useHex) !== null && r !== void 0 ? r : !1;
  return {
    encodeHrTime: n ? Ka : Z_,
    encodeSpanContext: i ? Qi : zn,
    encodeOptionalSpanContext: i ? Qi : Ja
  };
}
var tv = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
};
function Qa(e) {
  return {
    attributes: At(e.attributes),
    droppedAttributesCount: 0
  };
}
function ts(e) {
  return {
    name: e.name,
    version: e.version
  };
}
function At(e) {
  return Object.keys(e).map(function(t) {
    return es(t, e[t]);
  });
}
function es(e, t) {
  return {
    key: e,
    value: rs(t)
  };
}
function rs(e) {
  var t = typeof e;
  return t === "string" ? { stringValue: e } : t === "number" ? Number.isInteger(e) ? { intValue: e } : { doubleValue: e } : t === "boolean" ? { boolValue: e } : e instanceof Uint8Array ? { bytesValue: e } : Array.isArray(e) ? { arrayValue: { values: e.map(rs) } } : t === "object" && e != null ? {
    kvlistValue: {
      values: Object.entries(e).map(function(r) {
        var n = tv(r, 2), i = n[0], o = n[1];
        return es(i, o);
      })
    }
  } : {};
}
var X;
(function(e) {
  e[e.DELTA = 0] = "DELTA", e[e.CUMULATIVE = 1] = "CUMULATIVE";
})(X || (X = {}));
var Y;
(function(e) {
  e[e.HISTOGRAM = 0] = "HISTOGRAM", e[e.EXPONENTIAL_HISTOGRAM = 1] = "EXPONENTIAL_HISTOGRAM", e[e.GAUGE = 2] = "GAUGE", e[e.SUM = 3] = "SUM";
})(Y || (Y = {}));
var ev = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), to = function(e, t, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function u(f) {
      try {
        s(n.next(f));
      } catch (l) {
        a(l);
      }
    }
    function c(f) {
      try {
        s(n.throw(f));
      } catch (l) {
        a(l);
      }
    }
    function s(f) {
      f.done ? o(f.value) : i(f.value).then(u, c);
    }
    s((n = n.apply(e, t || [])).next());
  });
}, eo = function(e, t) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(f) {
      return c([s, f]);
    };
  }
  function c(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return r.label++, { value: s[1], done: !1 };
        case 5:
          r.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            r = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            r.label = s[1];
            break;
          }
          if (s[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = s;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(s);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      s = t.call(e, r);
    } catch (f) {
      s = [6, f], i = 0;
    } finally {
      n = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, rv = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, nv = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, iv = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
function ov(e) {
  return e != null;
}
function ns(e) {
  var t = Object.keys(e);
  return t.length === 0 ? "" : (t = t.sort(), JSON.stringify(t.map(function(r) {
    return [r, e[r]];
  })));
}
function av(e) {
  var t, r;
  return e.name + ":" + ((t = e.version) !== null && t !== void 0 ? t : "") + ":" + ((r = e.schemaUrl) !== null && r !== void 0 ? r : "");
}
var is = (
  /** @class */
  function(e) {
    ev(t, e);
    function t(r) {
      var n = e.call(this, r) || this;
      return Object.setPrototypeOf(n, t.prototype), n;
    }
    return t;
  }(Error)
);
function he(e, t) {
  var r, n = new Promise(function(o, a) {
    r = setTimeout(function() {
      a(new is("Operation timed out."));
    }, t);
  });
  return Promise.race([e, n]).then(function(i) {
    return clearTimeout(r), i;
  }, function(i) {
    throw clearTimeout(r), i;
  });
}
function sv(e) {
  return to(this, void 0, void 0, function() {
    var t = this;
    return eo(this, function(r) {
      return [2, Promise.all(e.map(function(n) {
        return to(t, void 0, void 0, function() {
          var i, o;
          return eo(this, function(a) {
            switch (a.label) {
              case 0:
                return a.trys.push([0, 2, , 3]), [4, n];
              case 1:
                return i = a.sent(), [2, {
                  status: "fulfilled",
                  value: i
                }];
              case 2:
                return o = a.sent(), [2, {
                  status: "rejected",
                  reason: o
                }];
              case 3:
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      }))];
    });
  });
}
function uv(e) {
  return e.status === "rejected";
}
function ro(e, t) {
  var r = [];
  return e.forEach(function(n) {
    r.push.apply(r, nv([], rv(t(n)), !1));
  }), r;
}
function cv(e, t) {
  var r, n;
  if (e.size !== t.size)
    return !1;
  try {
    for (var i = iv(e), o = i.next(); !o.done; o = i.next()) {
      var a = o.value;
      if (!t.has(a))
        return !1;
    }
  } catch (u) {
    r = { error: u };
  } finally {
    try {
      o && !o.done && (n = i.return) && n.call(i);
    } finally {
      if (r) throw r.error;
    }
  }
  return !0;
}
function fv(e, t) {
  for (var r = 0, n = e.length - 1, i = e.length; n >= r; ) {
    var o = r + Math.trunc((n - r) / 2);
    e[o] < t ? r = o + 1 : (i = o, n = o - 1);
  }
  return i;
}
function lv(e, t) {
  return e.toLowerCase() === t.toLowerCase();
}
var Tt;
(function(e) {
  e[e.DROP = 0] = "DROP", e[e.SUM = 1] = "SUM", e[e.LAST_VALUE = 2] = "LAST_VALUE", e[e.HISTOGRAM = 3] = "HISTOGRAM", e[e.EXPONENTIAL_HISTOGRAM = 4] = "EXPONENTIAL_HISTOGRAM";
})(Tt || (Tt = {}));
var dv = (
  /** @class */
  function() {
    function e() {
      this.kind = Tt.DROP;
    }
    return e.prototype.createAccumulation = function() {
    }, e.prototype.merge = function(t, r) {
    }, e.prototype.diff = function(t, r) {
    }, e.prototype.toMetricData = function(t, r, n, i) {
    }, e;
  }()
), T;
(function(e) {
  e.COUNTER = "COUNTER", e.GAUGE = "GAUGE", e.HISTOGRAM = "HISTOGRAM", e.UP_DOWN_COUNTER = "UP_DOWN_COUNTER", e.OBSERVABLE_COUNTER = "OBSERVABLE_COUNTER", e.OBSERVABLE_GAUGE = "OBSERVABLE_GAUGE", e.OBSERVABLE_UP_DOWN_COUNTER = "OBSERVABLE_UP_DOWN_COUNTER";
})(T || (T = {}));
function it(e, t, r) {
  var n, i, o, a;
  return vv(e) || v.warn('Invalid metric name: "' + e + '". The metric name should be a ASCII string with a length no greater than 255 characters.'), {
    name: e,
    type: t,
    description: (n = r == null ? void 0 : r.description) !== null && n !== void 0 ? n : "",
    unit: (i = r == null ? void 0 : r.unit) !== null && i !== void 0 ? i : "",
    valueType: (o = r == null ? void 0 : r.valueType) !== null && o !== void 0 ? o : ft.DOUBLE,
    advice: (a = r == null ? void 0 : r.advice) !== null && a !== void 0 ? a : {}
  };
}
function pv(e, t) {
  var r, n;
  return {
    name: (r = e.name) !== null && r !== void 0 ? r : t.name,
    description: (n = e.description) !== null && n !== void 0 ? n : t.description,
    type: t.type,
    unit: t.unit,
    valueType: t.valueType,
    advice: t.advice
  };
}
function hv(e, t) {
  return lv(e.name, t.name) && e.unit === t.unit && e.type === t.type && e.valueType === t.valueType;
}
var _v = /^[a-z][a-z0-9_.\-/]{0,254}$/i;
function vv(e) {
  return e.match(_v) != null;
}
var gv = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
};
function Ev(e) {
  var t = e.map(function() {
    return 0;
  });
  return t.push(0), {
    buckets: {
      boundaries: e,
      counts: t
    },
    sum: 0,
    count: 0,
    hasMinMax: !1,
    min: 1 / 0,
    max: -1 / 0
  };
}
var jr = (
  /** @class */
  function() {
    function e(t, r, n, i) {
      n === void 0 && (n = !0), i === void 0 && (i = Ev(r)), this.startTime = t, this._boundaries = r, this._recordMinMax = n, this._current = i;
    }
    return e.prototype.record = function(t) {
      if (!Number.isNaN(t)) {
        this._current.count += 1, this._current.sum += t, this._recordMinMax && (this._current.min = Math.min(t, this._current.min), this._current.max = Math.max(t, this._current.max), this._current.hasMinMax = !0);
        var r = fv(this._boundaries, t);
        this._current.buckets.counts[r] += 1;
      }
    }, e.prototype.setStartTime = function(t) {
      this.startTime = t;
    }, e.prototype.toPointValue = function() {
      return this._current;
    }, e;
  }()
), os = (
  /** @class */
  function() {
    function e(t, r) {
      this._boundaries = t, this._recordMinMax = r, this.kind = Tt.HISTOGRAM;
    }
    return e.prototype.createAccumulation = function(t) {
      return new jr(t, this._boundaries, this._recordMinMax);
    }, e.prototype.merge = function(t, r) {
      for (var n = t.toPointValue(), i = r.toPointValue(), o = n.buckets.counts, a = i.buckets.counts, u = new Array(o.length), c = 0; c < o.length; c++)
        u[c] = o[c] + a[c];
      var s = 1 / 0, f = -1 / 0;
      return this._recordMinMax && (n.hasMinMax && i.hasMinMax ? (s = Math.min(n.min, i.min), f = Math.max(n.max, i.max)) : n.hasMinMax ? (s = n.min, f = n.max) : i.hasMinMax && (s = i.min, f = i.max)), new jr(t.startTime, n.buckets.boundaries, this._recordMinMax, {
        buckets: {
          boundaries: n.buckets.boundaries,
          counts: u
        },
        count: n.count + i.count,
        sum: n.sum + i.sum,
        hasMinMax: this._recordMinMax && (n.hasMinMax || i.hasMinMax),
        min: s,
        max: f
      });
    }, e.prototype.diff = function(t, r) {
      for (var n = t.toPointValue(), i = r.toPointValue(), o = n.buckets.counts, a = i.buckets.counts, u = new Array(o.length), c = 0; c < o.length; c++)
        u[c] = a[c] - o[c];
      return new jr(r.startTime, n.buckets.boundaries, this._recordMinMax, {
        buckets: {
          boundaries: n.buckets.boundaries,
          counts: u
        },
        count: i.count - n.count,
        sum: i.sum - n.sum,
        hasMinMax: !1,
        min: 1 / 0,
        max: -1 / 0
      });
    }, e.prototype.toMetricData = function(t, r, n, i) {
      return {
        descriptor: t,
        aggregationTemporality: r,
        dataPointType: Y.HISTOGRAM,
        dataPoints: n.map(function(o) {
          var a = gv(o, 2), u = a[0], c = a[1], s = c.toPointValue(), f = t.type === T.GAUGE || t.type === T.UP_DOWN_COUNTER || t.type === T.OBSERVABLE_GAUGE || t.type === T.OBSERVABLE_UP_DOWN_COUNTER;
          return {
            attributes: u,
            startTime: c.startTime,
            endTime: i,
            value: {
              min: s.hasMinMax ? s.min : void 0,
              max: s.hasMinMax ? s.max : void 0,
              sum: f ? void 0 : s.sum,
              buckets: s.buckets,
              count: s.count
            }
          };
        })
      };
    }, e;
  }()
), Vr = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Fr = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, no = (
  /** @class */
  function() {
    function e(t, r, n, i) {
      t === void 0 && (t = new yv()), r === void 0 && (r = 0), n === void 0 && (n = 0), i === void 0 && (i = 0), this.backing = t, this.indexBase = r, this.indexStart = n, this.indexEnd = i;
    }
    return Object.defineProperty(e.prototype, "offset", {
      /**
       * Offset is the bucket index of the smallest entry in the counts array
       * @returns {number}
       */
      get: function() {
        return this.indexStart;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "length", {
      /**
       * Buckets is a view into the backing array.
       * @returns {number}
       */
      get: function() {
        return this.backing.length === 0 || this.indexEnd === this.indexStart && this.at(0) === 0 ? 0 : this.indexEnd - this.indexStart + 1;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.counts = function() {
      var t = this;
      return Array.from({ length: this.length }, function(r, n) {
        return t.at(n);
      });
    }, e.prototype.at = function(t) {
      var r = this.indexBase - this.indexStart;
      return t < r && (t += this.backing.length), t -= r, this.backing.countAt(t);
    }, e.prototype.incrementBucket = function(t, r) {
      this.backing.increment(t, r);
    }, e.prototype.decrementBucket = function(t, r) {
      this.backing.decrement(t, r);
    }, e.prototype.trim = function() {
      for (var t = 0; t < this.length; t++)
        if (this.at(t) !== 0) {
          this.indexStart += t;
          break;
        } else if (t === this.length - 1) {
          this.indexStart = this.indexEnd = this.indexBase = 0;
          return;
        }
      for (var t = this.length - 1; t >= 0; t--)
        if (this.at(t) !== 0) {
          this.indexEnd -= this.length - t - 1;
          break;
        }
      this._rotate();
    }, e.prototype.downscale = function(t) {
      this._rotate();
      for (var r = 1 + this.indexEnd - this.indexStart, n = 1 << t, i = 0, o = 0, a = this.indexStart; a <= this.indexEnd; ) {
        var u = a % n;
        u < 0 && (u += n);
        for (var c = u; c < n && i < r; c++)
          this._relocateBucket(o, i), i++, a++;
        o++;
      }
      this.indexStart >>= t, this.indexEnd >>= t, this.indexBase = this.indexStart;
    }, e.prototype.clone = function() {
      return new e(this.backing.clone(), this.indexBase, this.indexStart, this.indexEnd);
    }, e.prototype._rotate = function() {
      var t = this.indexBase - this.indexStart;
      t !== 0 && (t > 0 ? (this.backing.reverse(0, this.backing.length), this.backing.reverse(0, t), this.backing.reverse(t, this.backing.length)) : (this.backing.reverse(0, this.backing.length), this.backing.reverse(0, this.backing.length + t)), this.indexBase = this.indexStart);
    }, e.prototype._relocateBucket = function(t, r) {
      t !== r && this.incrementBucket(t, this.backing.emptyBucket(r));
    }, e;
  }()
), yv = (
  /** @class */
  function() {
    function e(t) {
      t === void 0 && (t = [0]), this._counts = t;
    }
    return Object.defineProperty(e.prototype, "length", {
      /**
       * length returns the physical size of the backing array, which
       * is >= buckets.length()
       */
      get: function() {
        return this._counts.length;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.countAt = function(t) {
      return this._counts[t];
    }, e.prototype.growTo = function(t, r, n) {
      var i = new Array(t).fill(0);
      i.splice.apply(i, Fr([
        n,
        this._counts.length - r
      ], Vr(this._counts.slice(r)), !1)), i.splice.apply(i, Fr([0, r], Vr(this._counts.slice(0, r)), !1)), this._counts = i;
    }, e.prototype.reverse = function(t, r) {
      for (var n = Math.floor((t + r) / 2) - t, i = 0; i < n; i++) {
        var o = this._counts[t + i];
        this._counts[t + i] = this._counts[r - i - 1], this._counts[r - i - 1] = o;
      }
    }, e.prototype.emptyBucket = function(t) {
      var r = this._counts[t];
      return this._counts[t] = 0, r;
    }, e.prototype.increment = function(t, r) {
      this._counts[t] += r;
    }, e.prototype.decrement = function(t, r) {
      this._counts[t] >= r ? this._counts[t] -= r : this._counts[t] = 0;
    }, e.prototype.clone = function() {
      return new e(Fr([], Vr(this._counts), !1));
    }, e;
  }()
), mv = 52, Tv = 2146435072, Sv = 1048575, qn = 1023, as = -qn + 1, ss = qn, Ln = Math.pow(2, -1022);
function us(e) {
  var t = new DataView(new ArrayBuffer(8));
  t.setFloat64(0, e);
  var r = t.getUint32(0), n = (r & Tv) >> 20;
  return n - qn;
}
function cs(e) {
  var t = new DataView(new ArrayBuffer(8));
  t.setFloat64(0, e);
  var r = t.getUint32(0), n = t.getUint32(4), i = (r & Sv) * Math.pow(2, 32);
  return i + n;
}
function Pn(e, t) {
  return e === 0 || e === Number.POSITIVE_INFINITY || e === Number.NEGATIVE_INFINITY || Number.isNaN(e) ? e : e * Math.pow(2, t);
}
function Ov(e) {
  return e--, e |= e >> 1, e |= e >> 2, e |= e >> 4, e |= e >> 8, e |= e >> 16, e++, e;
}
var Av = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), _e = (
  /** @class */
  function(e) {
    Av(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t;
  }(Error)
), bv = (
  /** @class */
  function() {
    function e(t) {
      this._shift = -t;
    }
    return e.prototype.mapToIndex = function(t) {
      if (t < Ln)
        return this._minNormalLowerBoundaryIndex();
      var r = us(t), n = this._rightShift(cs(t) - 1, mv);
      return r + n >> this._shift;
    }, e.prototype.lowerBoundary = function(t) {
      var r = this._minNormalLowerBoundaryIndex();
      if (t < r)
        throw new _e("underflow: " + t + " is < minimum lower boundary: " + r);
      var n = this._maxNormalLowerBoundaryIndex();
      if (t > n)
        throw new _e("overflow: " + t + " is > maximum lower boundary: " + n);
      return Pn(1, t << this._shift);
    }, Object.defineProperty(e.prototype, "scale", {
      /**
       * The scale used by this mapping
       * @returns {number}
       */
      get: function() {
        return this._shift === 0 ? 0 : -this._shift;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype._minNormalLowerBoundaryIndex = function() {
      var t = as >> this._shift;
      return this._shift < 2 && t--, t;
    }, e.prototype._maxNormalLowerBoundaryIndex = function() {
      return ss >> this._shift;
    }, e.prototype._rightShift = function(t, r) {
      return Math.floor(t * Math.pow(2, -r));
    }, e;
  }()
), wv = (
  /** @class */
  function() {
    function e(t) {
      this._scale = t, this._scaleFactor = Pn(Math.LOG2E, t), this._inverseFactor = Pn(Math.LN2, -t);
    }
    return e.prototype.mapToIndex = function(t) {
      if (t <= Ln)
        return this._minNormalLowerBoundaryIndex() - 1;
      if (cs(t) === 0) {
        var r = us(t);
        return (r << this._scale) - 1;
      }
      var n = Math.floor(Math.log(t) * this._scaleFactor), i = this._maxNormalLowerBoundaryIndex();
      return n >= i ? i : n;
    }, e.prototype.lowerBoundary = function(t) {
      var r = this._maxNormalLowerBoundaryIndex();
      if (t >= r) {
        if (t === r)
          return 2 * Math.exp((t - (1 << this._scale)) / this._scaleFactor);
        throw new _e("overflow: " + t + " is > maximum lower boundary: " + r);
      }
      var n = this._minNormalLowerBoundaryIndex();
      if (t <= n) {
        if (t === n)
          return Ln;
        if (t === n - 1)
          return Math.exp((t + (1 << this._scale)) / this._scaleFactor) / 2;
        throw new _e("overflow: " + t + " is < minimum lower boundary: " + n);
      }
      return Math.exp(t * this._inverseFactor);
    }, Object.defineProperty(e.prototype, "scale", {
      /**
       * The scale used by this mapping
       * @returns {number}
       */
      get: function() {
        return this._scale;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype._minNormalLowerBoundaryIndex = function() {
      return as << this._scale;
    }, e.prototype._maxNormalLowerBoundaryIndex = function() {
      return (ss + 1 << this._scale) - 1;
    }, e;
  }()
), io = -10, oo = 20, Rv = Array.from({ length: 31 }, function(e, t) {
  return t > 10 ? new wv(t - 10) : new bv(t - 10);
});
function ao(e) {
  if (e > oo || e < io)
    throw new _e("expected scale >= " + io + " && <= " + oo + ", got: " + e);
  return Rv[e + 10];
}
var Lv = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Pe = (
  /** @class */
  function() {
    function e(t, r) {
      this.low = t, this.high = r;
    }
    return e.combine = function(t, r) {
      return new e(Math.min(t.low, r.low), Math.max(t.high, r.high));
    }, e;
  }()
), Pv = 20, Nv = 160, Xr = 2, Iv = (
  /** @class */
  function() {
    function e(t, r, n, i, o, a, u, c, s, f, l) {
      t === void 0 && (t = t), r === void 0 && (r = Nv), n === void 0 && (n = !0), i === void 0 && (i = 0), o === void 0 && (o = 0), a === void 0 && (a = 0), u === void 0 && (u = Number.POSITIVE_INFINITY), c === void 0 && (c = Number.NEGATIVE_INFINITY), s === void 0 && (s = new no()), f === void 0 && (f = new no()), l === void 0 && (l = ao(Pv)), this.startTime = t, this._maxSize = r, this._recordMinMax = n, this._sum = i, this._count = o, this._zeroCount = a, this._min = u, this._max = c, this._positive = s, this._negative = f, this._mapping = l, this._maxSize < Xr && (v.warn("Exponential Histogram Max Size set to " + this._maxSize + ",                 changing to the minimum size of: " + Xr), this._maxSize = Xr);
    }
    return e.prototype.record = function(t) {
      this.updateByIncrement(t, 1);
    }, e.prototype.setStartTime = function(t) {
      this.startTime = t;
    }, e.prototype.toPointValue = function() {
      return {
        hasMinMax: this._recordMinMax,
        min: this.min,
        max: this.max,
        sum: this.sum,
        positive: {
          offset: this.positive.offset,
          bucketCounts: this.positive.counts()
        },
        negative: {
          offset: this.negative.offset,
          bucketCounts: this.negative.counts()
        },
        count: this.count,
        scale: this.scale,
        zeroCount: this.zeroCount
      };
    }, Object.defineProperty(e.prototype, "sum", {
      /**
       * @returns {Number} The sum of values recorded by this accumulation
       */
      get: function() {
        return this._sum;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "min", {
      /**
       * @returns {Number} The minimum value recorded by this accumulation
       */
      get: function() {
        return this._min;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "max", {
      /**
       * @returns {Number} The maximum value recorded by this accumulation
       */
      get: function() {
        return this._max;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "count", {
      /**
       * @returns {Number} The count of values recorded by this accumulation
       */
      get: function() {
        return this._count;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "zeroCount", {
      /**
       * @returns {Number} The number of 0 values recorded by this accumulation
       */
      get: function() {
        return this._zeroCount;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "scale", {
      /**
       * @returns {Number} The scale used by this accumulation
       */
      get: function() {
        return this._count === this._zeroCount ? 0 : this._mapping.scale;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "positive", {
      /**
       * positive holds the positive values
       * @returns {Buckets}
       */
      get: function() {
        return this._positive;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "negative", {
      /**
       * negative holds the negative values by their absolute value
       * @returns {Buckets}
       */
      get: function() {
        return this._negative;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.updateByIncrement = function(t, r) {
      if (!Number.isNaN(t)) {
        if (t > this._max && (this._max = t), t < this._min && (this._min = t), this._count += r, t === 0) {
          this._zeroCount += r;
          return;
        }
        this._sum += t * r, t > 0 ? this._updateBuckets(this._positive, t, r) : this._updateBuckets(this._negative, -t, r);
      }
    }, e.prototype.merge = function(t) {
      this._count === 0 ? (this._min = t.min, this._max = t.max) : t.count !== 0 && (t.min < this.min && (this._min = t.min), t.max > this.max && (this._max = t.max)), this.startTime = t.startTime, this._sum += t.sum, this._count += t.count, this._zeroCount += t.zeroCount;
      var r = this._minScale(t);
      this._downscale(this.scale - r), this._mergeBuckets(this.positive, t, t.positive, r), this._mergeBuckets(this.negative, t, t.negative, r);
    }, e.prototype.diff = function(t) {
      this._min = 1 / 0, this._max = -1 / 0, this._sum -= t.sum, this._count -= t.count, this._zeroCount -= t.zeroCount;
      var r = this._minScale(t);
      this._downscale(this.scale - r), this._diffBuckets(this.positive, t, t.positive, r), this._diffBuckets(this.negative, t, t.negative, r);
    }, e.prototype.clone = function() {
      return new e(this.startTime, this._maxSize, this._recordMinMax, this._sum, this._count, this._zeroCount, this._min, this._max, this.positive.clone(), this.negative.clone(), this._mapping);
    }, e.prototype._updateBuckets = function(t, r, n) {
      var i = this._mapping.mapToIndex(r), o = !1, a = 0, u = 0;
      if (t.length === 0 ? (t.indexStart = i, t.indexEnd = t.indexStart, t.indexBase = t.indexStart) : i < t.indexStart && t.indexEnd - i >= this._maxSize ? (o = !0, u = i, a = t.indexEnd) : i > t.indexEnd && i - t.indexStart >= this._maxSize && (o = !0, u = t.indexStart, a = i), o) {
        var c = this._changeScale(a, u);
        this._downscale(c), i = this._mapping.mapToIndex(r);
      }
      this._incrementIndexBy(t, i, n);
    }, e.prototype._incrementIndexBy = function(t, r, n) {
      if (n !== 0) {
        if (t.length === 0 && (t.indexStart = t.indexEnd = t.indexBase = r), r < t.indexStart) {
          var i = t.indexEnd - r;
          i >= t.backing.length && this._grow(t, i + 1), t.indexStart = r;
        } else if (r > t.indexEnd) {
          var i = r - t.indexStart;
          i >= t.backing.length && this._grow(t, i + 1), t.indexEnd = r;
        }
        var o = r - t.indexBase;
        o < 0 && (o += t.backing.length), t.incrementBucket(o, n);
      }
    }, e.prototype._grow = function(t, r) {
      var n = t.backing.length, i = t.indexBase - t.indexStart, o = n - i, a = Ov(r);
      a > this._maxSize && (a = this._maxSize);
      var u = a - i;
      t.backing.growTo(a, o, u);
    }, e.prototype._changeScale = function(t, r) {
      for (var n = 0; t - r >= this._maxSize; )
        t >>= 1, r >>= 1, n++;
      return n;
    }, e.prototype._downscale = function(t) {
      if (t !== 0) {
        if (t < 0)
          throw new Error("impossible change of scale: " + this.scale);
        var r = this._mapping.scale - t;
        this._positive.downscale(t), this._negative.downscale(t), this._mapping = ao(r);
      }
    }, e.prototype._minScale = function(t) {
      var r = Math.min(this.scale, t.scale), n = Pe.combine(this._highLowAtScale(this.positive, this.scale, r), this._highLowAtScale(t.positive, t.scale, r)), i = Pe.combine(this._highLowAtScale(this.negative, this.scale, r), this._highLowAtScale(t.negative, t.scale, r));
      return Math.min(r - this._changeScale(n.high, n.low), r - this._changeScale(i.high, i.low));
    }, e.prototype._highLowAtScale = function(t, r, n) {
      if (t.length === 0)
        return new Pe(0, -1);
      var i = r - n;
      return new Pe(t.indexStart >> i, t.indexEnd >> i);
    }, e.prototype._mergeBuckets = function(t, r, n, i) {
      for (var o = n.offset, a = r.scale - i, u = 0; u < n.length; u++)
        this._incrementIndexBy(t, o + u >> a, n.at(u));
    }, e.prototype._diffBuckets = function(t, r, n, i) {
      for (var o = n.offset, a = r.scale - i, u = 0; u < n.length; u++) {
        var c = o + u >> a, s = c - t.indexBase;
        s < 0 && (s += t.backing.length), t.decrementBucket(s, n.at(u));
      }
      t.trim();
    }, e;
  }()
), Cv = (
  /** @class */
  function() {
    function e(t, r) {
      this._maxSize = t, this._recordMinMax = r, this.kind = Tt.EXPONENTIAL_HISTOGRAM;
    }
    return e.prototype.createAccumulation = function(t) {
      return new Iv(t, this._maxSize, this._recordMinMax);
    }, e.prototype.merge = function(t, r) {
      var n = r.clone();
      return n.merge(t), n;
    }, e.prototype.diff = function(t, r) {
      var n = r.clone();
      return n.diff(t), n;
    }, e.prototype.toMetricData = function(t, r, n, i) {
      return {
        descriptor: t,
        aggregationTemporality: r,
        dataPointType: Y.EXPONENTIAL_HISTOGRAM,
        dataPoints: n.map(function(o) {
          var a = Lv(o, 2), u = a[0], c = a[1], s = c.toPointValue(), f = t.type === T.GAUGE || t.type === T.UP_DOWN_COUNTER || t.type === T.OBSERVABLE_GAUGE || t.type === T.OBSERVABLE_UP_DOWN_COUNTER;
          return {
            attributes: u,
            startTime: c.startTime,
            endTime: i,
            value: {
              min: s.hasMinMax ? s.min : void 0,
              max: s.hasMinMax ? s.max : void 0,
              sum: f ? void 0 : s.sum,
              positive: {
                offset: s.positive.offset,
                bucketCounts: s.positive.bucketCounts
              },
              negative: {
                offset: s.negative.offset,
                bucketCounts: s.negative.bucketCounts
              },
              count: s.count,
              scale: s.scale,
              zeroCount: s.zeroCount
            }
          };
        })
      };
    }, e;
  }()
), Mv = Ee("OpenTelemetry SDK Context Key SUPPRESS_TRACING");
function xv(e) {
  return e.setValue(Mv, !0);
}
function Dv() {
  return function(e) {
    v.error(Uv(e));
  };
}
function Uv(e) {
  return typeof e == "string" ? e : JSON.stringify(Bv(e));
}
function Bv(e) {
  for (var t = {}, r = e; r !== null; )
    Object.getOwnPropertyNames(r).forEach(function(n) {
      if (!t[n]) {
        var i = r[n];
        i && (t[n] = String(i));
      }
    }), r = Object.getPrototypeOf(r);
  return t;
}
var kv = Dv();
function so(e) {
  try {
    kv(e);
  } catch (t) {
  }
}
var Hv = 6, Gv = Math.pow(10, Hv);
function Wn(e) {
  var t = e / 1e3, r = Math.trunc(t), n = Math.round(e % 1e3 * Gv);
  return [r, n];
}
function Ne(e) {
  return e[0] * 1e6 + e[1] / 1e3;
}
var Nn;
(function(e) {
  e[e.SUCCESS = 0] = "SUCCESS", e[e.FAILED = 1] = "FAILED";
})(Nn || (Nn = {}));
function $v(e, t) {
  return new Promise(function(r) {
    O.with(xv(O.active()), function() {
      e.export(t, function(n) {
        r(n);
      });
    });
  });
}
var jv = {
  _export: $v
}, Vv = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, zr = (
  /** @class */
  function() {
    function e(t, r, n) {
      r === void 0 && (r = 0), n === void 0 && (n = [0, 0]), this.startTime = t, this._current = r, this.sampleTime = n;
    }
    return e.prototype.record = function(t) {
      this._current = t, this.sampleTime = Wn(Date.now());
    }, e.prototype.setStartTime = function(t) {
      this.startTime = t;
    }, e.prototype.toPointValue = function() {
      return this._current;
    }, e;
  }()
), Fv = (
  /** @class */
  function() {
    function e() {
      this.kind = Tt.LAST_VALUE;
    }
    return e.prototype.createAccumulation = function(t) {
      return new zr(t);
    }, e.prototype.merge = function(t, r) {
      var n = Ne(r.sampleTime) >= Ne(t.sampleTime) ? r : t;
      return new zr(t.startTime, n.toPointValue(), n.sampleTime);
    }, e.prototype.diff = function(t, r) {
      var n = Ne(r.sampleTime) >= Ne(t.sampleTime) ? r : t;
      return new zr(r.startTime, n.toPointValue(), n.sampleTime);
    }, e.prototype.toMetricData = function(t, r, n, i) {
      return {
        descriptor: t,
        aggregationTemporality: r,
        dataPointType: Y.GAUGE,
        dataPoints: n.map(function(o) {
          var a = Vv(o, 2), u = a[0], c = a[1];
          return {
            attributes: u,
            startTime: c.startTime,
            endTime: i,
            value: c.toPointValue()
          };
        })
      };
    }, e;
  }()
), Xv = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, ee = (
  /** @class */
  function() {
    function e(t, r, n, i) {
      n === void 0 && (n = 0), i === void 0 && (i = !1), this.startTime = t, this.monotonic = r, this._current = n, this.reset = i;
    }
    return e.prototype.record = function(t) {
      this.monotonic && t < 0 || (this._current += t);
    }, e.prototype.setStartTime = function(t) {
      this.startTime = t;
    }, e.prototype.toPointValue = function() {
      return this._current;
    }, e;
  }()
), uo = (
  /** @class */
  function() {
    function e(t) {
      this.monotonic = t, this.kind = Tt.SUM;
    }
    return e.prototype.createAccumulation = function(t) {
      return new ee(t, this.monotonic);
    }, e.prototype.merge = function(t, r) {
      var n = t.toPointValue(), i = r.toPointValue();
      return r.reset ? new ee(r.startTime, this.monotonic, i, r.reset) : new ee(t.startTime, this.monotonic, n + i);
    }, e.prototype.diff = function(t, r) {
      var n = t.toPointValue(), i = r.toPointValue();
      return this.monotonic && n > i ? new ee(r.startTime, this.monotonic, i, !0) : new ee(r.startTime, this.monotonic, i - n);
    }, e.prototype.toMetricData = function(t, r, n, i) {
      return {
        descriptor: t,
        aggregationTemporality: r,
        dataPointType: Y.SUM,
        dataPoints: n.map(function(o) {
          var a = Xv(o, 2), u = a[0], c = a[1];
          return {
            attributes: u,
            startTime: c.startTime,
            endTime: i,
            value: c.toPointValue()
          };
        }),
        isMonotonic: this.monotonic
      };
    }, e;
  }()
), bt = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), nt = (
  /** @class */
  function() {
    function e() {
    }
    return e.Drop = function() {
      return fs;
    }, e.Sum = function() {
      return ls;
    }, e.LastValue = function() {
      return ds;
    }, e.Histogram = function() {
      return ps;
    }, e.ExponentialHistogram = function() {
      return Qv;
    }, e.Default = function() {
      return tg;
    }, e;
  }()
), zv = (
  /** @class */
  function(e) {
    bt(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.createAggregator = function(r) {
      return t.DEFAULT_INSTANCE;
    }, t.DEFAULT_INSTANCE = new dv(), t;
  }(nt)
), qv = (
  /** @class */
  function(e) {
    bt(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.createAggregator = function(r) {
      switch (r.type) {
        case T.COUNTER:
        case T.OBSERVABLE_COUNTER:
        case T.HISTOGRAM:
          return t.MONOTONIC_INSTANCE;
        default:
          return t.NON_MONOTONIC_INSTANCE;
      }
    }, t.MONOTONIC_INSTANCE = new uo(!0), t.NON_MONOTONIC_INSTANCE = new uo(!1), t;
  }(nt)
), Wv = (
  /** @class */
  function(e) {
    bt(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.createAggregator = function(r) {
      return t.DEFAULT_INSTANCE;
    }, t.DEFAULT_INSTANCE = new Fv(), t;
  }(nt)
), Yv = (
  /** @class */
  function(e) {
    bt(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.createAggregator = function(r) {
      return t.DEFAULT_INSTANCE;
    }, t.DEFAULT_INSTANCE = new os([0, 5, 10, 25, 50, 75, 100, 250, 500, 750, 1e3, 2500, 5e3, 7500, 1e4], !0), t;
  }(nt)
), Kv = (
  /** @class */
  function(e) {
    bt(t, e);
    function t(r, n) {
      n === void 0 && (n = !0);
      var i = e.call(this) || this;
      if (i._recordMinMax = n, r == null)
        throw new Error("ExplicitBucketHistogramAggregation should be created with explicit boundaries, if a single bucket histogram is required, please pass an empty array");
      r = r.concat(), r = r.sort(function(u, c) {
        return u - c;
      });
      var o = r.lastIndexOf(-1 / 0), a = r.indexOf(1 / 0);
      return a === -1 && (a = void 0), i._boundaries = r.slice(o + 1, a), i;
    }
    return t.prototype.createAggregator = function(r) {
      return new os(this._boundaries, this._recordMinMax);
    }, t;
  }(nt)
), Jv = (
  /** @class */
  function(e) {
    bt(t, e);
    function t(r, n) {
      r === void 0 && (r = 160), n === void 0 && (n = !0);
      var i = e.call(this) || this;
      return i._maxSize = r, i._recordMinMax = n, i;
    }
    return t.prototype.createAggregator = function(r) {
      return new Cv(this._maxSize, this._recordMinMax);
    }, t;
  }(nt)
), Zv = (
  /** @class */
  function(e) {
    bt(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype._resolve = function(r) {
      switch (r.type) {
        case T.COUNTER:
        case T.UP_DOWN_COUNTER:
        case T.OBSERVABLE_COUNTER:
        case T.OBSERVABLE_UP_DOWN_COUNTER:
          return ls;
        case T.GAUGE:
        case T.OBSERVABLE_GAUGE:
          return ds;
        case T.HISTOGRAM:
          return r.advice.explicitBucketBoundaries ? new Kv(r.advice.explicitBucketBoundaries) : ps;
      }
      return v.warn("Unable to recognize instrument type: " + r.type), fs;
    }, t.prototype.createAggregator = function(r) {
      return this._resolve(r).createAggregator(r);
    }, t;
  }(nt)
), fs = new zv(), ls = new qv(), ds = new Wv(), ps = new Yv(), Qv = new Jv(), tg = new Zv(), eg = function(e) {
  return nt.Default();
}, rg = function(e) {
  return X.CUMULATIVE;
}, qr = function(e, t, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function u(f) {
      try {
        s(n.next(f));
      } catch (l) {
        a(l);
      }
    }
    function c(f) {
      try {
        s(n.throw(f));
      } catch (l) {
        a(l);
      }
    }
    function s(f) {
      f.done ? o(f.value) : i(f.value).then(u, c);
    }
    s((n = n.apply(e, t || [])).next());
  });
}, Wr = function(e, t) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(f) {
      return c([s, f]);
    };
  }
  function c(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return r.label++, { value: s[1], done: !1 };
        case 5:
          r.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            r = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            r.label = s[1];
            break;
          }
          if (s[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = s;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(s);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      s = t.call(e, r);
    } catch (f) {
      s = [6, f], i = 0;
    } finally {
      n = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, co = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, ng = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, ig = (
  /** @class */
  function() {
    function e(t) {
      var r, n, i;
      this._shutdown = !1, this._aggregationSelector = (r = t == null ? void 0 : t.aggregationSelector) !== null && r !== void 0 ? r : eg, this._aggregationTemporalitySelector = (n = t == null ? void 0 : t.aggregationTemporalitySelector) !== null && n !== void 0 ? n : rg, this._metricProducers = (i = t == null ? void 0 : t.metricProducers) !== null && i !== void 0 ? i : [], this._cardinalitySelector = t == null ? void 0 : t.cardinalitySelector;
    }
    return e.prototype.setMetricProducer = function(t) {
      if (this._sdkMetricProducer)
        throw new Error("MetricReader can not be bound to a MeterProvider again.");
      this._sdkMetricProducer = t, this.onInitialized();
    }, e.prototype.selectAggregation = function(t) {
      return this._aggregationSelector(t);
    }, e.prototype.selectAggregationTemporality = function(t) {
      return this._aggregationTemporalitySelector(t);
    }, e.prototype.selectCardinalityLimit = function(t) {
      return this._cardinalitySelector ? this._cardinalitySelector(t) : 2e3;
    }, e.prototype.onInitialized = function() {
    }, e.prototype.collect = function(t) {
      return qr(this, void 0, void 0, function() {
        var r, n, i, o, a, u;
        return Wr(this, function(c) {
          switch (c.label) {
            case 0:
              if (this._sdkMetricProducer === void 0)
                throw new Error("MetricReader is not bound to a MetricProducer");
              if (this._shutdown)
                throw new Error("MetricReader is shutdown");
              return [4, Promise.all(ng([
                this._sdkMetricProducer.collect({
                  timeoutMillis: t == null ? void 0 : t.timeoutMillis
                })
              ], co(this._metricProducers.map(function(s) {
                return s.collect({
                  timeoutMillis: t == null ? void 0 : t.timeoutMillis
                });
              })), !1))];
            case 1:
              return r = co.apply(void 0, [c.sent()]), n = r[0], i = r.slice(1), o = n.errors.concat(ro(i, function(s) {
                return s.errors;
              })), a = n.resourceMetrics.resource, u = n.resourceMetrics.scopeMetrics.concat(ro(i, function(s) {
                return s.resourceMetrics.scopeMetrics;
              })), [2, {
                resourceMetrics: {
                  resource: a,
                  scopeMetrics: u
                },
                errors: o
              }];
          }
        });
      });
    }, e.prototype.shutdown = function(t) {
      return qr(this, void 0, void 0, function() {
        return Wr(this, function(r) {
          switch (r.label) {
            case 0:
              return this._shutdown ? (v.error("Cannot call shutdown twice."), [
                2
                /*return*/
              ]) : (t == null ? void 0 : t.timeoutMillis) != null ? [3, 2] : [4, this.onShutdown()];
            case 1:
              return r.sent(), [3, 4];
            case 2:
              return [4, he(this.onShutdown(), t.timeoutMillis)];
            case 3:
              r.sent(), r.label = 4;
            case 4:
              return this._shutdown = !0, [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.forceFlush = function(t) {
      return qr(this, void 0, void 0, function() {
        return Wr(this, function(r) {
          switch (r.label) {
            case 0:
              return this._shutdown ? (v.warn("Cannot forceFlush on already shutdown MetricReader."), [
                2
                /*return*/
              ]) : (t == null ? void 0 : t.timeoutMillis) != null ? [3, 2] : [4, this.onForceFlush()];
            case 1:
              return r.sent(), [
                2
                /*return*/
              ];
            case 2:
              return [4, he(this.onForceFlush(), t.timeoutMillis)];
            case 3:
              return r.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, e;
  }()
), og = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), Ie = function(e, t, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function u(f) {
      try {
        s(n.next(f));
      } catch (l) {
        a(l);
      }
    }
    function c(f) {
      try {
        s(n.throw(f));
      } catch (l) {
        a(l);
      }
    }
    function s(f) {
      f.done ? o(f.value) : i(f.value).then(u, c);
    }
    s((n = n.apply(e, t || [])).next());
  });
}, Ce = function(e, t) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(f) {
      return c([s, f]);
    };
  }
  function c(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return r.label++, { value: s[1], done: !1 };
        case 5:
          r.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            r = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            r.label = s[1];
            break;
          }
          if (s[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = s;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(s);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      s = t.call(e, r);
    } catch (f) {
      s = [6, f], i = 0;
    } finally {
      n = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, ag = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, sg = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, ug = (
  /** @class */
  function(e) {
    og(t, e);
    function t(r) {
      var n, i, o, a, u = e.call(this, {
        aggregationSelector: (n = r.exporter.selectAggregation) === null || n === void 0 ? void 0 : n.bind(r.exporter),
        aggregationTemporalitySelector: (i = r.exporter.selectAggregationTemporality) === null || i === void 0 ? void 0 : i.bind(r.exporter),
        metricProducers: r.metricProducers
      }) || this;
      if (r.exportIntervalMillis !== void 0 && r.exportIntervalMillis <= 0)
        throw Error("exportIntervalMillis must be greater than 0");
      if (r.exportTimeoutMillis !== void 0 && r.exportTimeoutMillis <= 0)
        throw Error("exportTimeoutMillis must be greater than 0");
      if (r.exportTimeoutMillis !== void 0 && r.exportIntervalMillis !== void 0 && r.exportIntervalMillis < r.exportTimeoutMillis)
        throw Error("exportIntervalMillis must be greater than or equal to exportTimeoutMillis");
      return u._exportInterval = (o = r.exportIntervalMillis) !== null && o !== void 0 ? o : 6e4, u._exportTimeout = (a = r.exportTimeoutMillis) !== null && a !== void 0 ? a : 3e4, u._exporter = r.exporter, u;
    }
    return t.prototype._runOnce = function() {
      return Ie(this, void 0, void 0, function() {
        var r;
        return Ce(this, function(n) {
          switch (n.label) {
            case 0:
              return n.trys.push([0, 2, , 3]), [4, he(this._doRun(), this._exportTimeout)];
            case 1:
              return n.sent(), [3, 3];
            case 2:
              return r = n.sent(), r instanceof is ? (v.error("Export took longer than %s milliseconds and timed out.", this._exportTimeout), [
                2
                /*return*/
              ]) : (so(r), [3, 3]);
            case 3:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype._doRun = function() {
      var r, n;
      return Ie(this, void 0, void 0, function() {
        var i, o, a, u, c, s;
        return Ce(this, function(f) {
          switch (f.label) {
            case 0:
              return [4, this.collect({
                timeoutMillis: this._exportTimeout
              })];
            case 1:
              if (i = f.sent(), o = i.resourceMetrics, a = i.errors, a.length > 0 && (s = v).error.apply(s, sg(["PeriodicExportingMetricReader: metrics collection errors"], ag(a), !1)), !o.resource.asyncAttributesPending) return [3, 5];
              f.label = 2;
            case 2:
              return f.trys.push([2, 4, , 5]), [4, (n = (r = o.resource).waitForAsyncAttributes) === null || n === void 0 ? void 0 : n.call(r)];
            case 3:
              return f.sent(), [3, 5];
            case 4:
              return u = f.sent(), v.debug("Error while resolving async portion of resource: ", u), so(u), [3, 5];
            case 5:
              return o.scopeMetrics.length === 0 ? [
                2
                /*return*/
              ] : [4, jv._export(this._exporter, o)];
            case 6:
              if (c = f.sent(), c.code !== Nn.SUCCESS)
                throw new Error("PeriodicExportingMetricReader: metrics export failed (error " + c.error + ")");
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.onInitialized = function() {
      var r = this;
      this._interval = setInterval(function() {
        r._runOnce();
      }, this._exportInterval);
    }, t.prototype.onForceFlush = function() {
      return Ie(this, void 0, void 0, function() {
        return Ce(this, function(r) {
          switch (r.label) {
            case 0:
              return [4, this._runOnce()];
            case 1:
              return r.sent(), [4, this._exporter.forceFlush()];
            case 2:
              return r.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.onShutdown = function() {
      return Ie(this, void 0, void 0, function() {
        return Ce(this, function(r) {
          switch (r.label) {
            case 0:
              return this._interval && clearInterval(this._interval), [4, this.onForceFlush()];
            case 1:
              return r.sent(), [4, this._exporter.shutdown()];
            case 2:
              return r.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, t;
  }(ig)
), cg = (
  /** @class */
  function() {
    function e() {
      this._registeredViews = [];
    }
    return e.prototype.addView = function(t) {
      this._registeredViews.push(t);
    }, e.prototype.findViews = function(t, r) {
      var n = this, i = this._registeredViews.filter(function(o) {
        return n._matchInstrument(o.instrumentSelector, t) && n._matchMeter(o.meterSelector, r);
      });
      return i;
    }, e.prototype._matchInstrument = function(t, r) {
      return (t.getType() === void 0 || r.type === t.getType()) && t.getNameFilter().match(r.name) && t.getUnitFilter().match(r.unit);
    }, e.prototype._matchMeter = function(t, r) {
      return t.getNameFilter().match(r.name) && (r.version === void 0 || t.getVersionFilter().match(r.version)) && (r.schemaUrl === void 0 || t.getSchemaUrlFilter().match(r.schemaUrl));
    }, e;
  }()
), wt = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), or = (
  /** @class */
  function() {
    function e(t, r) {
      this._writableMetricStorage = t, this._descriptor = r;
    }
    return e.prototype._record = function(t, r, n) {
      if (r === void 0 && (r = {}), n === void 0 && (n = O.active()), typeof t != "number") {
        v.warn("non-number value provided to metric " + this._descriptor.name + ": " + t);
        return;
      }
      this._descriptor.valueType === ft.INT && !Number.isInteger(t) && (v.warn("INT value type cannot accept a floating-point value for " + this._descriptor.name + ", ignoring the fractional digits."), t = Math.trunc(t), !Number.isInteger(t)) || this._writableMetricStorage.record(t, r, n, Wn(Date.now()));
    }, e;
  }()
), fg = (
  /** @class */
  function(e) {
    wt(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.add = function(r, n, i) {
      this._record(r, n, i);
    }, t;
  }(or)
), lg = (
  /** @class */
  function(e) {
    wt(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.add = function(r, n, i) {
      if (r < 0) {
        v.warn("negative value provided to counter " + this._descriptor.name + ": " + r);
        return;
      }
      this._record(r, n, i);
    }, t;
  }(or)
), dg = (
  /** @class */
  function(e) {
    wt(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.record = function(r, n, i) {
      this._record(r, n, i);
    }, t;
  }(or)
), pg = (
  /** @class */
  function(e) {
    wt(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.record = function(r, n, i) {
      if (r < 0) {
        v.warn("negative value provided to histogram " + this._descriptor.name + ": " + r);
        return;
      }
      this._record(r, n, i);
    }, t;
  }(or)
), ar = (
  /** @class */
  function() {
    function e(t, r, n) {
      this._observableRegistry = n, this._descriptor = t, this._metricStorages = r;
    }
    return e.prototype.addCallback = function(t) {
      this._observableRegistry.addCallback(t, this);
    }, e.prototype.removeCallback = function(t) {
      this._observableRegistry.removeCallback(t, this);
    }, e;
  }()
), hg = (
  /** @class */
  function(e) {
    wt(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t;
  }(ar)
), _g = (
  /** @class */
  function(e) {
    wt(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t;
  }(ar)
), vg = (
  /** @class */
  function(e) {
    wt(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t;
  }(ar)
);
function In(e) {
  return e instanceof ar;
}
var gg = (
  /** @class */
  function() {
    function e(t) {
      this._meterSharedState = t;
    }
    return e.prototype.createGauge = function(t, r) {
      var n = it(t, T.GAUGE, r), i = this._meterSharedState.registerMetricStorage(n);
      return new dg(i, n);
    }, e.prototype.createHistogram = function(t, r) {
      var n = it(t, T.HISTOGRAM, r), i = this._meterSharedState.registerMetricStorage(n);
      return new pg(i, n);
    }, e.prototype.createCounter = function(t, r) {
      var n = it(t, T.COUNTER, r), i = this._meterSharedState.registerMetricStorage(n);
      return new lg(i, n);
    }, e.prototype.createUpDownCounter = function(t, r) {
      var n = it(t, T.UP_DOWN_COUNTER, r), i = this._meterSharedState.registerMetricStorage(n);
      return new fg(i, n);
    }, e.prototype.createObservableGauge = function(t, r) {
      var n = it(t, T.OBSERVABLE_GAUGE, r), i = this._meterSharedState.registerAsyncMetricStorage(n);
      return new _g(n, i, this._meterSharedState.observableRegistry);
    }, e.prototype.createObservableCounter = function(t, r) {
      var n = it(t, T.OBSERVABLE_COUNTER, r), i = this._meterSharedState.registerAsyncMetricStorage(n);
      return new hg(n, i, this._meterSharedState.observableRegistry);
    }, e.prototype.createObservableUpDownCounter = function(t, r) {
      var n = it(t, T.OBSERVABLE_UP_DOWN_COUNTER, r), i = this._meterSharedState.registerAsyncMetricStorage(n);
      return new vg(n, i, this._meterSharedState.observableRegistry);
    }, e.prototype.addBatchObservableCallback = function(t, r) {
      this._meterSharedState.observableRegistry.addBatchCallback(t, r);
    }, e.prototype.removeBatchObservableCallback = function(t, r) {
      this._meterSharedState.observableRegistry.removeBatchCallback(t, r);
    }, e;
  }()
), hs = (
  /** @class */
  function() {
    function e(t) {
      this._instrumentDescriptor = t;
    }
    return e.prototype.getInstrumentDescriptor = function() {
      return this._instrumentDescriptor;
    }, e.prototype.updateDescription = function(t) {
      this._instrumentDescriptor = it(this._instrumentDescriptor.name, this._instrumentDescriptor.type, {
        description: t,
        valueType: this._instrumentDescriptor.valueType,
        unit: this._instrumentDescriptor.unit,
        advice: this._instrumentDescriptor.advice
      });
    }, e;
  }()
), Eg = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), fo = function(e, t) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(f) {
      return c([s, f]);
    };
  }
  function c(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return r.label++, { value: s[1], done: !1 };
        case 5:
          r.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            r = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            r.label = s[1];
            break;
          }
          if (s[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = s;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(s);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      s = t.call(e, r);
    } catch (f) {
      s = [6, f], i = 0;
    } finally {
      n = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, yg = (
  /** @class */
  function() {
    function e(t) {
      this._hash = t, this._valueMap = /* @__PURE__ */ new Map(), this._keyMap = /* @__PURE__ */ new Map();
    }
    return e.prototype.get = function(t, r) {
      return r != null || (r = this._hash(t)), this._valueMap.get(r);
    }, e.prototype.getOrDefault = function(t, r) {
      var n = this._hash(t);
      if (this._valueMap.has(n))
        return this._valueMap.get(n);
      var i = r();
      return this._keyMap.has(n) || this._keyMap.set(n, t), this._valueMap.set(n, i), i;
    }, e.prototype.set = function(t, r, n) {
      n != null || (n = this._hash(t)), this._keyMap.has(n) || this._keyMap.set(n, t), this._valueMap.set(n, r);
    }, e.prototype.has = function(t, r) {
      return r != null || (r = this._hash(t)), this._valueMap.has(r);
    }, e.prototype.keys = function() {
      var t, r;
      return fo(this, function(n) {
        switch (n.label) {
          case 0:
            t = this._keyMap.entries(), r = t.next(), n.label = 1;
          case 1:
            return r.done === !0 ? [3, 3] : [4, [r.value[1], r.value[0]]];
          case 2:
            return n.sent(), r = t.next(), [3, 1];
          case 3:
            return [
              2
              /*return*/
            ];
        }
      });
    }, e.prototype.entries = function() {
      var t, r;
      return fo(this, function(n) {
        switch (n.label) {
          case 0:
            t = this._valueMap.entries(), r = t.next(), n.label = 1;
          case 1:
            return r.done === !0 ? [3, 3] : [4, [this._keyMap.get(r.value[0]), r.value[1], r.value[0]]];
          case 2:
            return n.sent(), r = t.next(), [3, 1];
          case 3:
            return [
              2
              /*return*/
            ];
        }
      });
    }, Object.defineProperty(e.prototype, "size", {
      get: function() {
        return this._valueMap.size;
      },
      enumerable: !1,
      configurable: !0
    }), e;
  }()
), Et = (
  /** @class */
  function(e) {
    Eg(t, e);
    function t() {
      return e.call(this, ns) || this;
    }
    return t;
  }(yg)
), mg = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, _s = (
  /** @class */
  function() {
    function e(t, r) {
      this._aggregator = t, this._activeCollectionStorage = new Et(), this._cumulativeMemoStorage = new Et(), this._overflowAttributes = { "otel.metric.overflow": !0 }, this._cardinalityLimit = (r != null ? r : 2e3) - 1, this._overflowHashCode = ns(this._overflowAttributes);
    }
    return e.prototype.record = function(t, r, n, i) {
      var o = this, a = this._activeCollectionStorage.get(r);
      if (!a) {
        if (this._activeCollectionStorage.size >= this._cardinalityLimit) {
          var u = this._activeCollectionStorage.getOrDefault(this._overflowAttributes, function() {
            return o._aggregator.createAccumulation(i);
          });
          u == null || u.record(t);
          return;
        }
        a = this._aggregator.createAccumulation(i), this._activeCollectionStorage.set(r, a);
      }
      a == null || a.record(t);
    }, e.prototype.batchCumulate = function(t, r) {
      var n = this;
      Array.from(t.entries()).forEach(function(i) {
        var o = mg(i, 3), a = o[0], u = o[1], c = o[2], s = n._aggregator.createAccumulation(r);
        s == null || s.record(u);
        var f = s;
        if (n._cumulativeMemoStorage.has(a, c)) {
          var l = n._cumulativeMemoStorage.get(a, c);
          f = n._aggregator.diff(l, s);
        } else if (n._cumulativeMemoStorage.size >= n._cardinalityLimit && (a = n._overflowAttributes, c = n._overflowHashCode, n._cumulativeMemoStorage.has(a, c))) {
          var l = n._cumulativeMemoStorage.get(a, c);
          f = n._aggregator.diff(l, s);
        }
        if (n._activeCollectionStorage.has(a, c)) {
          var d = n._activeCollectionStorage.get(a, c);
          f = n._aggregator.merge(d, f);
        }
        n._cumulativeMemoStorage.set(a, s, c), n._activeCollectionStorage.set(a, f, c);
      });
    }, e.prototype.collect = function() {
      var t = this._activeCollectionStorage;
      return this._activeCollectionStorage = new Et(), t;
    }, e;
  }()
), Yr = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, lo = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, vs = (
  /** @class */
  function() {
    function e(t, r) {
      var n = this;
      this._aggregator = t, this._unreportedAccumulations = /* @__PURE__ */ new Map(), this._reportHistory = /* @__PURE__ */ new Map(), r.forEach(function(i) {
        n._unreportedAccumulations.set(i, []);
      });
    }
    return e.prototype.buildMetrics = function(t, r, n, i) {
      this._stashAccumulations(n);
      var o = this._getMergedUnreportedAccumulations(t), a = o, u;
      if (this._reportHistory.has(t)) {
        var c = this._reportHistory.get(t), s = c.collectionTime;
        u = c.aggregationTemporality, u === X.CUMULATIVE ? a = e.merge(c.accumulations, o, this._aggregator) : a = e.calibrateStartTime(c.accumulations, o, s);
      } else
        u = t.selectAggregationTemporality(r.type);
      this._reportHistory.set(t, {
        accumulations: a,
        collectionTime: i,
        aggregationTemporality: u
      });
      var f = Tg(a);
      if (f.length !== 0)
        return this._aggregator.toMetricData(
          r,
          u,
          f,
          /* endTime */
          i
        );
    }, e.prototype._stashAccumulations = function(t) {
      var r, n, i = this._unreportedAccumulations.keys();
      try {
        for (var o = Yr(i), a = o.next(); !a.done; a = o.next()) {
          var u = a.value, c = this._unreportedAccumulations.get(u);
          c === void 0 && (c = [], this._unreportedAccumulations.set(u, c)), c.push(t);
        }
      } catch (s) {
        r = { error: s };
      } finally {
        try {
          a && !a.done && (n = o.return) && n.call(o);
        } finally {
          if (r) throw r.error;
        }
      }
    }, e.prototype._getMergedUnreportedAccumulations = function(t) {
      var r, n, i = new Et(), o = this._unreportedAccumulations.get(t);
      if (this._unreportedAccumulations.set(t, []), o === void 0)
        return i;
      try {
        for (var a = Yr(o), u = a.next(); !u.done; u = a.next()) {
          var c = u.value;
          i = e.merge(i, c, this._aggregator);
        }
      } catch (s) {
        r = { error: s };
      } finally {
        try {
          u && !u.done && (n = a.return) && n.call(a);
        } finally {
          if (r) throw r.error;
        }
      }
      return i;
    }, e.merge = function(t, r, n) {
      for (var i = t, o = r.entries(), a = o.next(); a.done !== !0; ) {
        var u = lo(a.value, 3), c = u[0], s = u[1], f = u[2];
        if (t.has(c, f)) {
          var l = t.get(c, f), d = n.merge(l, s);
          i.set(c, d, f);
        } else
          i.set(c, s, f);
        a = o.next();
      }
      return i;
    }, e.calibrateStartTime = function(t, r, n) {
      var i, o;
      try {
        for (var a = Yr(t.keys()), u = a.next(); !u.done; u = a.next()) {
          var c = lo(u.value, 2), s = c[0], f = c[1], l = r.get(s, f);
          l == null || l.setStartTime(n);
        }
      } catch (d) {
        i = { error: d };
      } finally {
        try {
          u && !u.done && (o = a.return) && o.call(a);
        } finally {
          if (i) throw i.error;
        }
      }
      return r;
    }, e;
  }()
);
function Tg(e) {
  return Array.from(e.entries());
}
var Sg = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), Og = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Ag = (
  /** @class */
  function(e) {
    Sg(t, e);
    function t(r, n, i, o, a) {
      var u = e.call(this, r) || this;
      return u._attributesProcessor = i, u._aggregationCardinalityLimit = a, u._deltaMetricStorage = new _s(n, u._aggregationCardinalityLimit), u._temporalMetricStorage = new vs(n, o), u;
    }
    return t.prototype.record = function(r, n) {
      var i = this, o = new Et();
      Array.from(r.entries()).forEach(function(a) {
        var u = Og(a, 2), c = u[0], s = u[1];
        o.set(i._attributesProcessor.process(c), s);
      }), this._deltaMetricStorage.batchCumulate(o, n);
    }, t.prototype.collect = function(r, n) {
      var i = this._deltaMetricStorage.collect();
      return this._temporalMetricStorage.buildMetrics(r, this._instrumentDescriptor, i, n);
    }, t;
  }(hs)
);
function po(e, t) {
  var r = "";
  return e.unit !== t.unit && (r += "	- Unit '" + e.unit + "' does not match '" + t.unit + `'
`), e.type !== t.type && (r += "	- Type '" + e.type + "' does not match '" + t.type + `'
`), e.valueType !== t.valueType && (r += "	- Value Type '" + e.valueType + "' does not match '" + t.valueType + `'
`), e.description !== t.description && (r += "	- Description '" + e.description + "' does not match '" + t.description + `'
`), r;
}
function bg(e, t) {
  return "	- use valueType '" + e.valueType + "' on instrument creation or use an instrument name other than '" + t.name + "'";
}
function wg(e, t) {
  return "	- use unit '" + e.unit + "' on instrument creation or use an instrument name other than '" + t.name + "'";
}
function Rg(e, t) {
  var r = {
    name: t.name,
    type: t.type,
    unit: t.unit
  }, n = JSON.stringify(r);
  return "	- create a new view with a name other than '" + e.name + "' and InstrumentSelector '" + n + "'";
}
function Lg(e, t) {
  var r = {
    name: t.name,
    type: t.type,
    unit: t.unit
  }, n = JSON.stringify(r);
  return "	- create a new view with a name other than '" + e.name + "' and InstrumentSelector '" + n + `'
    	- OR - create a new view with the name ` + e.name + " and description '" + e.description + "' and InstrumentSelector " + n + `
    	- OR - create a new view with the name ` + t.name + " and description '" + e.description + "' and InstrumentSelector " + n;
}
function ho(e, t) {
  return e.valueType !== t.valueType ? bg(e, t) : e.unit !== t.unit ? wg(e, t) : e.type !== t.type ? Rg(e, t) : e.description !== t.description ? Lg(e, t) : "";
}
var Kr = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Pg = (
  /** @class */
  function() {
    function e() {
      this._sharedRegistry = /* @__PURE__ */ new Map(), this._perCollectorRegistry = /* @__PURE__ */ new Map();
    }
    return e.create = function() {
      return new e();
    }, e.prototype.getStorages = function(t) {
      var r, n, i, o, a = [];
      try {
        for (var u = Kr(this._sharedRegistry.values()), c = u.next(); !c.done; c = u.next()) {
          var s = c.value;
          a = a.concat(s);
        }
      } catch (h) {
        r = { error: h };
      } finally {
        try {
          c && !c.done && (n = u.return) && n.call(u);
        } finally {
          if (r) throw r.error;
        }
      }
      var f = this._perCollectorRegistry.get(t);
      if (f != null)
        try {
          for (var l = Kr(f.values()), d = l.next(); !d.done; d = l.next()) {
            var s = d.value;
            a = a.concat(s);
          }
        } catch (h) {
          i = { error: h };
        } finally {
          try {
            d && !d.done && (o = l.return) && o.call(l);
          } finally {
            if (i) throw i.error;
          }
        }
      return a;
    }, e.prototype.register = function(t) {
      this._registerStorage(t, this._sharedRegistry);
    }, e.prototype.registerForCollector = function(t, r) {
      var n = this._perCollectorRegistry.get(t);
      n == null && (n = /* @__PURE__ */ new Map(), this._perCollectorRegistry.set(t, n)), this._registerStorage(r, n);
    }, e.prototype.findOrUpdateCompatibleStorage = function(t) {
      var r = this._sharedRegistry.get(t.name);
      return r === void 0 ? null : this._findOrUpdateCompatibleStorage(t, r);
    }, e.prototype.findOrUpdateCompatibleCollectorStorage = function(t, r) {
      var n = this._perCollectorRegistry.get(t);
      if (n === void 0)
        return null;
      var i = n.get(r.name);
      return i === void 0 ? null : this._findOrUpdateCompatibleStorage(r, i);
    }, e.prototype._registerStorage = function(t, r) {
      var n = t.getInstrumentDescriptor(), i = r.get(n.name);
      if (i === void 0) {
        r.set(n.name, [t]);
        return;
      }
      i.push(t);
    }, e.prototype._findOrUpdateCompatibleStorage = function(t, r) {
      var n, i, o = null;
      try {
        for (var a = Kr(r), u = a.next(); !u.done; u = a.next()) {
          var c = u.value, s = c.getInstrumentDescriptor();
          hv(s, t) ? (s.description !== t.description && (t.description.length > s.description.length && c.updateDescription(t.description), v.warn("A view or instrument with the name ", t.name, ` has already been registered, but has a different description and is incompatible with another registered view.
`, `Details:
`, po(s, t), `The longer description will be used.
To resolve the conflict:`, ho(s, t))), o = c) : v.warn("A view or instrument with the name ", t.name, ` has already been registered and is incompatible with another registered view.
`, `Details:
`, po(s, t), `To resolve the conflict:
`, ho(s, t));
        }
      } catch (f) {
        n = { error: f };
      } finally {
        try {
          u && !u.done && (i = a.return) && i.call(a);
        } finally {
          if (n) throw n.error;
        }
      }
      return o;
    }, e;
  }()
), Ng = (
  /** @class */
  function() {
    function e(t) {
      this._backingStorages = t;
    }
    return e.prototype.record = function(t, r, n, i) {
      this._backingStorages.forEach(function(o) {
        o.record(t, r, n, i);
      });
    }, e;
  }()
), Ig = (
  /** @class */
  function() {
    function e(t, r) {
      this._instrumentName = t, this._valueType = r, this._buffer = new Et();
    }
    return e.prototype.observe = function(t, r) {
      if (r === void 0 && (r = {}), typeof t != "number") {
        v.warn("non-number value provided to metric " + this._instrumentName + ": " + t);
        return;
      }
      this._valueType === ft.INT && !Number.isInteger(t) && (v.warn("INT value type cannot accept a floating-point value for " + this._instrumentName + ", ignoring the fractional digits."), t = Math.trunc(t), !Number.isInteger(t)) || this._buffer.set(r, t);
    }, e;
  }()
), Cg = (
  /** @class */
  function() {
    function e() {
      this._buffer = /* @__PURE__ */ new Map();
    }
    return e.prototype.observe = function(t, r, n) {
      if (n === void 0 && (n = {}), !!In(t)) {
        var i = this._buffer.get(t);
        if (i == null && (i = new Et(), this._buffer.set(t, i)), typeof r != "number") {
          v.warn("non-number value provided to metric " + t._descriptor.name + ": " + r);
          return;
        }
        t._descriptor.valueType === ft.INT && !Number.isInteger(r) && (v.warn("INT value type cannot accept a floating-point value for " + t._descriptor.name + ", ignoring the fractional digits."), r = Math.trunc(r), !Number.isInteger(r)) || i.set(n, r);
      }
    }, e;
  }()
), Jr = function(e, t, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function u(f) {
      try {
        s(n.next(f));
      } catch (l) {
        a(l);
      }
    }
    function c(f) {
      try {
        s(n.throw(f));
      } catch (l) {
        a(l);
      }
    }
    function s(f) {
      f.done ? o(f.value) : i(f.value).then(u, c);
    }
    s((n = n.apply(e, t || [])).next());
  });
}, Zr = function(e, t) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(f) {
      return c([s, f]);
    };
  }
  function c(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return r.label++, { value: s[1], done: !1 };
        case 5:
          r.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            r = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            r.label = s[1];
            break;
          }
          if (s[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = s;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(s);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      s = t.call(e, r);
    } catch (f) {
      s = [6, f], i = 0;
    } finally {
      n = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, _o = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, vo = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, Mg = (
  /** @class */
  function() {
    function e() {
      this._callbacks = [], this._batchCallbacks = [];
    }
    return e.prototype.addCallback = function(t, r) {
      var n = this._findCallback(t, r);
      n >= 0 || this._callbacks.push({ callback: t, instrument: r });
    }, e.prototype.removeCallback = function(t, r) {
      var n = this._findCallback(t, r);
      n < 0 || this._callbacks.splice(n, 1);
    }, e.prototype.addBatchCallback = function(t, r) {
      var n = new Set(r.filter(In));
      if (n.size === 0) {
        v.error("BatchObservableCallback is not associated with valid instruments", r);
        return;
      }
      var i = this._findBatchCallback(t, n);
      i >= 0 || this._batchCallbacks.push({ callback: t, instruments: n });
    }, e.prototype.removeBatchCallback = function(t, r) {
      var n = new Set(r.filter(In)), i = this._findBatchCallback(t, n);
      i < 0 || this._batchCallbacks.splice(i, 1);
    }, e.prototype.observe = function(t, r) {
      return Jr(this, void 0, void 0, function() {
        var n, i, o, a;
        return Zr(this, function(u) {
          switch (u.label) {
            case 0:
              return n = this._observeCallbacks(t, r), i = this._observeBatchCallbacks(t, r), [4, sv(vo(vo([], _o(n), !1), _o(i), !1))];
            case 1:
              return o = u.sent(), a = o.filter(uv).map(function(c) {
                return c.reason;
              }), [2, a];
          }
        });
      });
    }, e.prototype._observeCallbacks = function(t, r) {
      var n = this;
      return this._callbacks.map(function(i) {
        var o = i.callback, a = i.instrument;
        return Jr(n, void 0, void 0, function() {
          var u, c;
          return Zr(this, function(s) {
            switch (s.label) {
              case 0:
                return u = new Ig(a._descriptor.name, a._descriptor.valueType), c = Promise.resolve(o(u)), r != null && (c = he(c, r)), [4, c];
              case 1:
                return s.sent(), a._metricStorages.forEach(function(f) {
                  f.record(u._buffer, t);
                }), [
                  2
                  /*return*/
                ];
            }
          });
        });
      });
    }, e.prototype._observeBatchCallbacks = function(t, r) {
      var n = this;
      return this._batchCallbacks.map(function(i) {
        var o = i.callback, a = i.instruments;
        return Jr(n, void 0, void 0, function() {
          var u, c;
          return Zr(this, function(s) {
            switch (s.label) {
              case 0:
                return u = new Cg(), c = Promise.resolve(o(u)), r != null && (c = he(c, r)), [4, c];
              case 1:
                return s.sent(), a.forEach(function(f) {
                  var l = u._buffer.get(f);
                  l != null && f._metricStorages.forEach(function(d) {
                    d.record(l, t);
                  });
                }), [
                  2
                  /*return*/
                ];
            }
          });
        });
      });
    }, e.prototype._findCallback = function(t, r) {
      return this._callbacks.findIndex(function(n) {
        return n.callback === t && n.instrument === r;
      });
    }, e.prototype._findBatchCallback = function(t, r) {
      return this._batchCallbacks.findIndex(function(n) {
        return n.callback === t && cv(n.instruments, r);
      });
    }, e;
  }()
), xg = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), Dg = (
  /** @class */
  function(e) {
    xg(t, e);
    function t(r, n, i, o, a) {
      var u = e.call(this, r) || this;
      return u._attributesProcessor = i, u._aggregationCardinalityLimit = a, u._deltaMetricStorage = new _s(n, u._aggregationCardinalityLimit), u._temporalMetricStorage = new vs(n, o), u;
    }
    return t.prototype.record = function(r, n, i, o) {
      n = this._attributesProcessor.process(n, i), this._deltaMetricStorage.record(r, n, i, o);
    }, t.prototype.collect = function(r, n) {
      var i = this._deltaMetricStorage.collect();
      return this._temporalMetricStorage.buildMetrics(r, this._instrumentDescriptor, i, n);
    }, t;
  }(hs)
), gs = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), Yn = (
  /** @class */
  function() {
    function e() {
    }
    return e.Noop = function() {
      return Bg;
    }, e;
  }()
), Ug = (
  /** @class */
  function(e) {
    gs(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.process = function(r, n) {
      return r;
    }, t;
  }(Yn)
);
(function(e) {
  gs(t, e);
  function t(r) {
    var n = e.call(this) || this;
    return n._allowedAttributeNames = r, n;
  }
  return t.prototype.process = function(r, n) {
    var i = this, o = {};
    return Object.keys(r).filter(function(a) {
      return i._allowedAttributeNames.includes(a);
    }).forEach(function(a) {
      return o[a] = r[a];
    }), o;
  }, t;
})(Yn);
var Bg = new Ug(), kg = function(e, t, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function u(f) {
      try {
        s(n.next(f));
      } catch (l) {
        a(l);
      }
    }
    function c(f) {
      try {
        s(n.throw(f));
      } catch (l) {
        a(l);
      }
    }
    function s(f) {
      f.done ? o(f.value) : i(f.value).then(u, c);
    }
    s((n = n.apply(e, t || [])).next());
  });
}, Hg = function(e, t) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(f) {
      return c([s, f]);
    };
  }
  function c(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return r.label++, { value: s[1], done: !1 };
        case 5:
          r.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            r = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            r.label = s[1];
            break;
          }
          if (s[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = s;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(s);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      s = t.call(e, r);
    } catch (f) {
      s = [6, f], i = 0;
    } finally {
      n = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, Gg = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, $g = (
  /** @class */
  function() {
    function e(t, r) {
      this._meterProviderSharedState = t, this._instrumentationScope = r, this.metricStorageRegistry = new Pg(), this.observableRegistry = new Mg(), this.meter = new gg(this);
    }
    return e.prototype.registerMetricStorage = function(t) {
      var r = this._registerMetricStorage(t, Dg);
      return r.length === 1 ? r[0] : new Ng(r);
    }, e.prototype.registerAsyncMetricStorage = function(t) {
      var r = this._registerMetricStorage(t, Ag);
      return r;
    }, e.prototype.collect = function(t, r, n) {
      return kg(this, void 0, void 0, function() {
        var i, o, a;
        return Hg(this, function(u) {
          switch (u.label) {
            case 0:
              return [4, this.observableRegistry.observe(r, n == null ? void 0 : n.timeoutMillis)];
            case 1:
              return i = u.sent(), o = this.metricStorageRegistry.getStorages(t), o.length === 0 ? [2, null] : (a = o.map(function(c) {
                return c.collect(t, r);
              }).filter(ov), a.length === 0 ? [2, { errors: i }] : [2, {
                scopeMetrics: {
                  scope: this._instrumentationScope,
                  metrics: a
                },
                errors: i
              }]);
          }
        });
      });
    }, e.prototype._registerMetricStorage = function(t, r) {
      var n = this, i = this._meterProviderSharedState.viewRegistry.findViews(t, this._instrumentationScope), o = i.map(function(c) {
        var s = pv(c, t), f = n.metricStorageRegistry.findOrUpdateCompatibleStorage(s);
        if (f != null)
          return f;
        var l = c.aggregation.createAggregator(s), d = new r(s, l, c.attributesProcessor, n._meterProviderSharedState.metricCollectors, c.aggregationCardinalityLimit);
        return n.metricStorageRegistry.register(d), d;
      });
      if (o.length === 0) {
        var a = this._meterProviderSharedState.selectAggregations(t.type), u = a.map(function(c) {
          var s = Gg(c, 2), f = s[0], l = s[1], d = n.metricStorageRegistry.findOrUpdateCompatibleCollectorStorage(f, t);
          if (d != null)
            return d;
          var h = l.createAggregator(t), _ = f.selectCardinalityLimit(t.type), p = new r(t, h, Yn.Noop(), [f], _);
          return n.metricStorageRegistry.registerForCollector(f, p), p;
        });
        o = o.concat(u);
      }
      return o;
    }, e;
  }()
), jg = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Vg = (
  /** @class */
  function() {
    function e(t) {
      this.resource = t, this.viewRegistry = new cg(), this.metricCollectors = [], this.meterSharedStates = /* @__PURE__ */ new Map();
    }
    return e.prototype.getMeterSharedState = function(t) {
      var r = av(t), n = this.meterSharedStates.get(r);
      return n == null && (n = new $g(this, t), this.meterSharedStates.set(r, n)), n;
    }, e.prototype.selectAggregations = function(t) {
      var r, n, i = [];
      try {
        for (var o = jg(this.metricCollectors), a = o.next(); !a.done; a = o.next()) {
          var u = a.value;
          i.push([u, u.selectAggregation(t)]);
        }
      } catch (c) {
        r = { error: c };
      } finally {
        try {
          a && !a.done && (n = o.return) && n.call(o);
        } finally {
          if (r) throw r.error;
        }
      }
      return i;
    }, e;
  }()
), Me = function(e, t, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function u(f) {
      try {
        s(n.next(f));
      } catch (l) {
        a(l);
      }
    }
    function c(f) {
      try {
        s(n.throw(f));
      } catch (l) {
        a(l);
      }
    }
    function s(f) {
      f.done ? o(f.value) : i(f.value).then(u, c);
    }
    s((n = n.apply(e, t || [])).next());
  });
}, xe = function(e, t) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(f) {
      return c([s, f]);
    };
  }
  function c(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return r.label++, { value: s[1], done: !1 };
        case 5:
          r.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            r = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            r.label = s[1];
            break;
          }
          if (s[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = s;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(s);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      s = t.call(e, r);
    } catch (f) {
      s = [6, f], i = 0;
    } finally {
      n = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, Fg = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Xg = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, zg = (
  /** @class */
  function() {
    function e(t, r) {
      this._sharedState = t, this._metricReader = r;
    }
    return e.prototype.collect = function(t) {
      return Me(this, void 0, void 0, function() {
        var r, n, i, o, a = this;
        return xe(this, function(u) {
          switch (u.label) {
            case 0:
              return r = Wn(Date.now()), n = [], i = [], o = Array.from(this._sharedState.meterSharedStates.values()).map(function(c) {
                return Me(a, void 0, void 0, function() {
                  var s;
                  return xe(this, function(f) {
                    switch (f.label) {
                      case 0:
                        return [4, c.collect(this, r, t)];
                      case 1:
                        return s = f.sent(), (s == null ? void 0 : s.scopeMetrics) != null && n.push(s.scopeMetrics), (s == null ? void 0 : s.errors) != null && i.push.apply(i, Xg([], Fg(s.errors), !1)), [
                          2
                          /*return*/
                        ];
                    }
                  });
                });
              }), [4, Promise.all(o)];
            case 1:
              return u.sent(), [2, {
                resourceMetrics: {
                  resource: this._sharedState.resource,
                  scopeMetrics: n
                },
                errors: i
              }];
          }
        });
      });
    }, e.prototype.forceFlush = function(t) {
      return Me(this, void 0, void 0, function() {
        return xe(this, function(r) {
          switch (r.label) {
            case 0:
              return [4, this._metricReader.forceFlush(t)];
            case 1:
              return r.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.shutdown = function(t) {
      return Me(this, void 0, void 0, function() {
        return xe(this, function(r) {
          switch (r.label) {
            case 0:
              return [4, this._metricReader.shutdown(t)];
            case 1:
              return r.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.selectAggregationTemporality = function(t) {
      return this._metricReader.selectAggregationTemporality(t);
    }, e.prototype.selectAggregation = function(t) {
      return this._metricReader.selectAggregation(t);
    }, e.prototype.selectCardinalityLimit = function(t) {
      var r, n, i;
      return (i = (n = (r = this._metricReader).selectCardinalityLimit) === null || n === void 0 ? void 0 : n.call(r, t)) !== null && i !== void 0 ? i : 2e3;
    }, e;
  }()
), go = function(e, t, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function u(f) {
      try {
        s(n.next(f));
      } catch (l) {
        a(l);
      }
    }
    function c(f) {
      try {
        s(n.throw(f));
      } catch (l) {
        a(l);
      }
    }
    function s(f) {
      f.done ? o(f.value) : i(f.value).then(u, c);
    }
    s((n = n.apply(e, t || [])).next());
  });
}, Eo = function(e, t) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(f) {
      return c([s, f]);
    };
  }
  function c(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return r.label++, { value: s[1], done: !1 };
        case 5:
          r.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            r = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            r.label = s[1];
            break;
          }
          if (s[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = s;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(s);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      s = t.call(e, r);
    } catch (f) {
      s = [6, f], i = 0;
    } finally {
      n = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, yo = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
function qg(e, t) {
  var r = t != null ? t : de.empty();
  return e ? de.default().merge(r) : r;
}
var Wg = (
  /** @class */
  function() {
    function e(t) {
      var r, n, i, o, a;
      if (this._shutdown = !1, this._sharedState = new Vg(qg((a = t == null ? void 0 : t.mergeResourceWithDefaults) !== null && a !== void 0 ? a : !0, t == null ? void 0 : t.resource)), (t == null ? void 0 : t.views) != null && t.views.length > 0)
        try {
          for (var u = yo(t.views), c = u.next(); !c.done; c = u.next()) {
            var s = c.value;
            this._sharedState.viewRegistry.addView(s);
          }
        } catch (h) {
          r = { error: h };
        } finally {
          try {
            c && !c.done && (n = u.return) && n.call(u);
          } finally {
            if (r) throw r.error;
          }
        }
      if ((t == null ? void 0 : t.readers) != null && t.readers.length > 0)
        try {
          for (var f = yo(t.readers), l = f.next(); !l.done; l = f.next()) {
            var d = l.value;
            this.addMetricReader(d);
          }
        } catch (h) {
          i = { error: h };
        } finally {
          try {
            l && !l.done && (o = f.return) && o.call(f);
          } finally {
            if (i) throw i.error;
          }
        }
    }
    return e.prototype.getMeter = function(t, r, n) {
      return r === void 0 && (r = ""), n === void 0 && (n = {}), this._shutdown ? (v.warn("A shutdown MeterProvider cannot provide a Meter"), Ec()) : this._sharedState.getMeterSharedState({
        name: t,
        version: r,
        schemaUrl: n.schemaUrl
      }).meter;
    }, e.prototype.addMetricReader = function(t) {
      var r = new zg(this._sharedState, t);
      t.setMetricProducer(r), this._sharedState.metricCollectors.push(r);
    }, e.prototype.shutdown = function(t) {
      return go(this, void 0, void 0, function() {
        return Eo(this, function(r) {
          switch (r.label) {
            case 0:
              return this._shutdown ? (v.warn("shutdown may only be called once per MeterProvider"), [
                2
                /*return*/
              ]) : (this._shutdown = !0, [4, Promise.all(this._sharedState.metricCollectors.map(function(n) {
                return n.shutdown(t);
              }))]);
            case 1:
              return r.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.forceFlush = function(t) {
      return go(this, void 0, void 0, function() {
        return Eo(this, function(r) {
          switch (r.label) {
            case 0:
              return this._shutdown ? (v.warn("invalid attempt to force flush after MeterProvider shutdown"), [
                2
                /*return*/
              ]) : [4, Promise.all(this._sharedState.metricCollectors.map(function(n) {
                return n.forceFlush(t);
              }))];
            case 1:
              return r.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, e;
  }()
);
function Yg(e, t) {
  var r = Za(t);
  return {
    resource: Qa(e.resource),
    schemaUrl: void 0,
    scopeMetrics: Kg(e.scopeMetrics, r)
  };
}
function Kg(e, t) {
  return Array.from(e.map(function(r) {
    return {
      scope: ts(r.scope),
      metrics: r.metrics.map(function(n) {
        return Jg(n, t);
      }),
      schemaUrl: r.scope.schemaUrl
    };
  }));
}
function Jg(e, t) {
  var r = {
    name: e.descriptor.name,
    description: e.descriptor.description,
    unit: e.descriptor.unit
  }, n = eE(e.aggregationTemporality);
  switch (e.dataPointType) {
    case Y.SUM:
      r.sum = {
        aggregationTemporality: n,
        isMonotonic: e.isMonotonic,
        dataPoints: mo(e, t)
      };
      break;
    case Y.GAUGE:
      r.gauge = {
        dataPoints: mo(e, t)
      };
      break;
    case Y.HISTOGRAM:
      r.histogram = {
        aggregationTemporality: n,
        dataPoints: Qg(e, t)
      };
      break;
    case Y.EXPONENTIAL_HISTOGRAM:
      r.exponentialHistogram = {
        aggregationTemporality: n,
        dataPoints: tE(e, t)
      };
      break;
  }
  return r;
}
function Zg(e, t, r) {
  var n = {
    attributes: At(e.attributes),
    startTimeUnixNano: r.encodeHrTime(e.startTime),
    timeUnixNano: r.encodeHrTime(e.endTime)
  };
  switch (t) {
    case ft.INT:
      n.asInt = e.value;
      break;
    case ft.DOUBLE:
      n.asDouble = e.value;
      break;
  }
  return n;
}
function mo(e, t) {
  return e.dataPoints.map(function(r) {
    return Zg(r, e.descriptor.valueType, t);
  });
}
function Qg(e, t) {
  return e.dataPoints.map(function(r) {
    var n = r.value;
    return {
      attributes: At(r.attributes),
      bucketCounts: n.buckets.counts,
      explicitBounds: n.buckets.boundaries,
      count: n.count,
      sum: n.sum,
      min: n.min,
      max: n.max,
      startTimeUnixNano: t.encodeHrTime(r.startTime),
      timeUnixNano: t.encodeHrTime(r.endTime)
    };
  });
}
function tE(e, t) {
  return e.dataPoints.map(function(r) {
    var n = r.value;
    return {
      attributes: At(r.attributes),
      count: n.count,
      min: n.min,
      max: n.max,
      sum: n.sum,
      positive: {
        offset: n.positive.offset,
        bucketCounts: n.positive.bucketCounts
      },
      negative: {
        offset: n.negative.offset,
        bucketCounts: n.negative.bucketCounts
      },
      scale: n.scale,
      zeroCount: n.zeroCount,
      startTimeUnixNano: t.encodeHrTime(r.startTime),
      timeUnixNano: t.encodeHrTime(r.endTime)
    };
  });
}
function eE(e) {
  switch (e) {
    case X.DELTA:
      return 1;
    case X.CUMULATIVE:
      return 2;
  }
}
function rE(e, t) {
  return {
    resourceMetrics: e.map(function(r) {
      return Yg(r, t);
    })
  };
}
var nE = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, iE = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
};
function oE(e, t) {
  var r, n = e.spanContext(), i = e.status;
  return {
    traceId: t.encodeSpanContext(n.traceId),
    spanId: t.encodeSpanContext(n.spanId),
    parentSpanId: t.encodeOptionalSpanContext(e.parentSpanId),
    traceState: (r = n.traceState) === null || r === void 0 ? void 0 : r.serialize(),
    name: e.name,
    // Span kind is offset by 1 because the API does not define a value for unset
    kind: e.kind == null ? 0 : e.kind + 1,
    startTimeUnixNano: t.encodeHrTime(e.startTime),
    endTimeUnixNano: t.encodeHrTime(e.endTime),
    attributes: At(e.attributes),
    droppedAttributesCount: e.droppedAttributesCount,
    events: e.events.map(function(o) {
      return sE(o, t);
    }),
    droppedEventsCount: e.droppedEventsCount,
    status: {
      // API and proto enums share the same values
      code: i.code,
      message: i.message
    },
    links: e.links.map(function(o) {
      return aE(o, t);
    }),
    droppedLinksCount: e.droppedLinksCount
  };
}
function aE(e, t) {
  var r;
  return {
    attributes: e.attributes ? At(e.attributes) : [],
    spanId: t.encodeSpanContext(e.context.spanId),
    traceId: t.encodeSpanContext(e.context.traceId),
    traceState: (r = e.context.traceState) === null || r === void 0 ? void 0 : r.serialize(),
    droppedAttributesCount: e.droppedAttributesCount || 0
  };
}
function sE(e, t) {
  return {
    attributes: e.attributes ? At(e.attributes) : [],
    name: e.name,
    timeUnixNano: t.encodeHrTime(e.time),
    droppedAttributesCount: e.droppedAttributesCount || 0
  };
}
function uE(e, t) {
  var r = Za(t);
  return {
    resourceSpans: fE(e, r)
  };
}
function cE(e) {
  var t, r, n = /* @__PURE__ */ new Map();
  try {
    for (var i = nE(e), o = i.next(); !o.done; o = i.next()) {
      var a = o.value, u = n.get(a.resource);
      u || (u = /* @__PURE__ */ new Map(), n.set(a.resource, u));
      var c = a.instrumentationLibrary.name + "@" + (a.instrumentationLibrary.version || "") + ":" + (a.instrumentationLibrary.schemaUrl || ""), s = u.get(c);
      s || (s = [], u.set(c, s)), s.push(a);
    }
  } catch (f) {
    t = { error: f };
  } finally {
    try {
      o && !o.done && (r = i.return) && r.call(i);
    } finally {
      if (t) throw t.error;
    }
  }
  return n;
}
function fE(e, t) {
  for (var r = cE(e), n = [], i = r.entries(), o = i.next(); !o.done; ) {
    for (var a = iE(o.value, 2), u = a[0], c = a[1], s = [], f = c.values(), l = f.next(); !l.done; ) {
      var d = l.value;
      if (d.length > 0) {
        var h = d.map(function(p) {
          return oE(p, t);
        });
        s.push({
          scope: ts(d[0].instrumentationLibrary),
          spans: h,
          schemaUrl: d[0].instrumentationLibrary.schemaUrl
        });
      }
      l = f.next();
    }
    var _ = {
      resource: Qa(u),
      scopeSpans: s,
      schemaUrl: void 0
    };
    n.push(_), o = i.next();
  }
  return n;
}
var lE = {
  serializeRequest: function(e) {
    var t = rE([e], {
      useLongBits: !1
    }), r = new TextEncoder();
    return r.encode(JSON.stringify(t));
  },
  deserializeResponse: function(e) {
    var t = new TextDecoder();
    return JSON.parse(t.decode(e));
  }
}, dE = {
  serializeRequest: function(e) {
    var t = uE(e, {
      useHex: !0,
      useLongBits: !1
    }), r = new TextEncoder();
    return r.encode(JSON.stringify(t));
  },
  deserializeResponse: function(e) {
    var t = new TextDecoder();
    return JSON.parse(t.decode(e));
  }
}, pE = function(e, t, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function u(f) {
      try {
        s(n.next(f));
      } catch (l) {
        a(l);
      }
    }
    function c(f) {
      try {
        s(n.throw(f));
      } catch (l) {
        a(l);
      }
    }
    function s(f) {
      f.done ? o(f.value) : i(f.value).then(u, c);
    }
    s((n = n.apply(e, t || [])).next());
  });
}, hE = function(e, t) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(f) {
      return c([s, f]);
    };
  }
  function c(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return r.label++, { value: s[1], done: !1 };
        case 5:
          r.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            r = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            r.label = s[1];
            break;
          }
          if (s[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = s;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(s);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      s = t.call(e, r);
    } catch (f) {
      s = [6, f], i = 0;
    } finally {
      n = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, _E = 5, vE = 1e3, gE = 5e3, EE = 1.5, To = 0.2;
function yE() {
  return Math.random() * (2 * To) - To;
}
var mE = (
  /** @class */
  function() {
    function e(t) {
      this._transport = t;
    }
    return e.prototype.retry = function(t, r, n) {
      var i = this;
      return new Promise(function(o, a) {
        setTimeout(function() {
          i._transport.send(t, r).then(o, a);
        }, n);
      });
    }, e.prototype.send = function(t, r) {
      var n;
      return pE(this, void 0, void 0, function() {
        var i, o, a, u, c, s, f;
        return hE(this, function(l) {
          switch (l.label) {
            case 0:
              return i = Date.now() + r, [4, this._transport.send(t, r)];
            case 1:
              o = l.sent(), a = _E, u = vE, l.label = 2;
            case 2:
              return o.status === "retryable" && a > 0 ? (a--, c = Math.max(Math.min(u, gE) + yE(), 0), u = u * EE, s = (n = o.retryInMillis) !== null && n !== void 0 ? n : c, f = i - Date.now(), s > f ? [2, o] : [4, this.retry(t, f, s)]) : [3, 4];
            case 3:
              return o = l.sent(), [3, 2];
            case 4:
              return [2, o];
          }
        });
      });
    }, e.prototype.shutdown = function() {
      return this._transport.shutdown();
    }, e;
  }()
);
function Es(e) {
  return new mE(e.transport);
}
function TE(e) {
  var t = [429, 502, 503, 504];
  return t.includes(e);
}
function SE(e) {
  if (e != null) {
    var t = Number.parseInt(e, 10);
    if (Number.isInteger(t))
      return t > 0 ? t * 1e3 : -1;
    var r = new Date(e).getTime() - Date.now();
    return r >= 0 ? r : 0;
  }
}
var OE = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, AE = (
  /** @class */
  function() {
    function e(t) {
      this._parameters = t;
    }
    return e.prototype.send = function(t, r) {
      var n = this;
      return new Promise(function(i) {
        var o = new XMLHttpRequest();
        o.timeout = r, o.open("POST", n._parameters.url);
        var a = n._parameters.headers();
        Object.entries(a).forEach(function(u) {
          var c = OE(u, 2), s = c[0], f = c[1];
          o.setRequestHeader(s, f);
        }), o.ontimeout = function(u) {
          i({
            status: "failure",
            error: new Error("XHR request timed out")
          });
        }, o.onreadystatechange = function() {
          o.status >= 200 && o.status <= 299 ? (v.debug("XHR success"), i({
            status: "success"
          })) : o.status && TE(o.status) ? i({
            status: "retryable",
            retryInMillis: SE(o.getResponseHeader("Retry-After"))
          }) : o.status !== 0 && i({
            status: "failure",
            error: new Error("XHR request failed with non-retryable status")
          });
        }, o.onabort = function() {
          i({
            status: "failure",
            error: new Error("XHR request aborted")
          });
        }, o.onerror = function() {
          i({
            status: "failure",
            error: new Error("XHR request errored")
          });
        }, o.send(t);
      });
    }, e.prototype.shutdown = function() {
    }, e;
  }()
);
function bE(e) {
  return new AE(e);
}
var wE = (
  /** @class */
  function() {
    function e(t) {
      this._params = t;
    }
    return e.prototype.send = function(t) {
      var r = this;
      return new Promise(function(n) {
        navigator.sendBeacon(r._params.url, new Blob([t], { type: r._params.blobType })) ? (v.debug("SendBeacon success"), n({
          status: "success"
        })) : n({
          status: "failure",
          error: new Error("SendBeacon failed")
        });
      });
    }, e.prototype.shutdown = function() {
    }, e;
  }()
);
function RE(e) {
  return new wE(e);
}
function LE(e, t) {
  return Wa(e, t, Es({
    transport: bE(e)
  }));
}
function PE(e, t) {
  return Wa(e, t, Es({
    transport: RE({
      url: e.url,
      blobType: e.headers()["Content-Type"]
    })
  }));
}
var NE = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
};
function IE(e) {
  return function() {
    var t, r = {};
    return Object.entries((t = e == null ? void 0 : e()) !== null && t !== void 0 ? t : {}).forEach(function(n) {
      var i = NE(n, 2), o = i[0], a = i[1];
      typeof a != "undefined" ? r[o] = String(a) : v.warn('Header "' + o + '" has invalid value (' + a + ") and will be ignored");
    }), r;
  };
}
var St = function() {
  return St = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, St.apply(this, arguments);
};
function CE(e, t, r) {
  var n = St({}, r()), i = {};
  return function() {
    return t != null && Object.assign(i, t()), e != null && Object.assign(i, e()), Object.assign(i, n);
  };
}
function ME(e) {
  if (e != null)
    try {
      return new URL(e), e;
    } catch (t) {
      throw new Error("Configuration: Could not parse user-provided export URL: '" + e + "'");
    }
}
function xE(e, t, r) {
  var n, i, o, a;
  return St(St({}, D_(e, t, r)), { headers: CE(IE(e.headers), t.headers, r.headers), url: (i = (n = ME(e.url)) !== null && n !== void 0 ? n : t.url) !== null && i !== void 0 ? i : r.url, agentOptions: (a = (o = e.agentOptions) !== null && o !== void 0 ? o : t.agentOptions) !== null && a !== void 0 ? a : r.agentOptions });
}
function DE(e, t) {
  return St(St({}, U_()), { headers: function() {
    return e;
  }, url: "http://localhost:4318/" + t, agentOptions: { keepAlive: !0 } });
}
function UE(e, t, r) {
  return xE(
    {
      url: e.url,
      timeoutMillis: e.timeoutMillis,
      headers: x_(e.headers),
      concurrencyLimit: e.concurrencyLimit
    },
    {},
    // no fallback for browser case
    DE(r, t)
  );
}
function ys(e, t, r, n) {
  var i = !!e.headers || typeof navigator.sendBeacon != "function", o = UE(e, r, n);
  return i ? LE(o, t) : PE(o, t);
}
var BE = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), kE = (
  /** @class */
  function(e) {
    BE(t, e);
    function t(r) {
      return r === void 0 && (r = {}), e.call(this, ys(r, dE, "v1/traces", { "Content-Type": "application/json" })) || this;
    }
    return t;
  }(qa)
), Je;
(function(e) {
  e[e.DELTA = 0] = "DELTA", e[e.CUMULATIVE = 1] = "CUMULATIVE", e[e.LOWMEMORY = 2] = "LOWMEMORY";
})(Je || (Je = {}));
var HE = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), Cn = function() {
  return X.CUMULATIVE;
}, ms = function(e) {
  switch (e) {
    case T.COUNTER:
    case T.OBSERVABLE_COUNTER:
    case T.GAUGE:
    case T.HISTOGRAM:
    case T.OBSERVABLE_GAUGE:
      return X.DELTA;
    case T.UP_DOWN_COUNTER:
    case T.OBSERVABLE_UP_DOWN_COUNTER:
      return X.CUMULATIVE;
  }
}, Ts = function(e) {
  switch (e) {
    case T.COUNTER:
    case T.HISTOGRAM:
      return X.DELTA;
    case T.GAUGE:
    case T.UP_DOWN_COUNTER:
    case T.OBSERVABLE_UP_DOWN_COUNTER:
    case T.OBSERVABLE_COUNTER:
    case T.OBSERVABLE_GAUGE:
      return X.CUMULATIVE;
  }
};
function GE() {
  var e = Sf(), t = e.OTEL_EXPORTER_OTLP_METRICS_TEMPORALITY_PREFERENCE.trim().toLowerCase();
  return t === "cumulative" ? Cn : t === "delta" ? ms : t === "lowmemory" ? Ts : (v.warn("OTEL_EXPORTER_OTLP_METRICS_TEMPORALITY_PREFERENCE is set to '" + e.OTEL_EXPORTER_OTLP_METRICS_TEMPORALITY_PREFERENCE + "', but only 'cumulative' and 'delta' are allowed. Using default ('cumulative') instead."), Cn);
}
function $E(e) {
  return e != null ? e === Je.DELTA ? ms : e === Je.LOWMEMORY ? Ts : Cn : GE();
}
function jE(e) {
  return e != null && e.aggregationPreference ? e.aggregationPreference : function(t) {
    return nt.Default();
  };
}
var VE = (
  /** @class */
  function(e) {
    HE(t, e);
    function t(r, n) {
      var i = e.call(this, r) || this;
      return i._aggregationSelector = jE(n), i._aggregationTemporalitySelector = $E(n == null ? void 0 : n.temporalityPreference), i;
    }
    return t.prototype.selectAggregation = function(r) {
      return this._aggregationSelector(r);
    }, t.prototype.selectAggregationTemporality = function(r) {
      return this._aggregationTemporalitySelector(r);
    }, t;
  }(qa)
), FE = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), XE = (
  /** @class */
  function(e) {
    FE(t, e);
    function t(r) {
      return e.call(this, ys(r != null ? r : {}, lE, "v1/metrics", { "Content-Type": "application/json" }), r) || this;
    }
    return t;
  }(VE)
);
function zE(e, t) {
  const r = e.spanContext();
  return {
    name: e.name,
    kind: e.kind,
    spanContext: () => r,
    parentSpanId: e.parentSpanId,
    startTime: e.startTime,
    endTime: e.endTime,
    status: e.status,
    attributes: al(e.attributes, t),
    links: e.links,
    events: e.events,
    duration: e.duration,
    ended: e.ended,
    resource: e.resource,
    instrumentationLibrary: e.instrumentationLibrary,
    droppedAttributesCount: e.droppedAttributesCount,
    droppedEventsCount: e.droppedEventsCount,
    droppedLinksCount: e.droppedLinksCount
  };
}
function qE(e, t) {
  if (!t.isSamplingEnabled())
    return e;
  const r = [], n = {}, i = {};
  for (const o of e) {
    o.parentSpanId && (i[o.parentSpanId] = i[o.parentSpanId] || [], i[o.parentSpanId].push(
      o.spanContext().spanId
    ));
    const a = t.shouldSample(o);
    a.sample ? a.attributes ? n[o.spanContext().spanId] = zE(
      o,
      a.attributes
    ) : n[o.spanContext().spanId] = o : r.push(o.spanContext().spanId);
  }
  for (; r.length > 0; ) {
    const o = r.shift(), a = i[o];
    if (a)
      for (const u of a)
        delete n[u], r.push(u);
  }
  return Object.values(n);
}
class WE extends kE {
  constructor(t, r) {
    super(N(S({}, t), {
      headers: {}
      // a truthy value enables sending with XHR instead of beacon
    })), this.sampler = r;
  }
  export(t, r) {
    const n = qE(t, this.sampler);
    if (n.length === 0)
      return;
    let i = 0;
    const o = (a) => {
      if (a.code === B.SUCCESS)
        return r({
          code: B.SUCCESS
        });
      if (i++, i > $o)
        return r({
          code: B.FAILED,
          error: a.error
        });
      new Promise(
        (u) => setTimeout(
          u,
          jo + Vo * Math.pow(2, i)
        )
      ).then(() => {
        super.export(n, o);
      });
    };
    super.export(n, o);
  }
}
class YE extends XE {
  constructor(t) {
    super(N(S({}, t), {
      headers: {}
    }));
  }
  export(t, r) {
    let n = 0;
    const i = (o) => {
      var a;
      if (o.code === B.SUCCESS)
        return r({
          code: B.SUCCESS
        });
      if (n++, n > $o)
        return console.error(
          `[@launchdarkly/observability] failed to export OTeL metrics: ${(a = o.error) == null ? void 0 : a.message}`,
          o.error
        ), r({
          code: B.FAILED,
          error: o.error
        });
      new Promise(
        (u) => setTimeout(
          u,
          jo + Vo * Math.pow(2, n)
        )
      ).then(() => {
        var u;
        console.warn(
          `[@launchdarkly/observability] retry ${n}, failed to export OTeL metrics: ${(u = o.error) == null ? void 0 : u.message}`,
          o.error
        ), super.export(t, i);
      });
    };
    super.export(t, i);
  }
}
const KE = "OT_ZONE_CONTEXT", JE = "Navigation:", ZE = ["click", "input", "submit"];
function QE() {
  return !1;
}
const z = class z extends Tl {
  constructor(r = {}) {
    var n;
    super(
      z.moduleName,
      z.version,
      r
    );
    R(this, "_spansData", /* @__PURE__ */ new WeakMap());
    R(this, "_zonePatched");
    // for addEventListener/removeEventListener state
    R(this, "_wrappedListeners", /* @__PURE__ */ new WeakMap());
    // for event bubbling
    R(this, "_eventsSpanMap", /* @__PURE__ */ new WeakMap());
    R(this, "_eventNames");
    R(this, "_shouldPreventSpanCreation");
    this._eventNames = new Set(
      (n = r == null ? void 0 : r.eventNames) != null ? n : ZE
    ), this._shouldPreventSpanCreation = typeof (r == null ? void 0 : r.shouldPreventSpanCreation) == "function" ? r.shouldPreventSpanCreation : QE;
  }
  init() {
  }
  /**
   * This will check if last task was timeout and will save the time to
   * fix the user interaction when nothing happens
   * This timeout comes from xhr plugin which is needed to collect information
   * about last xhr main request from observer
   * @param task
   * @param span
   */
  _checkForTimeout(r, n) {
    const i = this._spansData.get(n);
    i && (r.source === "setTimeout" ? i.hrTimeLastTimeout = Rf() : r.source !== "Promise.then" && r.source !== "setTimeout" && (i.hrTimeLastTimeout = void 0));
  }
  /**
   * Controls whether or not to create a span, based on the event type.
   */
  _allowEventName(r) {
    return this._eventNames.has(r);
  }
  /**
   * Creates a new span
   * @param event
   * @param parentSpan
   */
  _createSpan(r, n) {
    var u;
    const i = r == null ? void 0 : r.target, o = r == null ? void 0 : r.type;
    if (!(i instanceof HTMLElement) || !i.getAttribute || i.hasAttribute("disabled") || !this._allowEventName(o))
      return;
    const a = ka(i, !0);
    try {
      const c = this.tracer.startSpan(
        o,
        {
          attributes: {
            "event.type": o,
            "event.tag": i.tagName,
            "event.xpath": a,
            "event.id": i.id,
            "event.classname": i.className,
            "event.text": (u = i.textContent) != null ? u : "",
            "event.url": window.location.href,
            "viewport.width": window.innerWidth,
            "viewport.height": window.innerHeight
          }
        },
        n ? b.setSpan(O.active(), n) : void 0
      );
      return r instanceof MouseEvent && (c.setAttribute("event.x", r.clientX), c.setAttribute("event.y", r.clientY), c.setAttribute(
        "event.relativeX",
        r.clientX / window.innerWidth
      ), c.setAttribute(
        "event.relativeY",
        r.clientY / window.innerHeight
      ), o === "scroll" && (c.setAttribute("event.scrollX", window.scrollX), c.setAttribute("event.scrollY", window.scrollY))), this._shouldPreventSpanCreation(o, i, c) === !0 ? void 0 : (this._spansData.set(c, {
        taskCount: 0
      }), c);
    } catch (c) {
      this._diag.error(
        "failed to start create new user interaction span",
        c
      );
    }
  }
  /**
   * Decrement number of tasks that left in zone,
   * This is needed to be able to end span when no more tasks left
   * @param span
   */
  _decrementTask(r) {
    const n = this._spansData.get(r);
    n && (n.taskCount--, n.taskCount === 0 && this._tryToEndSpan(r, n.hrTimeLastTimeout));
  }
  /**
   * Return the current span
   * @param zone
   * @private
   */
  _getCurrentSpan(r) {
    const n = r.get(KE);
    return n && b.getSpan(n);
  }
  /**
   * Increment number of tasks that are run within the same zone.
   *     This is needed to be able to end span when no more tasks left
   * @param span
   */
  _incrementTask(r) {
    const n = this._spansData.get(r);
    n && n.taskCount++;
  }
  /**
   * Returns true iff we should use the patched callback; false if it's already been patched
   */
  addPatchedListener(r, n, i, o) {
    let a = this._wrappedListeners.get(i);
    a || (a = /* @__PURE__ */ new Map(), this._wrappedListeners.set(i, a));
    let u = a.get(n);
    return u || (u = /* @__PURE__ */ new Map(), a.set(n, u)), u.has(r) ? !1 : (u.set(r, o), !0);
  }
  /**
   * Returns the patched version of the callback (or undefined)
   */
  removePatchedListener(r, n, i) {
    const o = this._wrappedListeners.get(i);
    if (!o)
      return;
    const a = o.get(n);
    if (!a)
      return;
    const u = a.get(r);
    return u && (a.delete(r), a.size === 0 && (o.delete(n), o.size === 0 && this._wrappedListeners.delete(i))), u;
  }
  // utility method to deal with the Function|EventListener nature of addEventListener
  _invokeListener(r, n, i) {
    return typeof r == "function" ? r.apply(n, i) : r.handleEvent(i[0]);
  }
  /**
   * This patches the addEventListener of HTMLElement to be able to
   * auto instrument the click events
   * This is done when zone is not available
   */
  _patchAddEventListener() {
    const r = this;
    let n = /* @__PURE__ */ new Map();
    return (i) => function(a, u, c) {
      if (!u)
        return i.call(this, a, u, c);
      const s = c && typeof c == "object" && c.once, f = function(...l) {
        var p;
        let d;
        const h = l[0];
        if (!(h != null && h.type))
          return r._invokeListener(u, this, l);
        if (Date.now() - ((p = n.get(h.type)) != null ? p : 0) < 1e3 / 60)
          return r._invokeListener(u, this, l);
        n.set(h.type, Date.now()), h && (d = r._eventsSpanMap.get(h)), s && r.removePatchedListener(this, a, u);
        const _ = r._createSpan(h, d);
        return _ ? (h && r._eventsSpanMap.set(h, _), O.with(
          b.setSpan(O.active(), _),
          () => {
            const g = r._invokeListener(
              u,
              this,
              l
            );
            return _.end(), g;
          }
        )) : r._invokeListener(u, this, l);
      };
      if (r.addPatchedListener(
        this,
        a,
        u,
        f
      ))
        return i.call(
          this,
          a,
          f,
          c
        );
    };
  }
  /**
   * This patches the removeEventListener of HTMLElement to handle the fact that
   * we patched the original callbacks
   * This is done when zone is not available
   */
  _patchRemoveEventListener() {
    const r = this;
    return (n) => function(o, a, u) {
      const c = r.removePatchedListener(
        this,
        o,
        a
      );
      return c ? n.call(
        this,
        o,
        c,
        u
      ) : n.call(this, o, a, u);
    };
  }
  /**
   * Most browser provide event listener api via EventTarget in prototype chain.
   * Exception to this is IE 11 which has it on the prototypes closest to EventTarget:
   *
   * * - has addEventListener in IE
   * ** - has addEventListener in all other browsers
   * ! - missing in IE
   *
   * HTMLElement -> Element -> Node * -> EventTarget **! -> Object
   * Document -> Node * -> EventTarget **! -> Object
   * Window * -> WindowProperties ! -> EventTarget **! -> Object
   */
  _getPatchableEventTargets() {
    return window.EventTarget ? [EventTarget.prototype] : [Node.prototype, Window.prototype];
  }
  /**
   * Patches the history api
   */
  _patchHistoryApi() {
    this._unpatchHistoryApi(), this._wrap(history, "replaceState", this._patchHistoryMethod()), this._wrap(history, "pushState", this._patchHistoryMethod()), this._wrap(history, "back", this._patchHistoryMethod()), this._wrap(history, "forward", this._patchHistoryMethod()), this._wrap(history, "go", this._patchHistoryMethod());
  }
  /**
   * Patches the certain history api method
   */
  _patchHistoryMethod() {
    const r = this;
    return (n) => function(...o) {
      const a = `${location.pathname}${location.hash}${location.search}`, u = n.apply(this, o), c = `${location.pathname}${location.hash}${location.search}`;
      return a !== c && r._updateInteractionName(c), u;
    };
  }
  /**
   * unpatch the history api methods
   */
  _unpatchHistoryApi() {
    U(history.replaceState) && this._unwrap(history, "replaceState"), U(history.pushState) && this._unwrap(history, "pushState"), U(history.back) && this._unwrap(history, "back"), U(history.forward) && this._unwrap(history, "forward"), U(history.go) && this._unwrap(history, "go");
  }
  /**
   * Updates interaction span name
   * @param url
   */
  _updateInteractionName(r) {
    const n = b.getSpan(
      O.active()
    );
    n && typeof n.updateName == "function" && n.updateName(`${JE} ${r}`);
  }
  /**
   * Patches zone cancel task - this is done to be able to correctly
   * decrement the number of remaining tasks
   */
  _patchZoneCancelTask() {
    const r = this;
    return (n) => function(o) {
      const a = Zone.current, u = r._getCurrentSpan(a);
      return u && r._shouldCountTask(o, a) && r._decrementTask(u), n.call(this, o);
    };
  }
  /**
   * Patches zone schedule task - this is done to be able to correctly
   * increment the number of tasks running within current zone but also to
   * save time in case of timeout running from xhr plugin when waiting for
   * main request from PerformanceResourceTiming
   */
  _patchZoneScheduleTask() {
    const r = this;
    return (n) => function(o) {
      const a = Zone.current, u = r._getCurrentSpan(a);
      return u && r._shouldCountTask(o, a) && (r._incrementTask(u), r._checkForTimeout(o, u)), n.call(this, o);
    };
  }
  /**
   * Patches zone run task - this is done to be able to create a span when
   * user interaction starts
   * @private
   */
  _patchZoneRunTask() {
    const r = this;
    return (n) => function(o, a, u) {
      const c = Array.isArray(u) && u[0] instanceof Event ? u[0] : void 0, s = c == null ? void 0 : c.target;
      let f;
      const l = this;
      if (s) {
        if (f = r._createSpan(c), f)
          return r._incrementTask(f), l.run(() => {
            try {
              return O.with(
                b.setSpan(
                  O.active(),
                  f
                ),
                () => {
                  const d = Zone.current;
                  return o._zone = d, n.call(
                    d,
                    o,
                    a,
                    u
                  );
                }
              );
            } finally {
              r._decrementTask(f);
            }
          });
      } else
        f = r._getCurrentSpan(l);
      try {
        return n.call(l, o, a, u);
      } finally {
        f && r._shouldCountTask(o, l) && r._decrementTask(f);
      }
    };
  }
  /**
   * Decides if task should be counted.
   * @param task
   * @param currentZone
   * @private
   */
  _shouldCountTask(r, n) {
    if (r._zone && (n = r._zone), !n || !r.data || r.data.isPeriodic)
      return !1;
    const i = this._getCurrentSpan(n);
    return !i || !this._spansData.get(i) ? !1 : r.type === "macroTask" || r.type === "microTask";
  }
  /**
   * Will try to end span when such span still exists.
   * @param span
   * @param endTime
   * @private
   */
  _tryToEndSpan(r, n) {
    r && this._spansData.get(r) && (r.end(n), this._spansData.delete(r));
  }
  /**
   * implements enable function
   */
  enable() {
    const r = this._getZoneWithPrototype();
    this._diag.debug(
      "applying patch to",
      z.moduleName,
      z.version,
      "zone:",
      !!r
    ), r ? (U(r.prototype.runTask) && (this._unwrap(r.prototype, "runTask"), this._diag.debug("removing previous patch from method runTask")), U(r.prototype.scheduleTask) && (this._unwrap(r.prototype, "scheduleTask"), this._diag.debug(
      "removing previous patch from method scheduleTask"
    )), U(r.prototype.cancelTask) && (this._unwrap(r.prototype, "cancelTask"), this._diag.debug(
      "removing previous patch from method cancelTask"
    )), this._zonePatched = !0, this._wrap(
      r.prototype,
      "runTask",
      this._patchZoneRunTask()
    ), this._wrap(
      r.prototype,
      "scheduleTask",
      this._patchZoneScheduleTask()
    ), this._wrap(
      r.prototype,
      "cancelTask",
      this._patchZoneCancelTask()
    )) : (this._zonePatched = !1, this._getPatchableEventTargets().forEach((i) => {
      U(i.addEventListener) && (this._unwrap(i, "addEventListener"), this._diag.debug(
        "removing previous patch from method addEventListener"
      )), U(i.removeEventListener) && (this._unwrap(i, "removeEventListener"), this._diag.debug(
        "removing previous patch from method removeEventListener"
      )), this._wrap(
        i,
        "addEventListener",
        this._patchAddEventListener()
      ), this._wrap(
        i,
        "removeEventListener",
        this._patchRemoveEventListener()
      );
    })), this._patchHistoryApi();
  }
  /**
   * implements unpatch function
   */
  disable() {
    const r = this._getZoneWithPrototype();
    this._diag.debug(
      "removing patch from",
      z.moduleName,
      z.version,
      "zone:",
      !!r
    ), r && this._zonePatched ? (U(r.prototype.runTask) && this._unwrap(r.prototype, "runTask"), U(r.prototype.scheduleTask) && this._unwrap(r.prototype, "scheduleTask"), U(r.prototype.cancelTask) && this._unwrap(r.prototype, "cancelTask")) : this._getPatchableEventTargets().forEach((i) => {
      U(i.addEventListener) && this._unwrap(i, "addEventListener"), U(i.removeEventListener) && this._unwrap(i, "removeEventListener");
    }), this._unpatchHistoryApi();
  }
  /**
   * returns Zone
   */
  _getZoneWithPrototype() {
    return window.Zone;
  }
};
R(z, "version", "0.1.1"), R(z, "moduleName", "user-interaction");
let Mn = z, M = {}, Q;
const yt = "highlight.record", ty = "highlight.session_id", xn = /* @__PURE__ */ new Map(), Ss = (e) => `${e.spanContext().traceId}:${e.spanContext().spanId}`, Os = "launchdarkly.js.log", ey = "launchdarkly.exception.id", So = "launchdarkly.sampling.ratio", As = "log.severity", bs = "log.message", ry = (e, t) => {
  var p, g, E, y, A, L, P, C, Lt;
  if (M.tracerProvider || M.meterProvider) {
    console.warn("OTEL already initialized. Skipping...");
    return;
  }
  Q = e;
  const r = e.backendUrl || void 0 || "https://pub.highlight.io", n = [
    ...(g = (p = e.networkRecordingOptions) == null ? void 0 : p.urlBlocklist) != null ? g : [],
    ...y_
  ], i = (E = e.environment) != null ? E : "production", o = {
    url: e.otlpEndpoint + "/v1/traces",
    concurrencyLimit: 10,
    timeoutMillis: 3e4,
    // Using any because we were getting an error importing CompressionAlgorithm
    // from @opentelemetry/otlp-exporter-base.
    compression: "gzip",
    keepAlive: !0,
    httpAgentOptions: {
      timeout: 6e4,
      keepAlive: !0
    }
  }, a = new WE(
    o,
    t
  ), u = new Ze(a, {
    maxExportBatchSize: 1024,
    // Default value from SDK is 512
    maxQueueSize: 2048,
    // Default value from SDK is 2048
    exportTimeoutMillis: o.timeoutMillis,
    // Default value from SDK is 30_000
    scheduledDelayMillis: o.timeoutMillis
    // Default value from SDK is 1000
  }), c = new de({
    [Ys]: (y = e.serviceName) != null ? y : "highlight-browser",
    [Ws]: e.serviceVersion,
    "deployment.environment.name": i,
    "highlight.project_id": e.projectId,
    [qs]: navigator.userAgent,
    "browser.language": navigator.language,
    "telemetry.distro.name": "@highlight-run/observability",
    "telemetry.distro.version": zs
  });
  M.tracerProvider = new Ip({
    resource: c,
    mergeResourceWithDefaults: !0,
    spanProcessors: [u]
  }), b.setGlobalTracerProvider(M.tracerProvider);
  const s = new YE(N(S({}, o), {
    url: e.otlpEndpoint + "/v1/metrics"
  })), f = new ug({
    exporter: s,
    exportIntervalMillis: o.timeoutMillis,
    exportTimeoutMillis: o.timeoutMillis
  });
  M.meterProvider = new Wg({ resource: c, readers: [f] }), Vt.setGlobalMeterProvider(M.meterProvider);
  let l = [];
  if (((A = e.instrumentations) == null ? void 0 : A["@opentelemetry/instrumentation-document-load"]) !== !1 && l.push(
    new Yp({
      applyCustomAttributesOnSpan: {
        documentLoad: bo,
        documentFetch: bo,
        resourceFetch: dy
      }
    })
  ), ((L = e.instrumentations) == null ? void 0 : L["@opentelemetry/instrumentation-user-interaction"]) !== !1 && l.push(
    new Mn({
      eventNames: e.eventNames
    })
  ), (P = e.networkRecordingOptions) != null && P.enabled) {
    if (((C = e.instrumentations) == null ? void 0 : C["@opentelemetry/instrumentation-fetch"]) !== !1) {
      const Z = new Uh({
        propagateTraceHeaderCorsUrls: wo(
          e.tracingOrigins
        ),
        applyCustomAttributesOnSpan: (G, zt, Nt) => {
          var Wt, Yt;
          if (!G.attributes)
            return;
          const qt = G;
          if (qt.attributes[yt] !== !1) {
            if (Ao(
              G,
              zt.body,
              zt.headers,
              e.networkRecordingOptions
            ), !(Nt instanceof Response)) {
              G.setAttributes({
                "http.response.error": Nt.message,
                [Fo]: Nt.status
              });
              return;
            }
            if (!((Wt = e.networkRecordingOptions) != null && Wt.requestResponseSanitizer && (Qr(
              G,
              e.networkRecordingOptions.requestResponseSanitizer
            ), qt.attributes[yt] === !1)) && (Yt = e.networkRecordingOptions) != null && Yt.recordHeadersAndBody) {
              const Oe = D(void 0, null, function* () {
                var ei, ri, ni, ii, oi, ai;
                const Ae = yield za(
                  Nt,
                  (ei = e.networkRecordingOptions) == null ? void 0 : ei.bodyKeysToRecord,
                  (ri = e.networkRecordingOptions) == null ? void 0 : ri.networkBodyKeysToRedact
                ), cr = Object.fromEntries(
                  Nt.headers.entries()
                ), Bs = ir(
                  (ii = (ni = e.networkRecordingOptions) == null ? void 0 : ni.networkHeadersToRedact) != null ? ii : [],
                  cr,
                  (oi = e.networkRecordingOptions) == null ? void 0 : oi.headerKeysToRecord
                ), ks = Kn(
                  Bs,
                  "http.response.header"
                );
                Object.assign(
                  G.attributes,
                  S({
                    "http.response.body": Ae
                  }, ks)
                ), (ai = e.networkRecordingOptions) != null && ai.requestResponseSanitizer && Qr(
                  G,
                  e.networkRecordingOptions.requestResponseSanitizer
                );
              });
              xn.set(Ss(G), Oe);
            }
          }
        }
      });
      l.push(Z);
    }
    ((Lt = e.instrumentations) == null ? void 0 : Lt["@opentelemetry/instrumentation-xml-http-request"]) !== !1 && l.push(
      new g_({
        propagateTraceHeaderCorsUrls: wo(
          e.tracingOrigins
        ),
        applyCustomAttributesOnSpan: (Z, G) => {
          var qt, Wt, Yt, Oe;
          const zt = G;
          if (!(!Z.attributes || Z.attributes[yt] === !1)) {
            if (Ao(
              Z,
              zt._body,
              zt._requestHeaders,
              e.networkRecordingOptions
            ), (qt = e.networkRecordingOptions) != null && qt.recordHeadersAndBody) {
              let Ae = "";
              (G.responseType === "" || G.responseType === "text") && (Ae = rt(
                G.responseText,
                (Wt = e.networkRecordingOptions) == null ? void 0 : Wt.networkBodyKeysToRedact,
                (Yt = e.networkRecordingOptions) == null ? void 0 : Yt.bodyKeysToRecord,
                void 0
              ));
              const cr = sy(
                G.getAllResponseHeaders()
              );
              fy(
                Z,
                cr,
                Ae,
                e.networkRecordingOptions
              );
            }
            (Oe = e.networkRecordingOptions) != null && Oe.requestResponseSanitizer && Qr(
              Z,
              e.networkRecordingOptions.requestResponseSanitizer
            );
          }
        }
      })
    );
  }
  vl({ instrumentations: l });
  const _ = new Da();
  return _.enable(), M.tracerProvider.register({
    contextManager: _,
    propagator: new Nf({
      propagators: [
        new of(),
        new ny({
          backendUrl: r,
          otlpEndpoint: e.otlpEndpoint,
          tracingOrigins: e.tracingOrigins,
          urlBlocklist: n
        })
      ]
    })
  }), M;
};
class Ze extends xa {
  constructor() {
    super(...arguments);
    R(this, "_pendingSpans", /* @__PURE__ */ new Set());
  }
  onStart(r, n) {
    r.setAttribute(ty, ot()), super.onStart(r, n);
  }
  onEnd(r) {
    if (r.attributes[yt] === !1)
      return;
    const n = Ss(r), i = xn.get(n);
    if (i) {
      const o = i.catch((a) => {
        console.warn(
          "[CustomBatchSpanProcessor] Failed to capture response body attributes",
          a
        );
      }).finally(() => {
        xn.delete(n), this._pendingSpans.delete(o), r.attributes[yt] !== !1 && super.onEnd(r);
      });
      this._pendingSpans.add(o);
      return;
    }
    super.onEnd(r);
  }
  shutdown() {
    return D(this, null, function* () {
      return yield Promise.allSettled(this._pendingSpans), dr(Ze.prototype, this, "shutdown").call(this);
    });
  }
  forceFlush() {
    return D(this, null, function* () {
      return yield Promise.allSettled(this._pendingSpans), dr(Ze.prototype, this, "forceFlush").call(this);
    });
  }
}
class ny extends qf {
  constructor(r) {
    super();
    R(this, "highlightEndpoints");
    R(this, "tracingOrigins");
    R(this, "urlBlocklist");
    this.highlightEndpoints = [
      r.backendUrl,
      `${r.otlpEndpoint}/v1/traces`,
      `${r.otlpEndpoint}/v1/logs`,
      `${r.otlpEndpoint}/v1/metrics`
    ], this.tracingOrigins = r.tracingOrigins, this.urlBlocklist = r.urlBlocklist;
  }
  inject(r, n, i) {
    var u;
    const o = b.getSpan(r);
    if (!o || !o.attributes)
      return;
    const a = Ls(o);
    typeof a == "string" && (ly(
      a,
      this.highlightEndpoints,
      this.tracingOrigins,
      this.urlBlocklist
    ) || o.setAttribute(yt, !1), !Xn(
      a,
      (u = this.tracingOrigins) != null ? u : [],
      this.urlBlocklist
    )) || super.inject(r, n, i);
  }
}
const ws = "highlight-browser", iy = ws, Oo = () => {
  var e;
  return (e = M.tracerProvider) == null ? void 0 : e.getTracer(ws);
}, De = () => {
  var e;
  return (e = M.meterProvider) == null ? void 0 : e.getMeter(iy);
}, oy = () => b.getActiveSpan(), ay = () => D(void 0, null, function* () {
  yield Promise.allSettled([
    D(void 0, null, function* () {
      M.tracerProvider ? (yield M.tracerProvider.shutdown(), M.tracerProvider = void 0) : console.warn(
        "OTEL shutdown called without initialized tracerProvider."
      );
    }),
    D(void 0, null, function* () {
      M.meterProvider ? (yield M.meterProvider.shutdown(), M.meterProvider = void 0) : console.warn(
        "OTEL shutdown called without initialized meterProvider."
      );
    })
  ]);
}), Ao = (e, t, r, n) => {
  var f;
  if (!e.attributes)
    return;
  const o = Ls(e), a = ja(o), u = $a(a), c = typeof t == "string" ? t : String(t);
  try {
    const l = t ? JSON.parse(c) : void 0;
    l != null && l.operationName && e.setAttribute(
      "graphql.operation.name",
      l.operationName
    );
  } catch (l) {
  }
  e.setAttributes({
    "highlight.type": "http.request",
    [Ht]: a,
    // overwrite with sanitized version
    [se]: a,
    [Xo]: u.pathname,
    [Js]: u.search
  });
  const s = Array.from(
    u.searchParams.entries()
  );
  if (s.length > 0 && e.setAttribute(
    "url.query_params",
    JSON.stringify(Object.fromEntries(s))
  ), n != null && n.recordHeadersAndBody) {
    const l = rt(
      t,
      n.networkBodyKeysToRedact,
      n.bodyKeysToRecord,
      r
    );
    e.setAttribute("http.request.body", l);
    const d = ir(
      (f = n.networkHeadersToRedact) != null ? f : [],
      r,
      n.headerKeysToRecord
    ), h = Kn(
      d,
      "http.request.header"
    );
    e.setAttributes(h);
  }
}, sy = (e) => {
  const t = {};
  return e && e.trim().split(/[\r\n]+/).forEach((r) => {
    const n = r.split(": "), i = n.shift();
    i && (t[i] = n.join(": "));
  }), t;
}, Kn = (e, t) => {
  const r = {};
  return Object.entries(e).forEach(([n, i]) => {
    const o = n.toLowerCase().replace(/_/g, "-"), a = `${t}.${o}`, u = cy(o, i);
    if (r[a]) {
      const c = r[a];
      Array.isArray(c) ? r[a] = [...c, ...u] : r[a] = [c, ...u];
    } else
      r[a] = u.length === 1 ? u[0] : u;
  }), r;
}, uy = /* @__PURE__ */ new Set([
  "accept",
  "accept-charset",
  "accept-encoding",
  "accept-language",
  "accept-ranges",
  "allow",
  "cache-control",
  "connection",
  "content-encoding",
  "content-language",
  "expect",
  "if-match",
  "if-none-match",
  "pragma",
  "proxy-authenticate",
  "te",
  "trailer",
  "transfer-encoding",
  "upgrade",
  "vary",
  "via",
  "warning",
  "www-authenticate",
  "access-control-allow-headers",
  "access-control-allow-methods",
  "access-control-expose-headers",
  "access-control-request-headers"
]), cy = (e, t) => uy.has(e) ? t.split(",").map((r) => r.trim()).filter((r) => r.length > 0) : [t], fy = (e, t, r, n) => {
  var a;
  e.setAttribute("http.response.body", r);
  const i = ir(
    (a = n.networkHeadersToRedact) != null ? a : [],
    t,
    n.headerKeysToRecord
  ), o = Kn(
    i,
    "http.response.header"
  );
  e.setAttributes(o);
}, Qr = (e, t) => {
  var l, d, h, _, p, g, E, y, A, L;
  const n = e.attributes, i = {}, o = {};
  for (const [P, C] of Object.entries(n))
    P.startsWith("http.request.header.") && (i[P.slice(20)] = String(C)), P.startsWith("http.response.header.") && (o[P.slice(21)] = String(C));
  let u = {
    request: {
      sessionSecureID: "",
      id: "",
      url: (d = (l = n[se]) != null ? l : n[Ht]) != null ? d : "",
      verb: (h = n["http.request.method"]) != null ? h : "GET",
      headers: i,
      body: (_ = n["http.request.body"]) != null ? _ : ""
    },
    response: {
      status: Number(
        (p = n[Fo]) != null ? p : 0
      ),
      headers: o,
      body: (g = n["http.response.body"]) != null ? g : ""
    },
    urlBlocked: !1
  }, c = !0;
  try {
    u.request.body = JSON.parse(u.request.body);
  } catch (P) {
    c = !1;
  }
  let s = !0;
  try {
    u.response.body = JSON.parse(u.response.body);
  } catch (P) {
    s = !1;
  }
  let f;
  try {
    f = t(u);
  } catch (P) {
    return;
  }
  if (!f) {
    Object.assign(e.attributes, {
      [yt]: !1
    });
    return;
  }
  c && ((E = f.request) != null && E.body) && (f.request.body = JSON.stringify(f.request.body)), s && ((y = f.response) != null && y.body) && (f.response.body = JSON.stringify(f.response.body)), Object.assign(e.attributes, {
    "http.request.body": (A = f.request.body) != null ? A : "",
    "http.response.body": (L = f.response.body) != null ? L : ""
  });
}, ly = (e, t, r, n) => n != null && n.some(
  (o) => e.toLowerCase().includes(o)
) ? !1 : Fn(
  e,
  t
), bo = (e) => {
  var o, a, u;
  if (!e.events)
    return;
  const r = e.events, n = {
    unload: $("unloadEventStart", "unloadEventEnd", r),
    dom_interactive: $(
      "fetchStart",
      "domInteractive",
      r
    ),
    dom_content_loaded: $(
      "domContentLoadedEventStart",
      "domContentLoadedEventEnd",
      r
    ),
    dom_complete: $("fetchStart", "domComplete", r),
    load_event: $("loadEventStart", "loadEventEnd", r),
    document_load: $("fetchStart", "loadEventEnd", r),
    first_paint: $("fetchStart", "firstPaint", r),
    first_contentful_paint: $(
      "fetchStart",
      "firstContentfulPaint",
      r
    ),
    domain_lookup: $(
      "domainLookupStart",
      "domainLookupEnd",
      r
    ),
    connect: $("connectStart", "connectEnd", r),
    request: $("requestStart", "requestEnd", r),
    response: $("responseStart", "responseEnd", r)
  }, i = (a = (o = Q == null ? void 0 : Q.getIntegrations) == null ? void 0 : o.call(Q)) != null ? a : [];
  if (n.document_load !== void 0)
    for (const c of i)
      c.recordGauge((u = Q == null ? void 0 : Q.sessionSecureId) != null ? u : "", {
        name: Ks,
        value: n.document_load / 1e6
      });
  Object.entries(n).forEach(([c, s]) => {
    s !== void 0 && (e.setAttribute(`timings.${c}.ns`, s), e.setAttribute(
      `timings.${c}.readable`,
      Rs(s)
    ));
  });
};
function $(e, t, r) {
  const n = r.find((u) => u.name === e), i = r.find((u) => u.name === t);
  if (!n || !i)
    return;
  const o = n.time[0] * 1e9 + n.time[1];
  return i.time[0] * 1e9 + i.time[1] - o;
}
const dy = (e, t) => {
  const r = {
    domain_lookup: (t.domainLookupEnd - t.domainLookupStart) * 1e9,
    connect: (t.connectEnd - t.connectStart) * 1e9,
    request: (t.responseEnd - t.requestStart) * 1e9,
    response: (t.responseEnd - t.responseStart) * 1e9
  };
  Object.entries(r).forEach(([n, i]) => {
    e.setAttribute(`timings.${n}.ns`, i), e.setAttribute(`timings.${n}.readable`, Rs(i));
  });
}, Rs = (e) => {
  if (e >= 36e11) {
    const a = e / 36e11;
    return `${Number(a.toFixed(1))}h`;
  } else if (e >= 6e10) {
    const a = e / 6e10;
    return `${Number(a.toFixed(1))}m`;
  } else if (e >= 1e9) {
    const a = e / 1e9;
    return `${Number(a.toFixed(1))}s`;
  } else if (e >= 1e6) {
    const a = e / 1e6;
    return `${Number(a.toFixed(1))}ms`;
  } else if (e >= 1e3) {
    const a = e / 1e3;
    return `${Number(a.toFixed(1))}µs`;
  } else
    return `${Number(e.toFixed(1))}ns`;
}, wo = (e) => e === !0 ? [/localhost/, /^\//, new RegExp(window.location.host)] : Array.isArray(e) ? e.map(
  (t) => typeof t == "string" ? new RegExp(t) : t
) : /^$/, Ls = (e) => e.attributes[se] ? e.attributes[se] : e.attributes[Ht], py = 30, hy = () => new Promise(
  (e) => requestAnimationFrame(
    (t) => requestAnimationFrame((r) => e(r - t))
  )
), _y = () => D(void 0, null, function* () {
  const e = [];
  for (let t = 0; t < py; t++)
    e.push(yield hy());
  return e.reduce((t, r) => t + r, 0) / e.length;
}), vy = (e, t) => {
  let r = {}, n = 16.666666666666668;
  _y().then((c) => n = c);
  const i = (c) => {
    var s;
    r != null && r.event || (r = {
      event: c,
      location: window.location.href,
      timerStart: (s = window.performance) == null ? void 0 : s.now()
    }, window.requestAnimationFrame(o));
  }, o = () => {
    if (!(r != null && r.timerStart)) return;
    const c = window.performance.now() - r.timerStart - n;
    a(c), r = {};
  }, a = (c) => {
    const s = ((/* @__PURE__ */ new Date()).getTime() - t) / 1e3;
    e({
      relativeTimestamp: s,
      jankAmount: c,
      querySelector: u(),
      newLocation: window.location.href != r.location ? window.location.href : void 0
    });
  }, u = () => {
    var c;
    return (c = r == null ? void 0 : r.event) != null && c.target ? Zs(r.event.target) : "";
  };
  return window.addEventListener("click", i, !0), window.addEventListener("keydown", i, !0), () => {
    window.removeEventListener("keydown", i, !0), window.removeEventListener("click", i, !0);
  };
}, gy = typeof window != "undefined", Ro = gy && "performance" in window && "memory" in performance ? performance : { memory: {} }, Ey = (e, t) => {
  let r = 0, n = 0;
  const i = () => {
    const f = ((/* @__PURE__ */ new Date()).getTime() - t) / 1e3, l = Ro.memory.jsHeapSizeLimit || 0, d = Ro.memory.usedJSHeapSize || 0;
    e({
      jsHeapSizeLimit: l,
      usedJSHeapSize: d,
      relativeTimestamp: f,
      fps: r
    });
  };
  i();
  let o;
  o = setInterval(() => {
    i();
  }, 1e3);
  let a = 0, u = Date.now();
  const c = function() {
    var s = Date.now();
    a++, s > 1e3 + u && (r = Math.round(a * 1e3 / (s - u)), a = 0, u = s), n = requestAnimationFrame(c);
  };
  return c(), () => {
    clearInterval(o), cancelAnimationFrame(n);
  };
};
var st, ae, Ps, Qe, Dn, Ns = -1, Rt = function(e) {
  addEventListener("pageshow", function(t) {
    t.persisted && (Ns = t.timeStamp, e(t));
  }, !0);
}, Jn = function() {
  return window.performance && performance.getEntriesByType && performance.getEntriesByType("navigation")[0];
}, sr = function() {
  var e = Jn();
  return e && e.activationStart || 0;
}, j = function(e, t) {
  var r = Jn(), n = "navigate";
  return Ns >= 0 ? n = "back-forward-cache" : r && (document.prerendering || sr() > 0 ? n = "prerender" : document.wasDiscarded ? n = "restore" : r.type && (n = r.type.replace(/_/g, "-"))), { name: e, value: t === void 0 ? -1 : t, rating: "good", delta: 0, entries: [], id: "v3-".concat(Date.now(), "-").concat(Math.floor(8999999999999 * Math.random()) + 1e12), navigationType: n };
}, Ft = function(e, t, r) {
  try {
    if (PerformanceObserver.supportedEntryTypes.includes(e)) {
      var n = new PerformanceObserver(function(i) {
        Promise.resolve().then(function() {
          t(i.getEntries());
        });
      });
      return n.observe(Object.assign({ type: e, buffered: !0 }, r || {})), n;
    }
  } catch (i) {
  }
}, V = function(e, t, r, n) {
  var i, o;
  return function(a) {
    t.value >= 0 && (a || n) && ((o = t.value - (i || 0)) || i === void 0) && (i = t.value, t.delta = o, t.rating = function(u, c) {
      return u > c[1] ? "poor" : u > c[0] ? "needs-improvement" : "good";
    }(t.value, r), e(t));
  };
}, Zn = function(e) {
  requestAnimationFrame(function() {
    return requestAnimationFrame(function() {
      return e();
    });
  });
}, ur = function(e) {
  var t = function(r) {
    r.type !== "pagehide" && document.visibilityState !== "hidden" || e(r);
  };
  addEventListener("visibilitychange", t, !0), addEventListener("pagehide", t, !0);
}, Qn = function(e) {
  var t = !1;
  return function(r) {
    t || (e(r), t = !0);
  };
}, Dt = -1, Lo = function() {
  return document.visibilityState !== "hidden" || document.prerendering ? 1 / 0 : 0;
}, tr = function(e) {
  document.visibilityState === "hidden" && Dt > -1 && (Dt = e.type === "visibilitychange" ? e.timeStamp : 0, yy());
}, Po = function() {
  addEventListener("visibilitychange", tr, !0), addEventListener("prerenderingchange", tr, !0);
}, yy = function() {
  removeEventListener("visibilitychange", tr, !0), removeEventListener("prerenderingchange", tr, !0);
}, ti = function() {
  return Dt < 0 && (Dt = Lo(), Po(), Rt(function() {
    setTimeout(function() {
      Dt = Lo(), Po();
    }, 0);
  })), { get firstHiddenTime() {
    return Dt;
  } };
}, Se = function(e) {
  document.prerendering ? addEventListener("prerenderingchange", function() {
    return e();
  }, !0) : e();
}, No = [1800, 3e3], Is = function(e, t) {
  t = t || {}, Se(function() {
    var r, n = ti(), i = j("FCP"), o = Ft("paint", function(a) {
      a.forEach(function(u) {
        u.name === "first-contentful-paint" && (o.disconnect(), u.startTime < n.firstHiddenTime && (i.value = Math.max(u.startTime - sr(), 0), i.entries.push(u), r(!0)));
      });
    });
    o && (r = V(e, i, No, t.reportAllChanges), Rt(function(a) {
      i = j("FCP"), r = V(e, i, No, t.reportAllChanges), Zn(function() {
        i.value = performance.now() - a.timeStamp, r(!0);
      });
    }));
  });
}, Io = [0.1, 0.25], my = function(e, t) {
  t = t || {}, Is(Qn(function() {
    var r, n = j("CLS", 0), i = 0, o = [], a = function(c) {
      c.forEach(function(s) {
        if (!s.hadRecentInput) {
          var f = o[0], l = o[o.length - 1];
          i && s.startTime - l.startTime < 1e3 && s.startTime - f.startTime < 5e3 ? (i += s.value, o.push(s)) : (i = s.value, o = [s]);
        }
      }), i > n.value && (n.value = i, n.entries = o, r());
    }, u = Ft("layout-shift", a);
    u && (r = V(e, n, Io, t.reportAllChanges), ur(function() {
      a(u.takeRecords()), r(!0);
    }), Rt(function() {
      i = 0, n = j("CLS", 0), r = V(e, n, Io, t.reportAllChanges), Zn(function() {
        return r();
      });
    }), setTimeout(r, 0));
  }));
}, re = { passive: !0, capture: !0 }, Ty = /* @__PURE__ */ new Date(), Co = function(e, t) {
  st || (st = t, ae = e, Ps = /* @__PURE__ */ new Date(), Ms(removeEventListener), Cs());
}, Cs = function() {
  if (ae >= 0 && ae < Ps - Ty) {
    var e = { entryType: "first-input", name: st.type, target: st.target, cancelable: st.cancelable, startTime: st.timeStamp, processingStart: st.timeStamp + ae };
    Qe.forEach(function(t) {
      t(e);
    }), Qe = [];
  }
}, Sy = function(e) {
  if (e.cancelable) {
    var t = (e.timeStamp > 1e12 ? /* @__PURE__ */ new Date() : performance.now()) - e.timeStamp;
    e.type == "pointerdown" ? function(r, n) {
      var i = function() {
        Co(r, n), a();
      }, o = function() {
        a();
      }, a = function() {
        removeEventListener("pointerup", i, re), removeEventListener("pointercancel", o, re);
      };
      addEventListener("pointerup", i, re), addEventListener("pointercancel", o, re);
    }(t, e) : Co(t, e);
  }
}, Ms = function(e) {
  ["mousedown", "keydown", "touchstart", "pointerdown"].forEach(function(t) {
    return e(t, Sy, re);
  });
}, Mo = [100, 300], Oy = function(e, t) {
  t = t || {}, Se(function() {
    var r, n = ti(), i = j("FID"), o = function(c) {
      c.startTime < n.firstHiddenTime && (i.value = c.processingStart - c.startTime, i.entries.push(c), r(!0));
    }, a = function(c) {
      c.forEach(o);
    }, u = Ft("first-input", a);
    r = V(e, i, Mo, t.reportAllChanges), u && ur(Qn(function() {
      a(u.takeRecords()), u.disconnect();
    })), u && Rt(function() {
      var c;
      i = j("FID"), r = V(e, i, Mo, t.reportAllChanges), Qe = [], ae = -1, st = null, Ms(addEventListener), c = o, Qe.push(c), Cs();
    });
  });
}, xs = 0, tn = 1 / 0, Ue = 0, Ay = function(e) {
  e.forEach(function(t) {
    t.interactionId && (tn = Math.min(tn, t.interactionId), Ue = Math.max(Ue, t.interactionId), xs = Ue ? (Ue - tn) / 7 + 1 : 0);
  });
}, Ds = function() {
  return Dn ? xs : performance.interactionCount || 0;
}, by = function() {
  "interactionCount" in performance || Dn || (Dn = Ft("event", Ay, { type: "event", buffered: !0, durationThreshold: 0 }));
}, xo = [200, 500], Us = 0, Do = function() {
  return Ds() - Us;
}, W = [], en = {}, Uo = function(e) {
  var t = W[W.length - 1], r = en[e.interactionId];
  if (r || W.length < 10 || e.duration > t.latency) {
    if (r) r.entries.push(e), r.latency = Math.max(r.latency, e.duration);
    else {
      var n = { id: e.interactionId, latency: e.duration, entries: [e] };
      en[n.id] = n, W.push(n);
    }
    W.sort(function(i, o) {
      return o.latency - i.latency;
    }), W.splice(10).forEach(function(i) {
      delete en[i.id];
    });
  }
}, wy = function(e, t) {
  t = t || {}, Se(function() {
    var r;
    by();
    var n, i = j("INP"), o = function(u) {
      u.forEach(function(f) {
        f.interactionId && Uo(f), f.entryType === "first-input" && !W.some(function(l) {
          return l.entries.some(function(d) {
            return f.duration === d.duration && f.startTime === d.startTime;
          });
        }) && Uo(f);
      });
      var c, s = (c = Math.min(W.length - 1, Math.floor(Do() / 50)), W[c]);
      s && s.latency !== i.value && (i.value = s.latency, i.entries = s.entries, n());
    }, a = Ft("event", o, { durationThreshold: (r = t.durationThreshold) !== null && r !== void 0 ? r : 40 });
    n = V(e, i, xo, t.reportAllChanges), a && ("interactionId" in PerformanceEventTiming.prototype && a.observe({ type: "first-input", buffered: !0 }), ur(function() {
      o(a.takeRecords()), i.value < 0 && Do() > 0 && (i.value = 0, i.entries = []), n(!0);
    }), Rt(function() {
      W = [], Us = Ds(), i = j("INP"), n = V(e, i, xo, t.reportAllChanges);
    }));
  });
}, Bo = [2500, 4e3], rn = {}, Ry = function(e, t) {
  t = t || {}, Se(function() {
    var r, n = ti(), i = j("LCP"), o = function(c) {
      var s = c[c.length - 1];
      s && s.startTime < n.firstHiddenTime && (i.value = Math.max(s.startTime - sr(), 0), i.entries = [s], r());
    }, a = Ft("largest-contentful-paint", o);
    if (a) {
      r = V(e, i, Bo, t.reportAllChanges);
      var u = Qn(function() {
        rn[i.id] || (o(a.takeRecords()), a.disconnect(), rn[i.id] = !0, r(!0));
      });
      ["keydown", "click"].forEach(function(c) {
        addEventListener(c, function() {
          return setTimeout(u, 0);
        }, !0);
      }), ur(u), Rt(function(c) {
        i = j("LCP"), r = V(e, i, Bo, t.reportAllChanges), Zn(function() {
          i.value = performance.now() - c.timeStamp, rn[i.id] = !0, r(!0);
        });
      });
    }
  });
}, ko = [800, 1800], Ly = function e(t) {
  document.prerendering ? Se(function() {
    return e(t);
  }) : document.readyState !== "complete" ? addEventListener("load", function() {
    return e(t);
  }, !0) : setTimeout(t, 0);
}, Py = function(e, t) {
  t = t || {};
  var r = j("TTFB"), n = V(e, r, ko, t.reportAllChanges);
  Ly(function() {
    var i = Jn();
    if (i) {
      var o = i.responseStart;
      if (o <= 0 || o > performance.now()) return;
      r.value = Math.max(o - sr(), 0), r.entries = [i], n(!0), Rt(function() {
        r = j("TTFB", 0), (n = V(e, r, ko, t.reportAllChanges))(!0);
      });
    }
  });
};
const Ny = (e) => (my(e), Is(e), Oy(e), Ry(e), Py(e), wy(e), () => {
}), xt = typeof navigator != "undefined" && "connection" in navigator ? navigator.connection : {}, Iy = (e, t) => {
  const r = () => {
    const o = ((/* @__PURE__ */ new Date()).getTime() - t) / 1e3;
    e({
      relativeTimestamp: o,
      downlink: xt.downlink,
      downlinkMax: xt.downlinkMax,
      effectiveType: xt.effectiveType,
      rtt: xt.rtt,
      saveData: xt.saveData,
      type: xt.type
    });
  };
  r();
  let n;
  return n = setInterval(() => {
    r();
  }, 1e3), () => {
    clearInterval(n);
  };
}, Cy = () => {
  if (!("performance" in window && "memory" in performance))
    return {
      getDeviceDetails: void 0,
      getCurrentDeviceDetails: void 0
    };
  const e = window.performance;
  return {
    getDeviceDetails: () => ({
      deviceMemory: My(
        navigator.deviceMemory || 0
      )
    }),
    getCurrentDeviceDetails: () => {
      const n = nn(
        e.memory.jsHeapSizeLimit
      ), i = nn(
        e.memory.totalJSHeapSize
      ), o = nn(
        e.memory.usedJSHeapSize
      );
      return {
        jsHeapSizeLimit: n,
        totalJSHeapSize: i,
        usedJSHeapSize: o
      };
    }
  };
}, nn = (e) => e / Math.pow(1e3, 2), My = (e) => 1024 * e;
function xy(e) {
  return "regexValue" in e;
}
function Dy(e) {
  return "matchValue" in e;
}
function Uy(e) {
  const t = Math.trunc(e);
  return t === 1 ? !0 : t === 0 ? !1 : Math.floor(Math.random() * t) === 0;
}
class By {
  /**
   * @param config The sampling configuration.
   * @param sampler The sampler to use. This is intended to be used for testing purposes.
   */
  constructor(t = Uy) {
    R(this, "regexCache", /* @__PURE__ */ new Map());
    R(this, "config");
    this.sampler = t;
  }
  setConfig(t) {
    this.config = t;
  }
  isSamplingEnabled() {
    var t, r, n, i;
    return !!((r = (t = this.config) == null ? void 0 : t.logs) != null && r.length || (i = (n = this.config) == null ? void 0 : n.spans) != null && i.length);
  }
  shouldSample(t) {
    var r, n;
    return t.name === Os ? this.sampleLog((r = this.config) == null ? void 0 : r.logs, t) : this.sampleSpan((n = this.config) == null ? void 0 : n.spans, t);
  }
  /**
   * Check if a value matches a match config.
   */
  matchesValue(t, r) {
    if (!t)
      return !1;
    if (Dy(t))
      return t.matchValue === r;
    if (xy(t)) {
      const n = t.regexValue;
      if (n === null)
        return !1;
      this.regexCache.has(n) || this.regexCache.set(n, new RegExp(n));
      const i = this.regexCache.get(n);
      if (typeof r == "string")
        return i.test(r);
    }
    return !1;
  }
  /**
   * Check if the attributes match the attribute configs.
   */
  matchesAttributes(t, r) {
    if (t)
      for (const n of t) {
        let i = !1;
        for (const o of Object.keys(r))
          if (this.matchesValue(n.key, o)) {
            const a = r[o];
            if (this.matchesValue(
              n.attribute,
              a
            )) {
              i = !0;
              break;
            }
          }
        if (!i)
          return !1;
      }
    return !0;
  }
  matchEvent(t, r) {
    return !(t.name && !this.matchesValue(t.name, r.name) || t.attributes && (!r.attributes || !this.matchesAttributes(
      t.attributes,
      r.attributes
    )));
  }
  matchesEvents(t, r) {
    if (t)
      for (const n of t) {
        let i = !1;
        for (const o of r)
          if (this.matchEvent(n, o)) {
            i = !0;
            break;
          }
        if (!i)
          return !1;
      }
    return !0;
  }
  /**
   * Attempts to match the span to the config. The span will match only if all defined conditions are met.
   *
   * @param config The config to match against.
   * @param name The name of the span to match.
   * @param attributes The attributes of the span to match.
   * @returns True if the span matches the config, false otherwise.
   */
  matchesSpanConfig(t, r) {
    return !(t.name && !this.matchesValue(t.name, r.name) || !this.matchesAttributes(t.attributes, r.attributes) || !this.matchesEvents(t.events, r.events));
  }
  matchesLogConfig(t, r) {
    if (t.severityText) {
      const n = r[As];
      if (!this.matchesValue(t.severityText, n))
        return !1;
    }
    if (t.message) {
      const n = r[bs];
      if (!this.matchesValue(t.message, n))
        return !1;
    }
    return !!this.matchesAttributes(t.attributes, r);
  }
  /**
   * Sample a span based on the sampling configuration.
   *
   * @param configs The sampling configuration.
   * @param name The name of the span to sample.
   * @param attributes The attributes of the span to sample.
   * @returns The sampling result.
   */
  sampleSpan(t, r) {
    if (t) {
      for (const n of t)
        if (this.matchesSpanConfig(n, r))
          return {
            sample: this.sampler(n.samplingRatio),
            attributes: {
              [So]: n.samplingRatio
            }
          };
    }
    return {
      sample: !0
    };
  }
  /**
   * Sample a log based on the sampling configuration.
   *
   * @param configs The sampling configuration.
   * @param attributes The attributes of the log to sample.
   * @returns The sampling result.
   */
  sampleLog(t, r) {
    if (t) {
      for (const n of t)
        if (this.matchesLogConfig(n, r.attributes))
          return {
            sample: this.sampler(n.samplingRatio),
            attributes: {
              [So]: n.samplingRatio
            }
          };
    }
    return {
      sample: !0
    };
  }
}
const Ho = () => {
  const e = {
    end: () => {
    },
    spanContext: () => ({
      traceId: "",
      spanId: "",
      traceFlags: 0
    }),
    setAttribute: (t, r) => e,
    setAttributes: (t) => e,
    addEvent: (t, r, n) => e,
    addLinks: (t) => e,
    setStatus: (t) => e,
    recordException: () => {
    },
    addLink: () => e,
    updateName: () => e,
    isRecording: () => !1
  };
  return e;
}, ky = "exception", Hy = function(e, t, r) {
  if (!e)
    return;
  const n = S({}, r);
  typeof t == "string" ? n[hr] = t : t && (t.code ? n[pr] = t.code.toString() : t.name && (n[pr] = t.name), t.message && (n[hr] = t.message), t.stack && (n[Qs] = t.stack)), n[pr] || n[hr] ? e.addEvent(ky, n) : Su(
    "otel",
    "recordException",
    "warn",
    `Failed to record an exception ${t}`
  );
};
class Gy {
  constructor(t) {
    /** Verbose project ID that is exposed to users. Legacy users may still be using ints. */
    R(this, "organizationID");
    R(this, "_options");
    R(this, "_integrations", []);
    R(this, "_gauges", /* @__PURE__ */ new Map());
    R(this, "_counters", /* @__PURE__ */ new Map());
    R(this, "_histograms", /* @__PURE__ */ new Map());
    R(this, "_up_down_counters", /* @__PURE__ */ new Map());
    R(this, "sampler", new By());
    R(this, "_started", !1);
    R(this, "graphqlSDK");
    this._options = t, this.organizationID = t.projectId;
  }
  start() {
    return D(this, null, function* () {
      var r, n, i, o, a, u, c, s, f, l, d, h, _, p, g, E, y;
      if (this._started)
        return;
      this._started = !0, ry(
        {
          backendUrl: (n = (r = this._options) == null ? void 0 : r.backendUrl) != null ? n : "https://pub.observability.app.launchdarkly.com",
          otlpEndpoint: (a = (o = (i = this._options) == null ? void 0 : i.otel) == null ? void 0 : o.otlpEndpoint) != null ? a : "https://otel.observability.app.launchdarkly.com",
          projectId: this._options.projectId,
          sessionSecureId: this._options.sessionSecureId,
          environment: (c = (u = this._options) == null ? void 0 : u.environment) != null ? c : "production",
          networkRecordingOptions: typeof ((s = this._options) == null ? void 0 : s.networkRecording) == "object" ? this._options.networkRecording : void 0,
          tracingOrigins: (f = this._options) == null ? void 0 : f.tracingOrigins,
          serviceName: (d = (l = this._options) == null ? void 0 : l.serviceName) != null ? d : "browser",
          serviceVersion: (h = this._options) == null ? void 0 : h.version,
          instrumentations: (p = (_ = this._options) == null ? void 0 : _.otel) == null ? void 0 : p.instrumentations,
          eventNames: (E = (g = this._options) == null ? void 0 : g.otel) == null ? void 0 : E.eventNames,
          getIntegrations: () => this._integrations
        },
        this.sampler
      ), this._gauges.clear(), this._counters.clear(), this._histograms.clear(), this._up_down_counters.clear();
      const t = new ru(
        (y = this._options.backendUrl) != null ? y : "https://pub.observability.app.launchdarkly.com",
        {
          headers: {}
        }
      );
      this.graphqlSDK = tu(t, eu()), yield this.configureSampling(), this.setupListeners();
    });
  }
  stop() {
    return D(this, null, function* () {
      this._started && (this._started = !1, yield ay());
    });
  }
  configureSampling() {
    return D(this, null, function* () {
      try {
        const t = yield this.graphqlSDK.GetSamplingConfig({
          organization_verbose_id: `${this.organizationID}`
        });
        this.sampler.setConfig(t.sampling);
      } catch (t) {
        zo(
          "sampling",
          "warn",
          `LaunchDarkly Observability: Failed to configure sampling: ${t}`
        );
      }
    });
  }
  _recordLog(t, r, n, i) {
    this.startSpan(Os, (o) => {
      const a = typeof t == "string" ? t : Ut(t), u = i ? Ut(i.map((c) => c.toString())) : void 0;
      if (o == null || o.addEvent("log", S({
        [As]: r,
        [bs]: a,
        "code.stacktrace": u
      }, n)), this._options.reportConsoleErrors && r === "error") {
        o == null || o.recordException(new Error(a)), o == null || o.setStatus({
          code: Ve.ERROR,
          message: a
        });
        const c = new Error(a);
        i && (c.stack = u), this.recordError(c);
      }
    });
  }
  _recordErrorMessage(t, r) {
    try {
      t.payload && (r = S(S({}, JSON.parse(t.payload)), r || {}));
    } catch (a) {
    }
    this.startSpan("highlight.exception", (a) => {
      var u;
      Hy(a, (u = t.error) != null ? u : new Error(t.event), {
        [ey]: t.id
      }), a == null || a.setAttributes(S({
        event: t.event,
        type: t.type,
        url: t.url,
        source: t.source,
        lineNumber: t.lineNumber,
        columnNumber: t.columnNumber
      }, r));
    });
    const o = t, { payload: n } = o, i = lr(o, ["payload"]);
    for (const a of this._integrations)
      a.error(ot(), N(S({}, i), {
        payload: JSON.stringify(r)
      }));
  }
  recordError(t, r, n, i, o) {
    var s, f, l, d;
    t = t || new Error("Unknown error"), t instanceof Error && t.cause && (n = N(S({}, n), {
      "exception.cause": JSON.stringify(t.cause)
    }));
    let a = r ? r + ":" + t.message : t.message;
    o === "React.ErrorBoundary" && (a = "ErrorBoundary: " + a);
    const u = er(t), c = {
      error: t,
      event: a,
      type: o != null ? o : "custom",
      url: window.location.href,
      source: i != null ? i : "frontend",
      lineNumber: (s = u[0]) != null && s.lineNumber ? (f = u[0]) == null ? void 0 : f.lineNumber : 0,
      columnNumber: (l = u[0]) != null && l.columnNumber ? (d = u[0]) == null ? void 0 : d.columnNumber : 0,
      stackTrace: u,
      timestamp: (/* @__PURE__ */ new Date()).toISOString(),
      id: Yo()
    };
    this._recordErrorMessage(c, n);
  }
  recordCount(t) {
    var n;
    let r = this._counters.get(t.name);
    if (!r) {
      if (r = (n = De()) == null ? void 0 : n.createCounter(t.name), !r) return;
      this._counters.set(t.name, r);
    }
    r.add(t.value, N(S({}, t.attributes), {
      "highlight.session_id": ot()
    }));
  }
  recordGauge(t) {
    var i, o, a, u;
    let r = this._gauges.get(t.name);
    if (!r) {
      if (r = (i = De()) == null ? void 0 : i.createGauge(t.name), !r) return;
      this._gauges.set(t.name, r);
    }
    r.record(t.value, N(S({}, t.attributes), {
      "highlight.session_id": ot()
    }));
    const n = {
      name: t.name,
      value: t.value,
      category: (o = t.attributes) == null ? void 0 : o.category,
      group: (u = (a = t.attributes) == null ? void 0 : a.group) == null ? void 0 : u.toString(),
      tags: t.attributes ? Object.entries(t.attributes).map(([c, s]) => {
        var f;
        return {
          name: c != null ? c : "",
          value: (f = s == null ? void 0 : s.toString()) != null ? f : ""
        };
      }) : []
    };
    for (const c of this._integrations)
      c.recordGauge(
        ot(),
        n
      );
  }
  recordIncr(t) {
    this.recordCount(N(S({}, t), { value: 1 }));
  }
  recordHistogram(t) {
    var n;
    let r = this._histograms.get(t.name);
    if (!r) {
      if (r = (n = De()) == null ? void 0 : n.createHistogram(t.name), !r) return;
      this._histograms.set(t.name, r);
    }
    r.record(t.value, N(S({}, t.attributes), {
      "highlight.session_id": ot()
    }));
  }
  recordUpDownCounter(t) {
    var n;
    let r = this._up_down_counters.get(t.name);
    if (!r) {
      if (r = (n = De()) == null ? void 0 : n.createUpDownCounter(t.name), !r) return;
      this._up_down_counters.set(t.name, r);
    }
    r.add(t.value, N(S({}, t.attributes), {
      "highlight.session_id": ot()
    }));
  }
  startSpan(t, r, n, i) {
    const o = Oo();
    if (!o) {
      const u = Ho();
      return i === void 0 && n === void 0 ? r(u) : i === void 0 ? n(u) : i(u);
    }
    const a = (u, c) => {
      const s = c(u);
      return s instanceof Promise ? s.finally(() => u.end()) : (u.end(), s);
    };
    return i === void 0 && n === void 0 ? o.startActiveSpan(
      t,
      (u) => a(u, r)
    ) : i === void 0 ? o.startActiveSpan(
      t,
      r,
      (u) => a(u, n)
    ) : o.startActiveSpan(
      t,
      r,
      n,
      (u) => a(u, i)
    );
  }
  startManualSpan(t, r, n, i) {
    const o = Oo();
    if (!o) {
      const a = Ho();
      return i === void 0 && n === void 0 ? r(a) : i === void 0 ? n(a) : i(a);
    }
    return i === void 0 && n === void 0 ? o.startActiveSpan(t, r) : i === void 0 ? o.startActiveSpan(
      t,
      r,
      n
    ) : o.startActiveSpan(
      t,
      r,
      n,
      i
    );
  }
  register(t, r) {
    this._integrations.push(new nu(t, r));
  }
  getHooks(t) {
    return this._integrations.flatMap((r) => {
      var n, i;
      return (i = (n = r.getHooks) == null ? void 0 : n.call(r, t)) != null ? i : [];
    });
  }
  submitViewportMetrics({
    height: t,
    width: r,
    availHeight: n,
    availWidth: i
  }) {
    this.recordGauge({
      name: dt.ViewportHeight,
      value: t,
      attributes: {
        category: F.Device,
        group: window.location.href
      }
    }), this.recordGauge({
      name: dt.ViewportWidth,
      value: r,
      attributes: {
        category: F.Device,
        group: window.location.href
      }
    }), this.recordGauge({
      name: dt.ScreenHeight,
      value: n,
      attributes: {
        category: F.Device,
        group: window.location.href
      }
    }), this.recordGauge({
      name: dt.ScreenWidth,
      value: i,
      attributes: {
        category: F.Device,
        group: window.location.href
      }
    }), this.recordGauge({
      name: dt.ViewportArea,
      value: t * r,
      attributes: {
        category: F.Device,
        group: window.location.href
      }
    });
  }
  setupListeners() {
    var r;
    this._options.disableConsoleRecording || wu(
      (n) => {
        var i;
        this._recordLog(
          (i = n.value) == null ? void 0 : i.join(" "),
          n.type,
          n.attributes ? JSON.parse(n.attributes) : {},
          n.trace
        );
      },
      {
        level: (r = this._options.consoleMethodsToRecord) != null ? r : [
          ...qo
        ],
        logger: "console",
        stringifyOptions: {
          depthOfLimit: 10,
          numOfKeysLimit: 100,
          stringLengthLimit: 1e3
        }
      }
    ), this._options.enablePerformanceRecording !== !1 && (Ey((n) => {
      Object.entries(n).filter(([i]) => i !== "relativeTimestamp").forEach(
        ([i, o]) => o && this.recordGauge({
          name: i,
          value: o,
          attributes: {
            category: F.Performance,
            group: window.location.href
          }
        })
      );
    }, 0), vy((n) => {
      this.recordGauge({
        name: "Jank",
        value: n.jankAmount,
        attributes: {
          category: F.WebVital,
          group: n.querySelector
        }
      });
    }, 0)), Du(
      (n) => {
        var a;
        if (Bu.includes(n.event) || ku.some(
          (u) => n.event.includes(u)
        ))
          return;
        const i = new Error(n.event);
        i.stack = Ut(n.stackTrace.map((u) => u.toString()));
        let o = {};
        try {
          n.payload && (o = JSON.parse(n.payload));
        } catch (u) {
        }
        this._recordErrorMessage(
          N(S({}, n), { error: (a = n.error) != null ? a : i }),
          o
        );
      },
      { enablePromisePatch: !!this._options.enablePromisePatch }
    ), Ny((n) => {
      const { name: i, value: o } = n, { hostname: a, pathname: u, href: c } = window.location;
      this.recordGauge({
        name: i,
        value: o,
        attributes: {
          group: window.location.pathname,
          category: F.WebVital,
          [se]: ja(c),
          [Xo]: u,
          [au]: a
        }
      });
    }), iu((n) => {
      this.submitViewportMetrics(n);
    }), Iy((n) => {
      const i = {
        category: F.Performance,
        group: window.location.href
      };
      n.saveData !== void 0 && (i.saveData = n.saveData.toString()), n.effectiveType !== void 0 && (i.effectiveType = n.effectiveType.toString()), n.type !== void 0 && (i.type = n.type.toString()), Object.entries(n).filter(([o]) => o !== "relativeTimestamp").forEach(([o, a]) => {
        ou(a) && this.recordGauge({
          name: o,
          value: a,
          attributes: i
        });
      });
    }, (/* @__PURE__ */ new Date()).getTime());
    const { getDeviceDetails: t } = Cy();
    t && this.recordGauge({
      name: dt.DeviceMemory,
      value: t().deviceMemory,
      attributes: {
        category: F.Device,
        group: window.location.href
      }
    });
  }
  recordLog(t, r, n) {
    return this._recordLog(t, r, n);
  }
}
class Ky extends su {
  constructor(r) {
    super(r);
    R(this, "observe");
    R(this, "options");
    this.options = r;
  }
  initialize(r, n) {
    try {
      if (typeof window == "undefined" || typeof document == "undefined") {
        console.warn(
          "@launchdarkly/observability is not initializing because it is not supported in this environment."
        );
        return;
      }
      if (!r) {
        console.warn(
          "@launchdarkly/observability is not initializing because the SDK credential is undefined."
        );
        return;
      }
      this.configureSession(r, n), this.observe = new Gy(N(S({}, n), {
        projectId: r,
        sessionSecureId: this.sessionSecureID
      })), n != null && n.manualStart || this.observe.start(), Ou.load(this.observe);
    } catch (i) {
      zo(
        "Error initializing @launchdarkly/observability SDK",
        "error",
        i
      );
    }
  }
  getMetadata() {
    return {
      name: "@launchdarkly/observability"
    };
  }
  register(r, n) {
    var i;
    (i = this.observe) == null || i.register(r, n);
  }
  getHooks(r) {
    var i, o, a, u;
    const n = S(S({
      [vu]: r.sdk.name,
      [_u]: r.sdk.version,
      [hu]: r.clientSideId,
      [pu]: "LaunchDarkly"
    }, (i = r.application) != null && i.id ? { [du]: r.application.id } : {}), (o = r.application) != null && o.version ? {
      [lu]: r.application.version
    } : {});
    return this.initialize(
      (u = (a = r.sdkKey) != null ? a : r.mobileKey) != null ? u : r.clientSideId,
      this.options
    ), [
      {
        getMetadata: () => ({
          name: "@launchdarkly/observability/hooks"
        }),
        afterIdentify: (c, s, f) => {
          var l, d, h, _, p, g, E, y;
          for (const A of (h = (d = (l = this.observe) == null ? void 0 : l.getHooks) == null ? void 0 : d.call(l, r)) != null ? h : [])
            (_ = A.afterIdentify) == null || _.call(A, c, s, f);
          if (f.status === "completed") {
            const A = N(S({}, ci(c.context)), {
              key: (E = (g = (p = this.options) == null ? void 0 : p.contextFriendlyName) == null ? void 0 : g.call(
                p,
                c.context
              )) != null ? E : _r(c.context),
              timeout: c.timeout,
              canonicalKey: _r(c.context),
              [Tu]: f.status
            });
            (y = this.observe) == null || y.recordLog("LD.identify", "info", S(S({}, n), A));
          }
          return s;
        },
        afterEvaluation: (c, s, f) => {
          var h, _, p, g, E;
          for (const y of (p = (_ = (h = this.observe) == null ? void 0 : h.getHooks) == null ? void 0 : _.call(h, r)) != null ? p : [])
            (g = y.afterEvaluation) == null || g.call(y, c, s, f);
          const l = S({
            [Eu]: c.flagKey,
            [uu]: JSON.stringify(f.value)
          }, f.variationIndex ? {
            [gu]: f.variationIndex
          } : {});
          if (f.reason)
            for (const y in fi) {
              const A = y, L = f.reason[A];
              L && (l[fi[A]] = L);
            }
          c.context && (l[yu] = JSON.stringify(ci(c.context)), l[mu] = _r(c.context));
          const d = S(S({}, n), l);
          return (E = this.observe) == null || E.startSpan(cu, (y) => {
            y && y.addEvent(fu, d);
          }), s;
        },
        afterTrack: (c) => {
          var s, f, l, d, h;
          for (const _ of (l = (f = (s = this.observe) == null ? void 0 : s.getHooks) == null ? void 0 : f.call(s, r)) != null ? l : [])
            (d = _.afterTrack) == null || d.call(_, c);
          (h = this.observe) == null || h.recordLog("LD.track", "info", S(N(S({}, n), {
            key: c.key,
            value: c.metricValue
          }), typeof c.data == "object" ? c.data : {}));
        }
      }
    ];
  }
}
export {
  qo as A,
  wu as C,
  y_ as D,
  Du as E,
  Yy as F,
  vy as J,
  F as M,
  Iy as N,
  Ky as O,
  Ey as P,
  Ny as W,
  Wy as X,
  Fn as a,
  Bu as b,
  ku as c,
  Xy as d,
  Ru as e,
  ry as f,
  By as g,
  dt as h,
  De as i,
  Cy as j,
  Fa as k,
  Oo as l,
  qy as m,
  Ho as n,
  er as p,
  Yo as r,
  ay as s
};
//# sourceMappingURL=observe-B62tYYWD.js.map
